import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Breadcrumb,
  Tab,
  Nav,
  Form,
  Modal,
  Accordion,
  FormControl,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import Swal from 'sweetalert2';
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import { firestore as db } from "../config/Config";
import { useLocation } from "react-router-dom";
import { Collapse } from "bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { fetchKitchenList } from "../redux/kitchenReducer";
import { useNavigate } from "react-router-dom";
import { auth } from "../config/Config";
import { createRooms } from "../redux/addRoomReducer";
import Sidebar from "./SidebarNav";
import { InputLabel, NativeSelect } from "@mui/material";


export default function AddRooms({ clientDataFor }) {

  const extraName = {
    'Matte Laminate': ['Matte', 'HG (High Gloss)', 'MR+', 'Fluted Digital'],
    'High Gloss Laminate': ['Matte', 'HG (High Gloss)', 'Fluted Digital'],
    'PU': ['Matte', 'Satin', 'HG (High Gloss)'],
    'Veneer': ['Matte', 'Glossy'],
    'Aluminium Shutters': ['Laminate', 'Acrylic', 'PU', 'Veneer'],
    'Glass with Ply Frame': [
      'Plain or Tinted with Laminate Carcass',
      'Clear or Tinted Fluted with Laminate Carcass',
      'Plain or Tinted with Acrylic Carcass',
      'Clear or Tinted Fluted with Acrylic Carcass',
      'Plain or Tinted with PU Carcass',
      'Clear or Tinted Fluted with PU Carcass',
      'Plain or Tinted with Veneer Carcass',
      'Clear or Tinted Fluted with Veneer Carcass'
    ],
    // 'L Shape': ['Standard', 'Premium', 'Luxury']
  };

  const [hoveredItem, setHoveredItem] = useState(null);
  const [isSaving, setIsSaving] = useState(false);


  const userDetailsLocal = localStorage.getItem('userDetails');
  const userDetailsLo = JSON.parse(userDetailsLocal);
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const data = location.state;

  console.log("clients data", data);

  const { userData, userLoader, userError } = useSelector((state) => state.viewusers);

  // useEffect(() => {
  //   dispatch(fetchKitchenList());
  // }, []);

  // const { looseThingsData } = useSelector(
  //   (state) => state.looseThings
  // );

  // console.log("sdfsdf", kitchenThingsData);


  // Room Draft Support
  const restored = data?.restoreDraft;
  const draftIdRef = React.useRef(restored?.id || `room_draft_${Date.now()}`);
  const [draftSaveStatus, setDraftSaveStatus] = useState(restored ? 'Draft Restored' : '');
  const isDraftCleanedUpRef = React.useRef(false);
  const [isDiscarding, setIsDiscarding] = useState(false);
  const saveDraftOnExitRef = React.useRef(null);
  const latestDraftPayloadRef = React.useRef(null);

  // Room Type 
  const [roomType, setRoomType] = useState(restored?.roomType || data?.['roomType'] || '');
  const [roomTypeName, setRoomTypeName] = useState(restored?.roomTypeName || data?.['roomName'] || '');
  const [roomTypeDesign, setRoomTypeDesign] = useState(restored?.roomTypeDesign || '');
  const [roomTypeDescription, setRoomTypeDescription] = useState(restored?.roomTypeDescription || '');
  const [roomTypeModal, setRoomTypeModal] = useState(restored?.roomTypeModal || '');
  const [roomTypePrice, setRoomTypePrice] = useState(restored?.roomTypePrice || 0);
  const [roomTypeWoodPrice, setRoomTypeWoodPrice] = useState(restored?.roomTypeWoodPrice || 0);




  const [defkey, setDefkey] = useState('room');

  const handleRoomTypeCancel = () => {
    // Save current draft state on exit
    if (saveDraftOnExitRef.current) {
      saveDraftOnExitRef.current();
    }

    if (data?.path === 'assigneRooms') {
      navigation("/assigned/view-rooms", { state: data });
    } else {
      navigation("/projects/view-rooms", { state: data });
    }
  }

  const handleRoomTypeSubmit = (e) => {
    e.preventDefault();
    const roomData = [{ 'roomType': roomType }, { 'roomTypeName': roomTypeName }, { 'roomTypeDesign': roomTypeDesign }, { 'roomTypeDescription': roomTypeDescription }];
    localStorage.setItem("roomTypeData", JSON.stringify(roomData));

  }

  // Base cabinet modal things & all

  const [addShow, setAddShow] = useState(false);
  const [roomData, setRoomData] = useState([]);


  // Material things

  const [kitchenBaseGrandTotal, setKitchenBaseGrandTotal] = useState(0);

  const [materialType, setMaterialType] = useState("");
  const [materialLabel, setMaterialLabel] = useState(0);
  const [materialValue, setMaterialValue] = useState(0);
  const [modalTitle, setModalTitle] = useState("");
  const [modalUrl, setModalUrl] = useState("");
  const [materialWidth, setMaterialWidth] = useState(0);
  const [materialHeight, setMaterialHeight] = useState(0);
  // const [materialDepth, setMaterialDepth] = useState(2);
  const [materialQuantity, setMaterialQuantity] = useState(0);
  const [materialPrice, setMaterialPrice] = useState(0);
  const handleFistItem = (name) => {
    setModalTitle(name.label);
    setModalUrl(name.url);
  };
  const handleCalculation = (e) => {
    setMaterialPrice(
      materialType * materialWidth * materialHeight * materialQuantity
    );
  };




  const handleLogOut = () => {
    auth.signOut();
    // navigation('/login');
  }

  // writting code for dynamic fields of inputs

  const [selectedItems, setSelectedItems] = useState([]);

  const handleQuantityChange = (itemId, newQuantity) => {
    const updatedItems = selectedItems.map((item) => {
      if (item.id === itemId) {
        return {
          ...item,
          selectedQuantity: newQuantity,
        };
      }
      return item;
    });

    setSelectedItems(updatedItems);
  };



  // Save Room types and naem

  const handleSaveNameType = () => {
    const cleanText = (text) => (text || "").trim().replace(/\s+/g, " ");

    const url =
      data.path === "assigneRooms"
        ? `https://us-central1-fabdiz-quote.cloudfunctions.net/api/add-assigne-rooms/${data.AssignedclientID}`
        : `https://us-central1-fabdiz-quote.cloudfunctions.net/api/project-rooms/${data.id}`;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        title: "",
        fields: "",
        roomType: cleanText(roomType),
        roomTypeName: cleanText(roomTypeName),
        roomTypeDesign: cleanText(roomTypeDesign),
        roomTypeDescription: cleanText(roomTypeDescription),
        roomTypePrice: 0,
        priceMode: priceGen,
        roomTypeWoodPrice: 0,
        userId: data.ID,
      }),
    })
      .then((response) => response.json())
      .then(async () => {
        setRoomTypeWoodPrice(0);
        await cleanupDraft();

        if (data.path === "assigneRooms") {
          navigation("/assigned/view-rooms", { state: data });
        } else {
          navigation("/projects/view-rooms", { state: data });
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  // const handleSaveNameType = () => {
    // alert('everything');
    // dispatch(createRooms(roomDatas));
    // navigation("/projects/view-rooms", { state: data });
    // const url = data.path === 'assigneRooms'
      // ? `https://us-central1-fabdiz-quote.cloudfunctions.net/api/add-assigne-rooms/${data.AssignedclientID}`
      // : `https://us-central1-fabdiz-quote.cloudfunctions.net/api/project-rooms/${data.id}`;

    // fetch(url, {
      // method: 'POST',
      // headers: {
        // 'Content-Type': 'application/json',
      // },
      // body: JSON.stringify({
        // title: '',
        // fields: '',
        // roomType: roomType,
        // roomTypeName: roomTypeName,
        // roomTypeDesign: roomTypeDesign,
        // roomTypeDescription: roomTypeDescription,
        // roomTypePrice: 0,
        // priceMode: priceGen,
        // roomTypeWoodPrice: 0,
        // userId: data.ID,
      // }),
    // })
      // .then(response => response.json())
      // .then(() => {
        // setRoomTypeWoodPrice(0);
        // if (data.path === 'assigneRooms') {
          // navigation("/assigned/view-rooms", { state: data });
        // } else {

          // navigation("/projects/view-rooms", { state: data });
        // }
      // }
      // )
      // .catch((error) => console.error('Error:', error));
  // }

  // Save Everything Calculation & Headings

  const handleSaveEverything = () => {
    // alert('everything');

    const roomDatas = {

      // title : [{'accordin' : [modalTitle, modalUrl, kitchenBaseGrandTotal]},{'material' : [materialType, materialWidth, materialHeight, materialQuantity, materialPrice]},{'baseHandleType' : [accessoriesBaseHandleType, accessoriesBaseHandleQuantity, accessoriesBaseHandlePrice]},{'thaliBasket' : [accessoriesThaliBasketType, accessoriesThaliBasketQuantity, accessoriesThaliBasketPrice]},{'thaliInlet' : [accessoriesThaliInletType, accessoriesThaliInletQuantity, accessoriesThaliInletPrice]},{'dustbinBasic' : [accessoriesDustbinBasicType, accessoriesDustbinBasicQuantity, accessoriesDustbinBasicPrice]},{'wickerBasket' : [accessoriesWickerBasketBasicType, accessoriesWickerBasketBasicQuantity, accessoriesWickerBasketBasicPrice]},{'detergentHolder' : [accessoriesDetergentHolderBasicType, accessoriesDetergentHolderBasicQuantity, accessoriesDetergentHolderBasicPrice]}],
      title: roomData,
      roomType: roomType,
      roomTypeName: roomTypeName,
      roomTypeDesign: roomTypeDesign,
      roomTypeDescription: roomTypeDescription,
      roomTypePrice: kitchenBaseGrandTotal,
      id: data.ID,
    };


    dispatch(createRooms(roomDatas));
    navigation("/projects/view-rooms", { state: data });
  }

  // dynamic form fields and data

  const [dynamicData, setDynamicData] = useState([{ fname: "", lname: "" }]);

  const handleAddClick = () => {
    setDynamicData([...dynamicData, { fname: "", lname: "" }])
  }

  const handleAddChange = (e, i) => {
    const { name, value } = e.target;
    const onchangeVal = [...dynamicData];
    onchangeVal[i][name] = value;
    setDynamicData(onchangeVal);
  }






  // dynamic for kitchen furniture
  const { kitchenThingsData } = useSelector((state) => state.kitchenThings);
  // console.log("kitchenThingsData", kitchenThingsData);


  // dynamic for extra items in every room
  const [extraItemMeasure, setExtraItemMeasure] = useState('');
  const [extraItemName, setExtraItemName] = useState('');
  const [extraItemMaterialName, setExtraItemMaterialName] = useState('');
  const [extraItemMaterialValue, setExtraItemMaterialValue] = useState(0);
  const [isChecked, setIsChecked] = useState(false);
  const [extraItemType, setExtraItemType] = useState('');

  const [kitchenThingsDataCopy, setKitchenThingsDataCopy] = useState(
    restored?.kitchenThingsDataCopy && restored.kitchenThingsDataCopy.length > 0
      ? restored.kitchenThingsDataCopy
      : [...kitchenThingsData]
  );
  console.log("kitchenFormData 1", kitchenThingsDataCopy);


  const [kitchenFormData, setKitchenFormData] = useState(
    restored?.kitchenFormData && restored.kitchenFormData.length > 0
      ? restored.kitchenFormData
      : (restored?.kitchenThingsDataCopy || kitchenThingsDataCopy).map((item) => ({
          name: item.name,
          label: "",
          value: 0,
          valueIncresed: 0,
          width: "",
          height: "",
          qnty: "",
          rft: "",
          area: "",
          price: 0,
          remark: "",
          type: item.type,
        }))
  );

  console.log("kitchenFormData", kitchenFormData);
  const handleCheckboxChange = (event) => {
    // console.log("ppp", event);

    setIsChecked(event.target.checked);
    // console.log("ppp", event.target.checked);
    setExtraItemType(event.target.checked ? 'woodwork' : '');
  };

  // Function to add a new kitchen item
  const addNewKitchenItem = () => {

    const nameExists = kitchenFormData.some((item) => item.name.toLowerCase() === extraItemName.trim().toLowerCase());
    if (nameExists) {
      Swal.fire({
        icon: "warning",
        title: "Duplicate Item Name",
        text: `An item named "${extraItemName}" already exists!`,
        confirmButtonColor: "#d33",
      });
      return;
    }

    if (!extraItemName.trim()) {
      Swal.fire({
        icon: "error",
        title: "Item Name Required",
        text: "Please enter an item name before adding.",
      });
      return;
    }

    const newKitchenItem = {
      name: extraItemName,
      measurement: extraItemMeasure,
      material: [{ label: extraItemMaterialName, value: extraItemMaterialValue, oldvalue: extraItemMaterialValue }],
      type: extraItemType,
      isUserAdded: true,
    };

    setKitchenThingsDataCopy((prevData) => {
      const updatedData = [...prevData, newKitchenItem];
      return updatedData;
    });

    setKitchenFormData((prevData) => [
      ...prevData,
      {
        name: extraItemName,
        label: "",
        value: 0,
        valueIncresed: 0,
        width: "",
        height: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: extraItemType,
        isUserAdded: true,
      },
    ]);

    setExtraItemMeasure('');
    setExtraItemName('');
    setExtraItemMaterialName('');
    setExtraItemMaterialValue(0);
    setExtraItemType('');
    setIsChecked(false)
  };

  // Function to handle changes to the kitchen form fields
  const handleKitchenChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value) || 0;
    const updatedKitchenFormData = [...kitchenFormData];
    const item = { ...updatedKitchenFormData[index] };
    console.log("eee", newValue);

    const incrementPercentage = data['increment'] / 100;

    // Update the price based on the measurement type
    if (kitchenThingsDataCopy[index].measurement === "area") {
      item[field] = newValue;
      item.price = item.type === "woodwork"
        ? Math.round(item.value * newValue * (1 + incrementPercentage))
        : Math.round(item.value * newValue);
    } else if (kitchenThingsDataCopy[index].measurement === "width") {
      item[field] = newValue;
      item.price = item.type === "woodwork"
        ? Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage))
        : Math.round(item.value * item.width * item.height * item.qnty);
    } else if (kitchenThingsDataCopy[index].measurement === "qty") {
      item[field] = newValue;
      item.price = item.type === "woodwork"
        ? Math.round(item.value * newValue * (1 + incrementPercentage))
        : Math.round(item.value * newValue);
    } else if (kitchenThingsDataCopy[index].measurement === "length") {
      item[field] = newValue;
      item.price = item.type === "woodwork"
        ? Math.round(item.value * item.height * item.width * (1 + incrementPercentage))
        : Math.round(item.value * item.height * item.width);
    } else if (kitchenThingsDataCopy[index].measurement === "rft") {
      item[field] = newValue;
      item.price = item.type === "woodwork"
        ? Math.round(item.value * newValue * (1 + incrementPercentage))
        : Math.round(item.value * newValue);
    }

    // Update state
    updatedKitchenFormData[index] = item;

    setKitchenFormData(updatedKitchenFormData);
  };

  // Function to handle price change
  const handleKitchenPriceChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    const updatedKitchenFormData = [...kitchenFormData];
    const item = { ...updatedKitchenFormData[index] };
    item[field] = newValue;

    updatedKitchenFormData[index] = item;
    setKitchenFormData(updatedKitchenFormData);
  };

  // Function to handle remark change
  const handleKitchenRemarkChange = (e, index, field) => {
    const newValue = e.target.value;
    const updatedKitchenFormData = [...kitchenFormData];
    const item = { ...updatedKitchenFormData[index] };
    item[field] = newValue;

    updatedKitchenFormData[index] = item;
    setKitchenFormData(updatedKitchenFormData);
  };

  // Function to handle option change
  const handleKitchenOptionChange = (e, index) => {
    const value = Number(e.target.value) || 0;
    // const subValue = Number(e.target.subValue) || 0;
    const selectedLabel = e.target.label || "";

    // const totalValue = value + subValue;
    const totalValue = value;
    const incrementPercentage = Number(data?.increment || 0) / 100;

    setKitchenFormData((prevData) => {
      const newData = [...prevData];
      const item = { ...newData[index] };
      item.value = value;
      // item.subValue = subValue;
      item.label = selectedLabel;
      item.valueIncresed = Math.round(
        totalValue * (1 + incrementPercentage)
      );

      const isWoodwork = item.type === "woodwork";
      const multiplier = isWoodwork
        ? (1 + incrementPercentage)
        : 1;

      const measurement = kitchenThingsDataCopy[index].measurement;

      switch (measurement) {
        case "area":
          item.price = Math.round(
            totalValue * (item.area || 0) * multiplier
          );
          break;

        case "width":
          item.price = Math.round(
            totalValue *
            (item.width || 0) *
            (item.height || 0) *
            (item.qnty || 0) *
            multiplier
          );
          break;

        case "qty":
          item.price = Math.round(
            totalValue * (item.qnty || 0) * multiplier
          );
          break;

        case "length":
          item.price = Math.round(
            totalValue *
            (item.height || 0) *
            (item.width || 0) *
            multiplier
          );
          break;

        case "rft":
          item.price = Math.round(
            totalValue * (item.rft || 0) * multiplier
          );
          break;

        default:
          item.price = 0;
      }

      newData[index] = item;
      console.log(newData);

      return newData;
    });
  };

  // Recalculate total prices whenever kitchenFormData changes
  useEffect(() => {
    // Calculate total price safely, ensuring item.price is a valid number
    const totalPrice = kitchenFormData.reduce((total, item) => {
      const price = parseFloat(item.price) || 0;  // Ensure valid number
      return total + price;
    }, 0);
    setRoomTypePrice(totalPrice);

    // Calculate total woodwork price safely
    const totalWoodworkPrice = kitchenFormData.reduce((total, item) => {
      if (item.type === 'woodwork') {
        const price = parseFloat(item.price) || 0;  // Ensure valid number
        return total + price;
      }
      return total;
    }, 0);
    setRoomTypeWoodPrice(totalWoodworkPrice);
  }, [kitchenFormData]);  // Depend on kitchenFormData


  // Function to save kitchen data
  const saveKitchenData = async () => {
    if (isSaving) return;
    setIsSaving(true);

    // Recalculate prices
    const updatedKitchenFormData = kitchenFormData.map(item => {
      const incrementPercentage = data['increment'] / 100;
      let newPrice = 0;

      if (item.type === "woodwork") {
        if (item.area) {
          newPrice = Math.round(item.value * item.area * (1 + incrementPercentage));
        } else if (item.width && item.height && item.qnty) {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else if (item.qnty) {
          newPrice = Math.round(item.value * item.qnty * (1 + incrementPercentage));
        } else if (item.height && item.width) {
          newPrice = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
        } else if (item.rft) {
          newPrice = Math.round(item.value * item.rft * (1 + incrementPercentage));
        }
      } else {
        if (item.area) {
          newPrice = Math.round(item.value * item.area);
        } else if (item.width && item.height && item.qnty) {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty);
        } else if (item.qnty) {
          newPrice = Math.round(item.value * item.qnty);
        } else if (item.height && item.width) {
          newPrice = Math.round(item.value * item.height * item.width);
        } else if (item.rft) {
          newPrice = Math.round(item.value * item.rft);
        }
      }

      return { ...item, price: newPrice };
    });
    // Recalculate total prices
    const newRoomTypePrice = updatedKitchenFormData.reduce((total, item) => total + item.price, 0);

    const newRoomTypeWoodPrice = updatedKitchenFormData.reduce((total, item) =>
      item.type === "woodwork" ? total + item.price : total, 0);
     const cleanText = (text) => (text || "").trim().replace(/\s+/g, " ");

    const url = data.path === 'assigneRooms'
      ? `https://us-central1-fabdiz-quote.cloudfunctions.net/api/add-assigne-rooms/${data.id}`
      : `https://us-central1-fabdiz-quote.cloudfunctions.net/api/project-rooms/${data.id}`;

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          title: kitchenFormData,
          title2: materialFields,
          fields: kitchenThingsDataCopy,
          roomType: cleanText(roomType),
          roomTypeName: cleanText(roomTypeName),
          roomTypeDesign: cleanText(roomTypeDesign),
          roomTypeDescription: cleanText(roomTypeDescription),
          roomTypePrice: newRoomTypePrice,
          roomTypeWoodPrice: newRoomTypeWoodPrice,
          priceMode: priceGen,
          roomTypePrice2: materialFieldsTotal,
          userId: data.ID,
        }),
      });

      if (response.ok) {
        setRoomTypeWoodPrice(0);
        await cleanupDraft();
        if (data.path === 'assigneRooms') {
          navigation("/assigned/view-rooms", { state: data });
        } else {
          navigation("/projects/view-rooms", { state: data });
        }
      } else {
        setIsSaving(false);
      }
    } catch (error) {
      console.error('Error:', error);
      setIsSaving(false);
    }
  };


  const deleteUserAddedKitchenItem = (index) => {
    // Only delete if the item is user-added
    if (kitchenThingsDataCopy[index].isUserAdded) {
      const updatedKitchenThingsDataCopy = [...kitchenThingsDataCopy];
      const updatedKitchenFormData = [...kitchenFormData];

      // Remove the item from the list and the form data
      updatedKitchenThingsDataCopy.splice(index, 1);
      updatedKitchenFormData.splice(index, 1);

      // Update the state
      setKitchenThingsDataCopy(updatedKitchenThingsDataCopy);
      setKitchenFormData(updatedKitchenFormData);
    }
  };




  // dynamic for Bedroom furniture 



  const { bedroomThingsData } = useSelector(
    (state) => state.bedroomThings
  );

  const [bedroomThingsDataCopy, setBedroomThingsDataCopy] = useState(
    restored?.bedroomThingsDataCopy && restored.bedroomThingsDataCopy.length > 0
      ? restored.bedroomThingsDataCopy
      : bedroomThingsData
  );
  console.log("bedroomFormData 2", bedroomThingsDataCopy);
  console.log("bedroomFormData 1", bedroomThingsData);



  const [bedroomFormData, setBedroomFormData] = useState(
    restored?.bedroomFormData && restored.bedroomFormData.length > 0
      ? restored.bedroomFormData
      : (restored?.bedroomThingsDataCopy || bedroomThingsDataCopy).map((item) => ({
          name: item.name,
          label: "",
          value: 0,
          valueIncresed: 0,
          label2: "",
          value2: 0,
          valueIncresed2: 0,
          width: "",
          height: "",
          depth: "",
          qnty: "",
          rft: "",
          area: "",
          price: 0,
          remark: "",
          type: item.type,
        }))
  );
  // console.log("bedroomFormData", bedroomFormData);
  const OriginalPriceType = data.priceType

  // Update bedroomFormData when OriginalPriceType changes
  const addNewBedroomItem = () => {


    const nameExists = bedroomFormData.some((item) => item.name.toLowerCase() === extraItemName.trim().toLowerCase());
    if (nameExists) {
      Swal.fire({
        icon: "warning",
        title: "Duplicate Item Name",
        text: `An item named "${extraItemName}" already exists!`,
        confirmButtonColor: "#d33",
      });
      return;
    }

    if (!extraItemName.trim()) {
      Swal.fire({
        icon: "error",
        title: "Item Name Required",
        text: "Please enter an item name before adding.",
      });
      return;
    }


    setBedroomThingsDataCopy([
      ...bedroomThingsDataCopy,
      {
        name: extraItemName,
        measurement: extraItemMeasure,
        material: [{ label: extraItemMaterialName, value: extraItemMaterialValue, oldvalue: extraItemMaterialValue }],
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    // console.log("data for copy kicthen data", bedroomThingsDataCopy);
    setBedroomFormData([
      ...bedroomFormData,
      {
        name: extraItemName,
        label: "",
        value: 0,
        valueIncresed: 0,
        label2: "",
        value2: 0,
        valueIncresed2: 0,
        width: "",
        height: "",
        depth: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    setExtraItemMeasure('');
    setExtraItemName('');
    setExtraItemMaterialName('');
    setExtraItemMaterialValue(0);
    setExtraItemType('');
    setIsChecked(false)
    // console.log("Kitchen Nwe data",kitchenFormData);
  };


  const handleBedroomChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value) || 0;
    console.log("eee", newValue);
    // console.log('pppp',newValue);

    // const newValue = e.target.value;
    const updatedBedroomFormData = [...bedroomFormData];
    const item = updatedBedroomFormData[index];


    const incrementPercentage = data['increment'] / 100;

    if (bedroomThingsDataCopy[index].measurement === "area") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue) || 0;
      }
    } else if (bedroomThingsDataCopy[index].measurement === "width") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * item.width * item.height * item.qnty);
      }
    } else if (bedroomThingsDataCopy[index].measurement === "qty") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    } else if (bedroomThingsDataCopy[index].measurement === "length") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * item.height * item.width);
      }
    } else if (bedroomThingsDataCopy[index].measurement === "depth") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)) * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));
      }
    } else if (bedroomThingsDataCopy[index].measurement === "rft") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    } else if (bedroomThingsDataCopy[index].measurement === "door") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(((item.value * item.width * item.height * item.qnty) + parseFloat(item.value2)) * (1 + incrementPercentage));
      } else {
        item.price = Math.round(((item.value * item.width * item.height * item.qnty) + parseFloat(item.value2)));
      }
    }


    //roomTypePrice
    // Update the state with the modified data
    updatedBedroomFormData[index] = item;
    setBedroomFormData(updatedBedroomFormData);
    // console.log("price checking", bedroomFormData);
  };


  const handleBedroomRemarkChange = (e, index, field) => {
    // const newValue = parseFloat(e.target.value);
    const newValue = e.target.value;
    const updatedBedroomFormData = [...bedroomFormData];
    const item = updatedBedroomFormData[index];


    item[field] = newValue;

    // Update the state with the modified data
    updatedBedroomFormData[index] = item;
    setBedroomFormData(updatedBedroomFormData);
    // console.log("price checking", bedroomFormData);
  };



  const handleBedroomOptionChange = (e, index) => {
    const value = e.target.value || 0;
    // const selectedLabel = e.target.options[e.target.selectedIndex].text;
    const selectedLabel = e.target.label;
    const incrementPercentage = data['increment'] / 100;
    console.log("eee", value);


    // console.log("incrementPercentage",value);


    setBedroomFormData((prevData) => {
      const newData = [...prevData]; newData[index]['value'] = value;
      newData[index]['valueIncresed'] = Math.round(value * (1 + incrementPercentage));

      newData[index]['label'] = selectedLabel;

      // Recalculate the price based on the selected value
      const item = newData[index];
      if (bedroomThingsDataCopy[index].measurement === "area") {
        if (item.type === "woodwork") {
          item.price = Math.round(value * item.area * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.area);
        }
      } else if (bedroomThingsDataCopy[index].measurement === "width") {
        if (item.type === "woodwork") {
          item.price = Math.round(value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.width * item.height * item.qnty);
        }
      } else if (bedroomThingsDataCopy[index].measurement === "qty") {
        if (item.type === "woodwork") {
          item.price = Math.round(value * item.qnty * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.qnty);
        }
      } else if (bedroomThingsDataCopy[index].measurement === "length") {
        if (item.type === "woodwork") {
          item.price = Math.round(value * item.height * item.width * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.height * item.width);
        }
      } else if (bedroomThingsDataCopy[index].measurement === "depth") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)) * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));

        }
      } else if (bedroomThingsDataCopy[index].measurement === "rft") {
        if (item.type === "woodwork") {
          item.price = Math.round(value * item.rft * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.rft);
        }
      } else if (bedroomThingsDataCopy[index].measurement === "door") {
        if (item.type === "woodwork") {
          item.price = Math.round(((value * item.width * item.height * item.qnty) + parseFloat(item.value2)) * (1 + incrementPercentage));
        } else {
          item.price = Math.round(((value * item.width * item.height * item.qnty) + parseFloat(item.value2)));
        }
      }


      return newData;
    });
  };


  const handleBedroomOption2Change = (e, index) => {
    const value = e.target.value;
    const selectedLabel = e.target.options[e.target.selectedIndex].text;
    const incrementPercentage = data['increment'] / 100;

    setBedroomFormData((prevData) => {
      const newData = [...prevData];
      newData[index]['value2'] = value;
      newData[index]['valueIncresed2'] = Math.round(value * (1 + incrementPercentage));

      newData[index]['label2'] = selectedLabel;

      // Recalculate the price based on the selected value
      const item = newData[index];
      if (bedroomThingsDataCopy[index].measurement === "door") {
        // Parse value as a floating-point number (assuming it's a decimal number)
        const valueAsNumber = parseFloat(value);
        if (!isNaN(valueAsNumber)) {
          item.price = Math.round(((item.value * item.width * item.height * item.qnty) + valueAsNumber) * (1 + incrementPercentage));
        }
      }


      return newData;
    });
  };


  // to calculate Total Price
  useEffect(() => {
    // Calculate total price
    const totalPrice = bedroomFormData.reduce((total, item) => {
      return total + (parseFloat(item.price) || 0);
    }, 0);

    // Update roomTypeWoodPrice
    setRoomTypePrice(totalPrice);
    // console.log(roomTypePrice);

  }, [bedroomFormData]);



  useEffect(() => {
    // Calculate total woodwork price
    const totalWoodworkPrice = bedroomFormData.reduce((total, item) => {
      if (item.type === "woodwork") {
        return total + item.price;
      }
      return total;
    }, 0);

    // Update roomTypeWoodPrice
    setRoomTypeWoodPrice(totalWoodworkPrice);
  }, [bedroomFormData]);


  const calculateTotalPricesBeforeSave = () => {
    // Calculate total price safely
    const totalPrice = bedroomFormData.reduce((total, item) => {
      const price = parseFloat(item.price) || 0; // Ensure price is a valid number
      return total + price;
    }, 0);

    setRoomTypePrice(totalPrice);

    // Calculate total woodwork price safely
    const totalWoodworkPrice = bedroomFormData.reduce((total, item) => {
      const price = parseFloat(item.price) || 0; // Ensure price is valid
      if (item.type === "woodwork") {
        return total + price;
      }
      return total;
    }, 0);

    setRoomTypeWoodPrice(totalWoodworkPrice);

    saveBedroomData();
  };



  const saveBedroomData = async () => {


    const incrementPercentage = data['increment'] / 100;

    // Recalculate prices
    const updatedBedroomFormData = bedroomFormData.map((item, index) => {
      let newPrice = 0;

      if (bedroomThingsDataCopy[index].measurement === "area") {
        if (item.type === "woodwork") {
          newPrice = Math.round(item.value * item.area * (1 + incrementPercentage));
        } else {
          newPrice = Math.round(item.value * item.area);
        }
      } else if (bedroomThingsDataCopy[index].measurement === "width") {
        if (item.type === "woodwork") {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty);
        }
      } else if (bedroomThingsDataCopy[index].measurement === "qty") {
        if (item.type === "woodwork") {
          newPrice = Math.round(item.value * item.qnty * (1 + incrementPercentage));
        } else {
          newPrice = Math.round(item.value * item.qnty);
        }
      } else if (bedroomThingsDataCopy[index].measurement === "length") {
        if (item.type === "woodwork") {
          newPrice = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
        } else {
          newPrice = Math.round(item.value * item.height * item.width);
        }
      } else if (bedroomThingsDataCopy[index].measurement === "depth") {

        if (item.type === "woodwork") {
          newPrice = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)) * (1 + incrementPercentage));
        } else {
          newPrice = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));

        }
      } else if (bedroomThingsDataCopy[index].measurement === "rft") {
        if (item.type === "woodwork") {
          newPrice = Math.round(item.value * item.rft * (1 + incrementPercentage));
        } else {
          newPrice = Math.round(item.value * item.rft);
        }
      } else if (bedroomThingsDataCopy[index].measurement === "door") {
        if (item.type === "woodwork") {
          newPrice = Math.round(((item.value * item.width * item.height * item.qnty) + parseFloat(item.value2)) * (1 + incrementPercentage));
        } else {
          newPrice = Math.round(((item.value * item.width * item.height * item.qnty) + parseFloat(item.value2)));
        }
      }

      return { ...item, price: newPrice };
    });

    // Recalculate total prices
    const newRoomTypePrice = updatedBedroomFormData.reduce((total, item) => total + item.price, 0);
    const newRoomTypeWoodPrice = updatedBedroomFormData.reduce((total, item) =>
      item.type === "woodwork" ? total + item.price : total, 0);
     const cleanText = (text) => (text || "").trim().replace(/\s+/g, " ");



    const url = data.path === 'assigneRooms'
      ? `https://us-central1-fabdiz-quote.cloudfunctions.net/api/add-assigne-rooms/${data.AssignedclientID}`
      : `https://us-central1-fabdiz-quote.cloudfunctions.net/api/project-rooms/${data.id}`;

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: bedroomFormData,
        fields: bedroomThingsDataCopy,
        roomType: cleanText(roomType),
        roomTypeName: cleanText(roomTypeName),
        roomTypeDesign:  cleanText(roomTypeDesign),
        roomTypeDescription:  cleanText(roomTypeDescription),
        roomTypePrice: newRoomTypePrice,
        priceMode: priceGen,
        roomTypeWoodPrice: newRoomTypeWoodPrice,
        userId: data.ID,
      }),
    })
      .then(response => response.json())
      .then(async () => {
        setRoomTypeWoodPrice(0);
        await cleanupDraft();
        if (data.path === 'assigneRooms') {
          navigation("/assigned/view-rooms", { state: data });
        } else {

          navigation("/projects/view-rooms", { state: data });
        }
      }
      )
      .catch((error) => console.error('Error:', error));
  }


  const deleteUserAddedBedroomItem = (index) => {
    // Only delete if the item is user-added
    if (bedroomThingsDataCopy[index].isUserAdded) {
      const updatedKitchenThingsDataCopy = [...bedroomThingsDataCopy];
      const updatedKitchenFormData = [...bedroomFormData];

      // Remove the item from the list and the form data
      updatedKitchenThingsDataCopy.splice(index, 1);
      updatedKitchenFormData.splice(index, 1);

      // Update the state
      setBedroomThingsDataCopy(updatedKitchenThingsDataCopy);
      setBedroomFormData(updatedKitchenFormData);
    }
  };

  // dynamic for foyer furniture 

  const { foyerThingsData } = useSelector(
    (state) => state.foyerThings
  );

  const [foyerThingsDataCopy, setFoyerThingsDataCopy] = useState(
    restored?.foyerThingsDataCopy && restored.foyerThingsDataCopy.length > 0
      ? restored.foyerThingsDataCopy
      : foyerThingsData
  );
  // console.log("foyerThingsDataCopy", foyerThingsDataCopy);

  const [foyerFormData, setFoyerFormData] = useState(
    restored?.foyerFormData && restored.foyerFormData.length > 0
      ? restored.foyerFormData
      : (restored?.foyerThingsDataCopy || foyerThingsDataCopy).map((item) => ({
          name: item.name,
          label: "",
          value: 0,
          valueIncresed: 0,
          width: "",
          height: "",
          depth: "",
          qnty: "",
          rft: "",
          area: "",
          price: 0,
          remark: "",
          type: item.type,
        }))
  );
  // console.log("foyerFormData", foyerFormData);

  const addNewFoyerItem = () => {


    const nameExists = foyerFormData.some((item) => item.name.toLowerCase() === extraItemName.trim().toLowerCase());
    if (nameExists) {
      Swal.fire({
        icon: "warning",
        title: "Duplicate Item Name",
        text: `An item named "${extraItemName}" already exists!`,
        confirmButtonColor: "#d33",
      });
      return;
    }

    if (!extraItemName.trim()) {
      Swal.fire({
        icon: "error",
        title: "Item Name Required",
        text: "Please enter an item name before adding.",
      });
      return;
    }


    setFoyerThingsDataCopy([
      ...foyerThingsDataCopy,
      {
        name: extraItemName,
        measurement: extraItemMeasure,
        material: [{ label: extraItemMaterialName, value: extraItemMaterialValue, oldvalue: extraItemMaterialValue }],
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    // console.log("data for copy kicthen data",kitchenThingsDataCopy);

    setFoyerFormData([
      ...foyerFormData,
      {
        name: extraItemName,
        label: "",
        value: 0,
        valueIncresed: 0,
        width: "",
        height: "",
        depth: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    setExtraItemMeasure('');
    setExtraItemName('');
    setExtraItemMaterialName('');
    setExtraItemMaterialValue(0);
    setExtraItemType('');
    setIsChecked(false)
    // console.log("Kitchen Nwe data",kitchenFormData);
  };



  const handleFoyerChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value) || 0;
    // const newValue = e.target.value;
    const updatedFoyerFormData = [...foyerFormData];
    const item = updatedFoyerFormData[index];
    const incrementPercentage = data['increment'] / 100;

    if (foyerThingsDataCopy[index].measurement === "area") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    } else if (foyerThingsDataCopy[index].measurement === "width") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * item.width * item.height * item.qnty);
      }
    } else if (foyerThingsDataCopy[index].measurement === "qty") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    } else if (foyerThingsDataCopy[index].measurement === "length") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * item.height * item.width);
      }
    } else if (foyerThingsDataCopy[index].measurement === "depth") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)) * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));

      }
    } else if (foyerThingsDataCopy[index].measurement === "rft") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    }

    // Update the state with the modified data
    updatedFoyerFormData[index] = item;
    setFoyerFormData(updatedFoyerFormData);
    // console.log("price checking", foyerFormData);
  };


  const handleFoyerPriceChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedFoyerFormData = [...foyerFormData];
    const item = updatedFoyerFormData[index];

    item[field] = newValue;


    // Update the state with the modified data
    updatedFoyerFormData[index] = item;
    setFoyerFormData(updatedFoyerFormData);
    // console.log("price checking", foyerFormData);
  };




  const handleFoyerRemarkChange = (e, index, field) => {
    // const newValue = parseFloat(e.target.value);
    const newValue = e.target.value;
    const updatedFoyerFormData = [...foyerFormData];
    const item = updatedFoyerFormData[index];

    item[field] = newValue;


    // Update the state with the modified data
    updatedFoyerFormData[index] = item;
    setFoyerFormData(updatedFoyerFormData);
    // console.log("price checking", foyerFormData);
  };



  const handleFoyerOptionChange = (e, index) => {
    const value = e.target.value || 0;
    // const selectedLabel = e.target.options[e.target.selectedIndex].text;
    const selectedLabel = e.target.label;
    const incrementPercentage = data['increment'] / 100;

    setFoyerFormData((prevData) => {
      const newData = [...prevData];
      newData[index]['value'] = value;
      newData[index]['valueIncresed'] = Math.round(value * (1 + incrementPercentage));
      newData[index]['label'] = selectedLabel;

      // Recalculate the price based on the selected value
      const item = newData[index];
      if (foyerThingsDataCopy[index].measurement === "area") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.area * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.area);
        }
      } else if (foyerThingsDataCopy[index].measurement === "width") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.width * item.height * item.qnty);
        }
      } else if (foyerThingsDataCopy[index].measurement === "qty") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.qnty * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.qnty);
        }
      } else if (foyerThingsDataCopy[index].measurement === "length") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.height * item.width * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.height * item.width);
        }
      } else if (foyerThingsDataCopy[index].measurement === "depth") {
        if (item.type === "woodwork") {
          item.price = Math.round(value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)) * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));

        }
      } else if (foyerThingsDataCopy[index].measurement === "rft") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.rft * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.rft);
        }
      }

      return newData;
    });
  };




  useEffect(() => {
    // Calculate total price
    const totalPrice = foyerFormData.reduce((total, item) => {
      return total + (parseInt(item.price) || 0);
    }, 0);

    // Update roomTypeWoodPrice
    setRoomTypePrice(totalPrice);
  }, [foyerFormData]);



  useEffect(() => {
    // Calculate total woodwork price
    const totalWoodworkPrice = foyerFormData.reduce((total, item) => {
      if (item.type === "woodwork") {
        return total + item.price;
      }
      return total;
    }, 0);

    // Update roomTypeWoodPrice
    setRoomTypeWoodPrice(totalWoodworkPrice);
  }, [foyerFormData]);



  const saveFoyerData = async () => {



    // Recalculate prices
    const updatedKitchenFormData = foyerFormData.map(item => {
      const incrementPercentage = data['increment'] / 100;
      let newPrice = 0;

      if (item.type === "woodwork") {
        if (item.area) {
          newPrice = Math.round(item.value * item.area * (1 + incrementPercentage));
        } else if (item.width && item.height && item.qnty) {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else if (item.qnty) {
          newPrice = Math.round(item.value * item.qnty * (1 + incrementPercentage));
        } else if (item.depth) {
          newPrice = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)) * (1 + incrementPercentage));
        } else if (item.height && item.width) {
          newPrice = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
        } else if (item.rft) {
          newPrice = Math.round(item.value * item.rft * (1 + incrementPercentage));
        }
      } else {
        if (item.area) {
          newPrice = Math.round(item.value * item.area);
        } else if (item.width && item.height && item.qnty) {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty);
        } else if (item.qnty) {
          newPrice = Math.round(item.value * item.qnty);
        } else if (item.depth) {
          newPrice = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));
        } else if (item.height && item.width) {
          newPrice = Math.round(item.value * item.height * item.width);
        } else if (item.rft) {
          newPrice = Math.round(item.value * item.rft);
        }
      }

      return { ...item, price: newPrice };
    });

    // Recalculate total prices
    const newRoomTypePrice = updatedKitchenFormData.reduce((total, item) => total + item.price, 0);
    const newRoomTypeWoodPrice = updatedKitchenFormData.reduce((total, item) =>
      item.type === "woodwork" ? total + item.price : total, 0);

     const cleanText = (text) => (text || "").trim().replace(/\s+/g, " ");

    const url = data.path === 'assigneRooms'
      ? `https://us-central1-fabdiz-quote.cloudfunctions.net/api/add-assigne-rooms/${data.AssignedclientID}`
      : `https://us-central1-fabdiz-quote.cloudfunctions.net/api/project-rooms/${data.id}`;




    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: foyerFormData,
        fields: foyerThingsDataCopy,
        roomType: cleanText(roomType),
        roomTypeName: cleanText(roomTypeName),
        roomTypeDesign: cleanText(roomTypeDesign),
        roomTypeDescription: cleanText(roomTypeDescription),
        roomTypePrice: newRoomTypePrice,
        priceMode: priceGen,
        roomTypeWoodPrice: newRoomTypeWoodPrice,
        userId: data.ID,
      }),
    })
      .then(response => response.json())
      .then(async () => {
        setRoomTypeWoodPrice(0);
        await cleanupDraft();
        if (data.path === 'assigneRooms') {
          navigation("/assigned/view-rooms", { state: data });
        } else {

          navigation("/projects/view-rooms", { state: data });
        }
      }
      )
      .catch((error) => console.error('Error:', error));
  }

  const deleteUserAddedFoyerItem = (index) => {
    // Only delete if the item is user-added
    if (foyerThingsDataCopy[index].isUserAdded) {
      const updatedKitchenThingsDataCopy = [...foyerThingsDataCopy];
      const updatedKitchenFormData = [...foyerFormData];

      // Remove the item from the list and the form data
      updatedKitchenThingsDataCopy.splice(index, 1);
      updatedKitchenFormData.splice(index, 1);

      // Update the state
      setFoyerThingsDataCopy(updatedKitchenThingsDataCopy);
      setFoyerFormData(updatedKitchenFormData);
    }
  };


  // dynamic for living furniture 

  const { livingThingsData } = useSelector(
    (state) => state.livingThings
  );


  const [livingThingsDataCopy, setLivingThingsDataCopy] = useState(
    restored?.livingThingsDataCopy && restored.livingThingsDataCopy.length > 0
      ? restored.livingThingsDataCopy
      : livingThingsData
  );
  // console.log("livingThingsDataCopy", livingThingsDataCopy);


  const [livingFormData, setLivingFormData] = useState(
    restored?.livingFormData && restored.livingFormData.length > 0
      ? restored.livingFormData
      : (restored?.livingThingsDataCopy || livingThingsDataCopy).map((item) => ({
          name: item.name,
          label: "",
          value: 0,
          valueIncresed: 0,
          width: "",
          height: "",
          depth: "",
          qnty: "",
          rft: "",
          area: "",
          price: 0,
          remark: "",
          type: item.type,
        }))
  );

  const addNewLivingItem = () => {


    const nameExists = livingFormData.some((item) => item.name.toLowerCase() === extraItemName.trim().toLowerCase());
    if (nameExists) {
      Swal.fire({
        icon: "warning",
        title: "Duplicate Item Name",
        text: `An item named "${extraItemName}" already exists!`,
        confirmButtonColor: "#d33",
      });
      return;
    }

    if (!extraItemName.trim()) {
      Swal.fire({
        icon: "error",
        title: "Item Name Required",
        text: "Please enter an item name before adding.",
      });
      return;
    }



    setLivingThingsDataCopy([
      ...livingThingsDataCopy,
      {
        name: extraItemName,
        measurement: extraItemMeasure,
        material: [{ label: extraItemMaterialName, value: extraItemMaterialValue, oldvalue: extraItemMaterialValue }],
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    // console.log("data for copy kicthen data",kitchenThingsDataCopy);

    setLivingFormData([
      ...livingFormData,
      {
        name: extraItemName,
        label: "",
        value: 0,
        valueIncresed: 0,
        width: "",
        height: "",
        depth: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    setExtraItemMeasure('');
    setExtraItemName('');
    setExtraItemMaterialName('');
    setExtraItemMaterialValue(0);
    setExtraItemType('');
    setIsChecked(false)
    // console.log("Kitchen Nwe data",kitchenFormData);
  };




  const handleLivingChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value) || 0;
    // const newValue = e.target.value;
    const updatedLivingFormData = [...livingFormData];
    const item = updatedLivingFormData[index];
    const incrementPercentage = data['increment'] / 100;

    if (livingThingsDataCopy[index].measurement === "area") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    } else if (livingThingsDataCopy[index].measurement === "width") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * item.width * item.height * item.qnty);
      }
    } else if (livingThingsDataCopy[index].measurement === "qty") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    } else if (livingThingsDataCopy[index].measurement === "length") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * item.height * item.width);
      }
    } else if (livingThingsDataCopy[index].measurement === "depth") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)) * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));

      }
    } else if (livingThingsDataCopy[index].measurement === "rft") {
      item[field] = newValue;
      if (item.type === "woodwork") {
        item.price = Math.round(item.value * newValue * (1 + incrementPercentage));
      } else {
        item.price = Math.round(item.value * newValue);
      }
    }

    // Update the state with the modified data
    updatedLivingFormData[index] = item;
    setLivingFormData(updatedLivingFormData);
    // console.log("price checking", livingFormData);
  };


  const handleLivingPriceChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedLivingFormData = [...livingFormData];
    const item = updatedLivingFormData[index];


    item[field] = newValue;


    // Update the state with the modified data
    updatedLivingFormData[index] = item;
    setLivingFormData(updatedLivingFormData);
    // console.log("price checking", livingFormData);
  };




  const handleLivingRemarkChange = (e, index, field) => {
    // const newValue = parseFloat(e.target.value);
    const newValue = e.target.value;
    const updatedLivingFormData = [...livingFormData];
    const item = updatedLivingFormData[index];


    item[field] = newValue;


    // Update the state with the modified data
    updatedLivingFormData[index] = item;
    setLivingFormData(updatedLivingFormData);
    // console.log("price checking", livingFormData);
  };



  const handleLivingOptionChange = (e, index) => {
    const value = e.target.value || 0;
    // const selectedLabel = e.target.options[e.target.selectedIndex].text;
    const selectedLabel = e.target.label;
    const incrementPercentage = data['increment'] / 100;

    setLivingFormData((prevData) => {
      const newData = [...prevData];
      newData[index]['value'] = value;
      newData[index]['valueIncresed'] = Math.round(value * (1 + incrementPercentage));
      newData[index]['label'] = selectedLabel;

      // Recalculate the price based on the selected value
      const item = newData[index];
      if (livingThingsDataCopy[index].measurement === "area") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.area * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.area);
        }
      } else if (livingThingsDataCopy[index].measurement === "width") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.width * item.height * item.qnty);
        }
      } else if (livingThingsDataCopy[index].measurement === "qty") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.qnty * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.qnty);
        }
      } else if (livingThingsDataCopy[index].measurement === "length") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.height * item.width * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.height * item.width);
        }
      } else if (livingThingsDataCopy[index].measurement === "depth") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)) * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));

        }
      } else if (livingThingsDataCopy[index].measurement === "rft") {

        if (item.type === "woodwork") {
          item.price = Math.round(value * item.rft * (1 + incrementPercentage));
        } else {
          item.price = Math.round(value * item.rft);
        }
      }

      return newData;
    });
  };






  useEffect(() => {
    // Calculate total price
    const totalPrice = livingFormData.reduce((total, item) => {
      return total + (parseInt(item.price) || 0);
    }, 0);

    // Update roomTypeWoodPrice
    setRoomTypePrice(totalPrice);
  }, [livingFormData]);



  useEffect(() => {
    // Calculate total woodwork price
    const totalWoodworkPrice = livingFormData.reduce((total, item) => {
      if (item.type === "woodwork") {
        return total + item.price;
      }
      return total;
    }, 0);

    // Update roomTypeWoodPrice
    setRoomTypeWoodPrice(totalWoodworkPrice);
  }, [livingFormData]);


  const saveLivingData = async () => {


    // Recalculate prices
    const updatedKitchenFormData = livingFormData.map(item => {
      const incrementPercentage = data['increment'] / 100;
      let newPrice = 0;

      if (item.type === "woodwork") {
        if (item.area) {
          newPrice = Math.round(item.value * item.area * (1 + incrementPercentage));
        } else if (item.width && item.height && item.qnty) {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty * (1 + incrementPercentage));
        } else if (item.qnty) {
          newPrice = Math.round(item.value * item.qnty * (1 + incrementPercentage));
        } else if (item.depth) {
          newPrice = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)) * (1 + incrementPercentage));
        } else if (item.height && item.width) {
          newPrice = Math.round(item.value * item.height * item.width * (1 + incrementPercentage));
        } else if (item.rft) {
          newPrice = Math.round(item.value * item.rft * (1 + incrementPercentage));
        }
      } else {
        if (item.area) {
          newPrice = Math.round(item.value * item.area);
        } else if (item.width && item.height && item.qnty) {
          newPrice = Math.round(item.value * item.width * item.height * item.qnty);
        } else if (item.qnty) {
          newPrice = Math.round(item.value * item.qnty);
        } else if (item.depth) {
          newPrice = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));
        } else if (item.height && item.width) {
          newPrice = Math.round(item.value * item.height * item.width);
        } else if (item.rft) {
          newPrice = Math.round(item.value * item.rft);
        }
      }

      return { ...item, price: newPrice };
    });

    // Recalculate total prices
    const newRoomTypePrice = updatedKitchenFormData.reduce((total, item) => total + item.price, 0);
    const newRoomTypeWoodPrice = updatedKitchenFormData.reduce((total, item) =>
      item.type === "woodwork" ? total + item.price : total, 0);
    const cleanText = (text) => (text || "").trim().replace(/\s+/g, " ");
    const url = data.path === 'assigneRooms'
      ? `https://us-central1-fabdiz-quote.cloudfunctions.net/api/add-assigne-rooms/${data.AssignedclientID}`
      : `https://us-central1-fabdiz-quote.cloudfunctions.net/api/project-rooms/${data.id}`;
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: livingFormData,
        fields: livingThingsDataCopy,
        roomType: cleanText(roomType),
        roomTypeName: cleanText(roomTypeName),
        roomTypeDesign: cleanText(roomTypeDesign),
        roomTypeDescription: cleanText(roomTypeDescription),
        priceMode: priceGen,
        roomTypePrice: newRoomTypePrice,
        roomTypeWoodPrice: newRoomTypeWoodPrice,
        userId: data.ID,
      }),
    })
      .then(response => response.json())
      .then(async () => {
        setRoomTypeWoodPrice(0);
        await cleanupDraft();
        if (data.path === 'assigneRooms') {
          navigation("/assigned/view-rooms", { state: data });
        } else {

          navigation("/projects/view-rooms", { state: data });
        }
      }
      )
      .catch((error) => console.error('Error:', error));
  }

  const deleteUserAddedLivingItem = (index) => {
    // Only delete if the item is user-added
    if (livingThingsDataCopy[index].isUserAdded) {
      const updatedKitchenThingsDataCopy = [...livingThingsDataCopy];
      const updatedKitchenFormData = [...livingFormData];

      // Remove the item from the list and the form data
      updatedKitchenThingsDataCopy.splice(index, 1);
      updatedKitchenFormData.splice(index, 1);

      // Update the state
      setLivingThingsDataCopy(updatedKitchenThingsDataCopy);
      setLivingFormData(updatedKitchenFormData);
    }
  };


  // dynamic for other furniture 

  const { otherWorkThingsData } = useSelector(
    (state) => state.OtherWorkThings
  );

  const [otherThings, setOtherThings] = useState(
    restored?.otherThings && restored.otherThings.length > 0
      ? restored.otherThings
      : otherWorkThingsData
  );
  console.log('otherThings', otherThings);




  const [otherFormData, setOtherFormData] = useState(
    restored?.otherFormData && restored.otherFormData.length > 0
      ? restored.otherFormData
      : (restored?.otherThings || otherThings).map((item) => ({
          name: item.name,
          label: "",
          value: 0,
          valueIncresed: 0,
          width: "",
          height: "",
          qnty: "",
          rft: "",
          area: "",
          painting: "",
          price: 0,
          remark: "",
        }))
  );
  console.log("otherFormData", otherWorkThingsData);
  console.log("otherFormData", otherFormData);


  const addNewOtherWorkItem = () => {


    const nameExists = otherThings.some((item) => item.name.toLowerCase() === extraItemName.trim().toLowerCase());
    if (nameExists) {
      Swal.fire({
        icon: "warning",
        title: "Duplicate Item Name",
        text: `An item named "${extraItemName}" already exists!`,
        confirmButtonColor: "#d33",
      });
      return;
    }

    if (!extraItemName.trim()) {
      Swal.fire({
        icon: "error",
        title: "Item Name Required",
        text: "Please enter an item name before adding.",
      });
      return;
    }



    setOtherThings([
      ...otherThings,
      {
        name: extraItemName,
        measurement: extraItemMeasure,
        material: [{ label: extraItemMaterialName, value: extraItemMaterialValue, oldvalue: extraItemMaterialValue }],
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    // console.log("data for copy kicthen data",kitchenThingsDataCopy);

    setOtherFormData([
      ...otherFormData,
      {
        name: extraItemName,
        label: "",
        value: 0,
        valueIncresed: 0,
        width: "",
        height: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    setExtraItemMeasure('');
    setExtraItemName('');
    setExtraItemMaterialName('');
    setExtraItemMaterialValue(0);
    setExtraItemType('');
    setIsChecked(false)
    // console.log("Kitchen Nwe data",kitchenFormData);
  };


  const handleOtherChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value) || 0;
    console.log('eee', newValue);

    // const newValue = e.target.value;
    const updatedOtherFormData = [...otherFormData];
    const item = updatedOtherFormData[index];

    if (otherThings[index].measurement === "area") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (otherThings[index].measurement === "width") {
      item[field] = newValue;
      item.price = Math.round(item.value * item.width * item.height * item.qnty);
    } else if (otherThings[index].measurement === "qty") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (otherThings[index].measurement === "length") {
      item[field] = newValue;
      item.price = Math.round(item.value * item.height * item.width);
    } else if (otherThings[index].measurement === "rft") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (otherThings[index].measurement === "painting") {
      item[field] = newValue;
      item.price = Math.round(item.value * 3.5 * newValue);
    }

    // Update the state with the modified data
    updatedOtherFormData[index] = item;
    setOtherFormData(updatedOtherFormData);
    // console.log("price checking", otherFormData);
  };


  const deleteUserAddedOtherWorks = (index) => {
    // Only delete if the item is user-added
    if (otherThings[index].isUserAdded) {
      const updatedAccessoriesThingsDataCopy = [...otherThings];
      const updatedAccessoriesFormData = [...otherFormData];

      // Remove the item from the list and the form data
      updatedAccessoriesThingsDataCopy.splice(index, 1);
      updatedAccessoriesFormData.splice(index, 1);

      // Update the state
      setOtherThings(updatedAccessoriesThingsDataCopy);
      setOtherFormData(updatedAccessoriesFormData);
    }
  };


  const handleOtherPriceChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedOtherFormData = [...otherFormData];
    const item = updatedOtherFormData[index];


    item[field] = newValue;


    // Update the state with the modified data
    updatedOtherFormData[index] = item;
    setOtherFormData(updatedOtherFormData);
    // console.log("price checking", otherFormData);
  };



  const handleOtherRemarkChange = (e, index, field) => {
    // const newValue = parseFloat(e.target.value);
    const newValue = e.target.value;
    const updatedOtherFormData = [...otherFormData];
    const item = updatedOtherFormData[index];


    item[field] = newValue;


    // Update the state with the modified data
    updatedOtherFormData[index] = item;
    setOtherFormData(updatedOtherFormData);
    // console.log("price checking", otherFormData);
  };



  const handleOtherOptionChange = (e, index) => {
    const value = e.target.value || 0;
    const selectedLabel = e.target.label;
    console.log("eee", value);
    console.log("eee", selectedLabel);


    // const selectedLabel = e.target.options[e.target.selectedIndex].text;

    setOtherFormData((prevData) => {
      const newData = [...prevData];
      newData[index]['value'] = value;
      newData[index]['valueIncresed'] = value;
      newData[index]['label'] = selectedLabel;

      // Recalculate the price based on the selected value
      const item = newData[index];
      if (otherThings[index].measurement === "area") {
        item.price = Math.round(value * item.area);
      } else if (otherThings[index].measurement === "width") {
        item.price = Math.round(value * item.width * item.height * item.qnty);
      } else if (otherThings[index].measurement === "qty") {
        item.price = Math.round(value * item.qnty);
      } else if (otherThings[index].measurement === "length") {
        item.price = Math.round(value * item.height * item.width);
      } else if (otherThings[index].measurement === "rft") {
        item.price = Math.round(value * item.rft);
      } else if (otherThings[index].measurement === "painting") {
        item.price = Math.round(value * 3.5 * item.painting);
      }

      return newData;
    });
  };






  useEffect(() => {
    // Recalculate the total price
    const totalPrice = otherFormData.reduce((total, item) => total + (parseFloat(item.price) || 0), 0);
    setRoomTypePrice(totalPrice);


  }, [otherFormData]); // Recalculate when kitchenFormData changes




  const saveOtherData = async () => {

    // Recalculate prices
    const updatedLooseFormData = otherFormData.map((item, index) => {
      let newPrice = 0;

      if (otherThings[index].measurement === "area") {
        newPrice = Math.round(item.value * item.area);
      } else if (otherThings[index].measurement === "width") {
        newPrice = Math.round(item.value * item.width * item.height * item.qnty);
      } else if (otherThings[index].measurement === "qty") {
        newPrice = Math.round(item.value * item.qnty);
      } else if (otherThings[index].measurement === "length") {
        newPrice = Math.round(item.value * item.height * item.width);
      } else if (otherThings[index].measurement === "rft") {
        newPrice = Math.round(item.value * item.rft);
      } else if (otherThings[index].measurement === "painting") {
        newPrice = Math.round(item.value * 3.5 * item.painting);
      }

      return { ...item, price: newPrice };
    });

    // Recalculate total price
    const newRoomTypePrice = updatedLooseFormData.reduce((total, item) => total + item.price, 0);
    const cleanText = (text) => (text || "").trim().replace(/\s+/g, " ");
    const url = data.path === 'assigneRooms'
      ? `https://us-central1-fabdiz-quote.cloudfunctions.net/api/add-assigne-rooms/${data.AssignedclientID}`
      : `https://us-central1-fabdiz-quote.cloudfunctions.net/api/project-rooms/${data.id}`;

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: otherFormData,
        roomType:  cleanText(roomType),
        fields: otherThings,
        roomTypeName: cleanText(roomTypeName),
        roomTypeDesign: cleanText(roomTypeDesign),
        roomTypeDescription: cleanText(roomTypeDescription),
        roomTypePrice: newRoomTypePrice,
        roomTypeWoodPrice: 0,
        userId: data.ID,
      }),
    })
      .then(response => response.json())
      .then(async () => {
        setRoomTypeWoodPrice(0);
        await cleanupDraft();
        if (data.path === 'assigneRooms') {
          navigation("/assigned/view-rooms", { state: data });
        } else {

          navigation("/projects/view-rooms", { state: data });
        }
      }
      )
      .catch((error) => console.error('Error:', error));
  }



  // dynamic for loose furniture 

  const { looseThingsData } = useSelector(
    (state) => state.looseThings
  );
  console.log("looseThingsData", looseThingsData);




  const [looseFormData, setLooseFormData] = useState(
    restored?.looseFormData && restored.looseFormData.length > 0
      ? restored.looseFormData
      : looseThingsData.map((item) => ({
          name: item.name,
          label: "",
          value: 0,
          valueIncresed: 0,
          width: "",
          height: "",
          qnty: "",
          rft: "",
          area: "",
          price: 0,
          remark: "",
        }))
  );




  const handleLooseChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedLooseFormData = [...looseFormData];
    const item = updatedLooseFormData[index];

    if (looseThingsData[index].measurement === "area") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (looseThingsData[index].measurement === "width") {
      item[field] = newValue;
      item.price = Math.round(item.value * item.width * item.height * item.qnty);
    } else if (looseThingsData[index].measurement === "qty") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (looseThingsData[index].measurement === "length") {
      item[field] = newValue;
      item.price = Math.round(item.value * item.height * item.width);
    } else if (looseThingsData[index].measurement === "rft") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    }

    // Update the state with the modified data
    updatedLooseFormData[index] = item;
    setLooseFormData(updatedLooseFormData);
    // console.log("price checking", looseFormData);
  };


  const handleLoosePriceChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedLooseFormData = [...looseFormData];
    const item = updatedLooseFormData[index];

    item[field] = newValue;


    // Update the state with the modified data
    updatedLooseFormData[index] = item;
    setLooseFormData(updatedLooseFormData);
    // console.log("price checking", looseFormData);
  };



  const handleLooseRemarkChange = (e, index, field) => {
    // const newValue = parseFloat(e.target.value);
    const newValue = e.target.value;
    const updatedLooseFormData = [...looseFormData];
    const item = updatedLooseFormData[index];

    item[field] = newValue;


    // Update the state with the modified data
    updatedLooseFormData[index] = item;
    setLooseFormData(updatedLooseFormData);
    // console.log("price checking", looseFormData);
  };



  const handleLooseOptionChange = (e, index) => {
    const value = e.target.value;
    const selectedLabel = e.target.options[e.target.selectedIndex].text;

    setLooseFormData((prevData) => {
      const newData = [...prevData];
      newData[index]['value'] = value;
      newData[index]['valueIncresed'] = value;
      newData[index]['label'] = selectedLabel;

      // Recalculate the price based on the selected value
      const item = newData[index];
      if (looseThingsData[index].measurement === "area") {
        item.price = Math.round(value * item.area);
      } else if (looseThingsData[index].measurement === "width") {
        item.price = Math.round(value * item.width * item.height * item.qnty);
      } else if (looseThingsData[index].measurement === "qty") {
        item.price = Math.round(value * item.qnty);
      } else if (looseThingsData[index].measurement === "length") {
        item.price = Math.round(value * item.height * item.width);
      } else if (looseThingsData[index].measurement === "rft") {
        item.price = Math.round(value * item.rft);
      }

      return newData;
    });
  };





  useEffect(() => {
    // Recalculate the total price
    const totalPrice = looseFormData.reduce((total, item) => total + item.price, 0);
    setRoomTypePrice(totalPrice);

  }, [looseFormData]); // Recalculate when kitchenFormData changes




  const saveLooseData = async () => {

    // Recalculate prices
    const updatedLooseFormData = looseFormData.map((item, index) => {
      let newPrice = 0;

      if (looseThingsData[index].measurement === "area") {
        newPrice = Math.round(item.value * item.area);
      } else if (looseThingsData[index].measurement === "width") {
        newPrice = Math.round(item.value * item.width * item.height * item.qnty);
      } else if (looseThingsData[index].measurement === "qty") {
        newPrice = Math.round(item.value * item.qnty);
      } else if (looseThingsData[index].measurement === "length") {
        newPrice = Math.round(item.value * item.height * item.width);
      } else if (looseThingsData[index].measurement === "rft") {
        newPrice = Math.round(item.value * item.rft);
      }

      return { ...item, price: newPrice };
    });

    // Recalculate total price
    const newRoomTypePrice = updatedLooseFormData.reduce((total, item) => total + item.price, 0);
    const cleanText = (text) => (text || "").trim().replace(/\s+/g, " ");

    const url = data.path === 'assigneRooms'
      ? `https://us-central1-fabdiz-quote.cloudfunctions.net/api/add-assigne-rooms/${data.AssignedclientID}`
      : `https://us-central1-fabdiz-quote.cloudfunctions.net/api/project-rooms/${data.id}`;



    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: looseFormData,
        roomType: cleanText(roomType),
        roomTypeName: cleanText(roomTypeName),
        roomTypeDesign: cleanText(roomTypeDesign),
        priceMode: priceGen,
        roomTypeDescription:  cleanText(roomTypeDescription),
        roomTypePrice: newRoomTypePrice,
        roomTypeWoodPrice: 0,
        userId: data.ID,
      }),
    })
      .then(response => response.json())
      .then(async () => {
        setRoomTypeWoodPrice(0);
        await cleanupDraft();
        if (data.path === 'assigneRooms') {
          navigation("/assigned/view-rooms", { state: data });
        } else {

          navigation("/projects/view-rooms", { state: data });
        }
      }
      )
      .catch((error) => console.error('Error:', error));
  }



  // dynamic for Accessories

  const { accessoriesThingsData } = useSelector(
    (state) => state.accessories
  );
  console.log("accessoriesThingsData", accessoriesThingsData);


  const [accessoriesThingsDataCopy, setAccessoriesThingsDataCopy] = useState(
    restored?.accessoriesThingsDataCopy && restored.accessoriesThingsDataCopy.length > 0
      ? restored.accessoriesThingsDataCopy
      : accessoriesThingsData
  );

  const [accessoriesFormData, setAccessoriesFormData] = useState(
    restored?.accessoriesFormData && restored.accessoriesFormData.length > 0
      ? restored.accessoriesFormData
      : (restored?.accessoriesThingsDataCopy || accessoriesThingsDataCopy).map((item) => ({
          name: item.name,
          label: "",
          value: 0,
          valueIncresed: 0,
          width: "",
          height: "",
          depth: "",
          qnty: "",
          rft: "",
          area: "",
          price: 0,
          remark: "",
        }))
  );

  console.log("accessoriesFormData", accessoriesFormData);

  const addNewAccessoriesItem = () => {


    const nameExists = accessoriesFormData.some((item) => item.name.toLowerCase() === extraItemName.trim().toLowerCase());
    if (nameExists) {
      Swal.fire({
        icon: "warning",
        title: "Duplicate Item Name",
        text: `An item named "${extraItemName}" already exists!`,
        confirmButtonColor: "#d33",
      });
      return;
    }

    if (!extraItemName.trim()) {
      Swal.fire({
        icon: "error",
        title: "Item Name Required",
        text: "Please enter an item name before adding.",
      });
      return;
    }



    setAccessoriesThingsDataCopy([
      ...accessoriesThingsDataCopy,
      {
        name: extraItemName,
        measurement: extraItemMeasure,
        material: [{ label: extraItemMaterialName, value: extraItemMaterialValue, oldvalue: extraItemMaterialValue }],
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    // console.log("data for copy kicthen data",kitchenThingsDataCopy);

    setAccessoriesFormData([
      ...accessoriesFormData,
      {
        name: extraItemName,
        label: "",
        value: 0,
        valueIncresed: 0,
        width: "",
        height: "",
        depth: "",
        qnty: "",
        rft: "",
        area: "",
        price: 0,
        remark: "",
        type: extraItemType,
        isUserAdded: true,
      },
    ]);
    setExtraItemMeasure('');
    setExtraItemName('');
    setExtraItemMaterialName('');
    setExtraItemMaterialValue(0);
    setExtraItemType('');
    setIsChecked(false)
    // console.log("Kitchen Nwe data",kitchenFormData);
  };

  const deleteUserAddedAccessories = (index) => {
    // Only delete if the item is user-added
    if (accessoriesThingsDataCopy[index].isUserAdded) {
      const updatedAccessoriesThingsDataCopy = [...accessoriesThingsDataCopy];
      const updatedAccessoriesFormData = [...accessoriesFormData];

      // Remove the item from the list and the form data
      updatedAccessoriesThingsDataCopy.splice(index, 1);
      updatedAccessoriesFormData.splice(index, 1);

      // Update the state
      setAccessoriesThingsDataCopy(updatedAccessoriesThingsDataCopy);
      setAccessoriesFormData(updatedAccessoriesFormData);
    }
  };

  const handleAccessoriesChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value) || 0;
    console.log("eee", newValue);

    // const newValue = e.target.value;
    const updatedAccessoriesFormData = [...accessoriesFormData];
    const item = updatedAccessoriesFormData[index];

    if (accessoriesThingsDataCopy[index].measurement === "area") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (accessoriesThingsDataCopy[index].measurement === "width") {
      item[field] = newValue;
      item.price = Math.round(item.value * item.width * item.height * item.qnty);
    } else if (accessoriesThingsDataCopy[index].measurement === "qty") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    } else if (accessoriesThingsDataCopy[index].measurement === "length") {
      item[field] = newValue;
      item.price = Math.round(item.value * item.height * item.width);
    } else if (accessoriesThingsDataCopy[index].measurement === "depth") {
      item[field] = newValue;
      item.price = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));
    } else if (accessoriesThingsDataCopy[index].measurement === "rft") {
      item[field] = newValue;
      item.price = Math.round(item.value * newValue);
    }

    // Update the state with the modified data
    updatedAccessoriesFormData[index] = item;
    setAccessoriesFormData(updatedAccessoriesFormData);
    // console.log("price checking", accessoriesFormData);
  };


  const handleAccessoriesPriceChange = (e, index, field) => {
    const newValue = parseFloat(e.target.value);
    // const newValue = e.target.value;
    const updatedAccessoriesFormData = [...accessoriesFormData];
    const item = updatedAccessoriesFormData[index];

    item[field] = newValue;


    // Update the state with the modified data
    updatedAccessoriesFormData[index] = item;
    setAccessoriesFormData(updatedAccessoriesFormData);
    // console.log("price checking", accessoriesFormData);
  };



  const handleAccessoriesRemarkChange = (e, index, field) => {
    // const newValue = parseFloat(e.target.value);
    const newValue = e.target.value;
    const updatedAccessoriesFormData = [...accessoriesFormData];
    const item = updatedAccessoriesFormData[index];

    item[field] = newValue;


    // Update the state with the modified data
    updatedAccessoriesFormData[index] = item;
    setAccessoriesFormData(updatedAccessoriesFormData);
    // console.log("price checking", accessoriesFormData);
  };



  const handleAccessoriesOptionChange = (e, index) => {
    const value = e.target.value || 0;
    const selectedLabel = e.target.options[e.target.selectedIndex].text;
    console.log("eee", value);
    console.log("eee", selectedLabel);


    setAccessoriesFormData((prevData) => {
      const newData = [...prevData];
      newData[index]['value'] = value;
      newData[index]['valueIncresed'] = value;
      newData[index]['label'] = selectedLabel;

      // Recalculate the price based on the selected value
      const item = newData[index];
      if (accessoriesThingsDataCopy[index].measurement === "area") {
        item.price = Math.round(value * item.area);
      } else if (accessoriesThingsDataCopy[index].measurement === "width") {
        item.price = Math.round(value * item.width * item.height * item.qnty);
      } else if (accessoriesThingsDataCopy[index].measurement === "qty") {
        item.price = Math.round(value * item.qnty);
      } else if (accessoriesThingsDataCopy[index].measurement === "length") {
        item.price = Math.round(value * item.height * item.width);
      } else if (accessoriesThingsDataCopy[index].measurement === "depth") {
        item.price = Math.round(value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));
      } else if (accessoriesThingsDataCopy[index].measurement === "rft") {
        item.price = Math.round(value * item.rft);
      }

      return newData;
    });
  };




  useEffect(() => {
    // Recalculate the total price
    const totalPrice = accessoriesFormData.reduce((total, item) => total + (parseFloat(item.price) || 0), 0);
    setRoomTypePrice(totalPrice);

  }, [accessoriesFormData]); // Recalculate when kitchenFormData changes



  const saveAccessoriesData = async () => {

    // Recalculate prices
    const updatedLooseFormData = accessoriesFormData.map((item, index) => {
      let newPrice = 0;

      if (accessoriesThingsDataCopy[index].measurement === "area") {
        newPrice = Math.round(item.value * item.area);
      } else if (accessoriesThingsDataCopy[index].measurement === "width") {
        newPrice = Math.round(item.value * item.width * item.height * item.qnty);
      } else if (accessoriesThingsDataCopy[index].measurement === "qty") {
        newPrice = Math.round(item.value * item.qnty);
      } else if (accessoriesThingsDataCopy[index].measurement === "length") {
        newPrice = Math.round(item.value * item.height * item.width);
      } else if (accessoriesThingsDataCopy[index].measurement === "depth") {
        newPrice = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));
      } else if (accessoriesThingsDataCopy[index].measurement === "rft") {
        newPrice = Math.round(item.value * item.rft);
      }
      else if (item.depth) {
        newPrice = Math.round(item.value * ((item.width * item.depth * 2) + ((item.height - (item.depth * 2)) * item.depth * 2) + (((item.width - (item.depth * 2)) + (item.height - (item.depth * 2)) + (item.width - (item.depth * 2)) + (item.height - (item.depth * 2))) * 3)));
      }

      return { ...item, price: newPrice };
    });

    // Recalculate total price
    const newRoomTypePrice = updatedLooseFormData.reduce((total, item) => total + item.price, 0);

    const url = data.path === 'assigneRooms'
      ? `https://us-central1-fabdiz-quote.cloudfunctions.net/api/add-assigne-rooms/${data.AssignedclientID}`
      : `https://us-central1-fabdiz-quote.cloudfunctions.net/api/project-rooms/${data.id}`;

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: accessoriesFormData,
        roomType: roomType,
        fields: accessoriesThingsDataCopy,
        roomTypeName: roomTypeName,
        roomTypeDesign: roomTypeDesign,
        roomTypeDescription: roomTypeDescription,
        roomTypePrice: newRoomTypePrice,
        roomTypeWoodPrice: 0,
        userId: data.ID,
      }),
    })
      .then(response => response.json())
      .then(async () => {
        setRoomTypeWoodPrice(0);
        await cleanupDraft();
        if (data.path === 'assigneRooms') {
          navigation("/assigned/view-rooms", { state: data });
        } else {

          navigation("/projects/view-rooms", { state: data });
        }
      }
      )
      .catch((error) => console.error('Error:', error));
  }

  // name: item.name,
  // label: "",
  // value: 0,
  // valueIncresed: 0,
  // width:0,
  // height: 0,
  // qnty: 0,
  // rft:0,
  // area:0,
  // price:0,
  // remark: "",

  // adding dynamic fields for extra items
  const [materialFields, setMaterialFields] = useState(
    restored?.materialFields && restored.materialFields.length > 0
      ? restored.materialFields
      : [{ label: '', value: 0, qnty: 1, remark: '' }]
  );
  const [materialFieldsTotal, setMaterialFieldsTotal] = useState(restored?.materialFieldsTotal || 0);

  const handleAddField = () => {
    setMaterialFields([...materialFields, { label: '', value: 0, qnty: 1, remark: '' }]);
  };

  const handleRemoveField = (index) => {
    const updatedFields = [...materialFields];
    updatedFields.splice(index, 1);
    setMaterialFields(updatedFields);
  };

  const handleFieldChange = (value, index, fieldName) => {
    const updatedFields = [...materialFields];
    updatedFields[index][fieldName] = value;
    setMaterialFields(updatedFields);
  };

  const values = materialFields.map(items => {
    return items.value;
  });
  // reducing the qty in  a single value
  const reducerOfValues = (accumulator, currentValue) =>
    accumulator + parseFloat(currentValue || 0);

  // const totalValues = values.reduce(reducerOfValues, 0);
  const totalValues = () => {
    return values.reduce(reducerOfValues, 0);
  }

  useEffect(() => {
    const newAccessoriesTotal = totalValues;

    setMaterialFieldsTotal(newAccessoriesTotal);
    setRoomTypePrice(newAccessoriesTotal);
  }, [materialFields]);


  const saveExtraItemsData = async () => {


    // Recalculate prices
    const updatedMaterialFields = materialFields.map(item => {
      const newValue = parseFloat(item.value) || 0;
      const newQnty = parseFloat(item.qnty) || 1;
      const newPrice = Math.round(newValue * newQnty);

      return { ...item, value: newValue, qnty: newQnty, price: newPrice };
    });

    // Recalculate total price
    const newRoomTypePrice = updatedMaterialFields.reduce((total, item) => total + item.price, 0);

    const url = data.path === 'assigneRooms'
      ? `https://us-central1-fabdiz-quote.cloudfunctions.net/api/add-assigne-rooms/${data.AssignedclientID}`
      : `https://us-central1-fabdiz-quote.cloudfunctions.net/api/project-rooms/${data.id}`;

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: materialFields,
        roomType: roomType,
        roomTypeName: roomTypeName,
        roomTypeDesign: roomTypeDesign,
        roomTypeDescription: roomTypeDescription,
        roomTypePrice: newRoomTypePrice,
        roomTypeWoodPrice: 0,
        userId: data.ID,
      }),
    })
      .then(response => response.json())
      .then(async () => {
        setRoomTypeWoodPrice(0);
        await cleanupDraft();
        if (data.path === 'assigneRooms') {
          navigation("/assigned/view-rooms", { state: data });
        } else {

          navigation("/projects/view-rooms", { state: data });
        }
      }
      )
      .catch((error) => console.error('Error:', error));
  }

  const [priceGen, setPriceGen] = useState(restored?.priceGen || OriginalPriceType || "" || data?.priceMode || "value");

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    setPriceGen(selectedValue);
  };

  const isItemFilled = (obj) => {
    if (!obj) return false;
    if (obj.price && Number(obj.price) > 0) return true;
    if (obj.value && Number(obj.value) > 0) return true;
    if (obj.value2 && Number(obj.value2) > 0) return true;
    if (
      obj.label &&
      typeof obj.label === 'string' &&
      obj.label.trim() !== '' &&
      obj.label.trim().toLowerCase() !== 'none'
    ) {
      return true;
    }
    const dimensionKeys = ['area', 'height', 'qnty', 'rft', 'width', 'depth', 'door'];
    for (const key of dimensionKeys) {
      if (
        obj[key] !== undefined &&
        obj[key] !== null &&
        obj[key] !== '' &&
        obj[key] !== 0 &&
        obj[key] !== '0'
      ) {
        return true;
      }
    }
    return false;
  };

  const sortedData = () => {
    const sortPair = (forms, fields, setForms, setFields) => {
      if (!forms || !Array.isArray(forms) || forms.length === 0) return;
      const fieldsArr = (fields && Array.isArray(fields)) ? fields : [];
      const paired = forms.map((formItem, idx) => ({
        formItem,
        fieldItem: fieldsArr[idx] || { name: formItem?.name || 'item', measurement: 'area' }
      }));

      paired.sort((a, b) => {
        const aFilled = isItemFilled(a.formItem);
        const bFilled = isItemFilled(b.formItem);
        if (aFilled === bFilled) return 0;
        return aFilled ? -1 : 1;
      });

      setForms(paired.map(p => p.formItem));
      if (setFields) setFields(paired.map(p => p.fieldItem));
    };

    sortPair(kitchenFormData, kitchenThingsDataCopy, setKitchenFormData, setKitchenThingsDataCopy);
    sortPair(bedroomFormData, bedroomThingsDataCopy, setBedroomFormData, setBedroomThingsDataCopy);
    sortPair(foyerFormData, foyerThingsDataCopy, setFoyerFormData, setFoyerThingsDataCopy);
    sortPair(livingFormData, livingThingsDataCopy, setLivingFormData, setLivingThingsDataCopy);
    sortPair(otherFormData, otherThings, setOtherFormData, setOtherThings);
    sortPair(looseFormData, looseThingsData, setLooseFormData, null);
    sortPair(accessoriesFormData, accessoriesThingsDataCopy, setAccessoriesFormData, setAccessoriesThingsDataCopy);
  };

  useEffect(() => {
    sortedData();
  }, [roomTypeModal, restored, kitchenFormData?.length, bedroomFormData?.length, foyerFormData?.length, livingFormData?.length]);

  const latestTimestampRef = React.useRef(0);

  const cleanupDraft = async () => {
    isDraftCleanedUpRef.current = true;
    const clientId = data?.id || data?.ID || data?.AssignedclientID;
    const draftDocId = draftIdRef.current;
    if (clientId && draftDocId) {
      try {
        localStorage.removeItem(`room_creation_draft_${clientId}_${draftDocId}`);
        localStorage.removeItem(`room_creation_draft_${clientId}_default`);
        for (let i = localStorage.length - 1; i >= 0; i--) {
          const k = localStorage.key(i);
          if (k && k.startsWith(`room_creation_draft_${clientId}_`) && (k.includes(draftDocId) || k.includes('default'))) {
            localStorage.removeItem(k);
          }
        }
        await db.collection("client").doc(clientId).collection("RoomCreationDrafts").doc(draftDocId).delete().catch(() => {});
      } catch (e) {
        console.error("Error cleaning up draft:", e);
      }
    }
  };

  const hasMeaningfulData = () => {
    const cleanRoomType = (roomType || '').trim();
    if (cleanRoomType && cleanRoomType !== 'Select a Room') return true;
    if ((roomTypeName || '').trim()) return true;
    if ((roomTypeDesign || '').trim()) return true;
    if ((roomTypeDescription || '').trim()) return true;

    const hasItemData = (arr) => Array.isArray(arr) && arr.some(item => (item.label && item.label !== "None") || item.value > 0 || item.price > 0 || item.width || item.height || item.qnty || item.rft || item.remark);
    if (hasItemData(kitchenFormData)) return true;
    if (hasItemData(bedroomFormData)) return true;
    if (hasItemData(foyerFormData)) return true;
    if (hasItemData(livingFormData)) return true;
    if (hasItemData(otherFormData)) return true;
    if (hasItemData(looseFormData)) return true;
    if (hasItemData(accessoriesFormData)) return true;
    if (Array.isArray(materialFields) && materialFields.some(m => m.label || m.value > 0 || m.remark)) return true;
    return false;
  };

  // Utility: removes undefined values so Firestore doesn't throw "Unsupported field value: undefined"
  const sanitizeFirestoreData = (obj) => {
    if (Array.isArray(obj)) return obj.map(sanitizeFirestoreData);
    if (obj !== null && typeof obj === 'object') {
      return Object.fromEntries(
        Object.entries(obj)
          .filter(([, v]) => v !== undefined)
          .map(([k, v]) => [k, sanitizeFirestoreData(v)])
      );
    }
    return obj;
  };

  const getDraftPayload = (customPayload = {}) => {
    const clientId = data?.id || data?.ID || data?.AssignedclientID;
    const draftDocId = draftIdRef.current;
    const now = Date.now();

    const currentRoomType = customPayload.roomType !== undefined ? customPayload.roomType : roomType;
    const rawType = (currentRoomType || '').trim();
    const safeRoomType = rawType === 'Select a Room' ? '' : rawType;
    const currentRoomTypeName = customPayload.roomTypeName !== undefined ? customPayload.roomTypeName : roomTypeName;
    const currentRoomTypeDesign = customPayload.roomTypeDesign !== undefined ? customPayload.roomTypeDesign : roomTypeDesign;
    const currentRoomTypeDescription = customPayload.roomTypeDescription !== undefined ? customPayload.roomTypeDescription : roomTypeDescription;
    const currentRoomTypeModal = customPayload.roomTypeModal !== undefined ? customPayload.roomTypeModal : roomTypeModal;

    return {
      id: draftDocId,
      clientId,
      roomType: safeRoomType,
      roomTypeName: (currentRoomTypeName || '').trim(),
      roomTypeDesign: (currentRoomTypeDesign || '').trim(),
      roomTypeDescription: (currentRoomTypeDescription || '').trim(),
      roomTypeModal: currentRoomTypeModal || safeRoomType || '',
      priceGen: priceGen || 'value',
      roomTypePrice: roomTypePrice || 0,
      roomTypeWoodPrice: roomTypeWoodPrice || 0,
      kitchenFormData: kitchenFormData || [],
      kitchenThingsDataCopy: kitchenThingsDataCopy || [],
      bedroomFormData: bedroomFormData || [],
      bedroomThingsDataCopy: bedroomThingsDataCopy || [],
      foyerFormData: foyerFormData || [],
      foyerThingsDataCopy: foyerThingsDataCopy || [],
      livingFormData: livingFormData || [],
      livingThingsDataCopy: livingThingsDataCopy || [],
      otherFormData: otherFormData || [],
      otherThings: otherThings || [],
      looseFormData: looseFormData || [],
      accessoriesFormData: accessoriesFormData || [],
      accessoriesThingsDataCopy: accessoriesThingsDataCopy || [],
      materialFields: materialFields || [],
      materialFieldsTotal: materialFieldsTotal || 0,
      updatedAt: new Date().toISOString(),
      timestamp: now,
      ...customPayload,
    };
  };

  const saveDraftOnExit = (customPayload = {}) => {
    if (isDraftCleanedUpRef.current) return;
    if (!hasMeaningfulData()) return;

    const clientId = data?.id || data?.ID || data?.AssignedclientID;
    if (!clientId) return;
    const draftDocId = draftIdRef.current;

    const payload = getDraftPayload(customPayload);
    latestDraftPayloadRef.current = payload;

    try {
      localStorage.setItem(`room_creation_draft_${clientId}_${draftDocId}`, JSON.stringify(payload));
    } catch (e) {}

    try {
      db.collection("client").doc(clientId).collection("RoomCreationDrafts").doc(draftDocId).set(sanitizeFirestoreData(payload), { merge: true })
        .then(() => setDraftSaveStatus('Draft Saved'))
        .catch(() => setDraftSaveStatus('Saved Locally'));
    } catch (err) {
      console.error("Error saving draft on exit:", err);
    }
  };

  saveDraftOnExitRef.current = saveDraftOnExit;

  // Sync draft state to localStorage synchronously with zero API requests
  useEffect(() => {
    if (isDraftCleanedUpRef.current) return;
    if (!hasMeaningfulData()) return;

    const clientId = data?.id || data?.ID || data?.AssignedclientID;
    if (!clientId) return;
    const draftDocId = draftIdRef.current;

    const payload = getDraftPayload();
    latestDraftPayloadRef.current = payload;

    try {
      localStorage.setItem(`room_creation_draft_${clientId}_${draftDocId}`, JSON.stringify(payload));
    } catch (e) {}
  }, [
    roomType,
    roomTypeName,
    roomTypeDesign,
    roomTypeDescription,
    roomTypeModal,
    priceGen,
    roomTypePrice,
    roomTypeWoodPrice,
    kitchenFormData,
    kitchenThingsDataCopy,
    bedroomFormData,
    bedroomThingsDataCopy,
    foyerFormData,
    foyerThingsDataCopy,
    livingFormData,
    livingThingsDataCopy,
    otherFormData,
    otherThings,
    looseFormData,
    accessoriesFormData,
    accessoriesThingsDataCopy,
    materialFields,
    materialFieldsTotal,
  ]);

  // Handle page exit, tab close, or navigation away: execute Firestore API call only on exit
  useEffect(() => {
    const handleExit = () => {
      if (saveDraftOnExitRef.current) {
        saveDraftOnExitRef.current();
      }
    };

    window.addEventListener('beforeunload', handleExit);
    window.addEventListener('pagehide', handleExit);

    return () => {
      window.removeEventListener('beforeunload', handleExit);
      window.removeEventListener('pagehide', handleExit);
      handleExit();
    };
  }, []);

  const handleCategoryGoBack = () => {
    if (saveDraftOnExitRef.current) {
      saveDraftOnExitRef.current({ roomTypeModal: "" });
    }
    setRoomTypeModal("");
  };

  const handleDiscardDraft = async () => {
    if (isDiscarding) return;
    const result = await Swal.fire({
      title: "Discard Draft?",
      text: "Are you sure you want to discard this draft? All unsaved configurations will be permanently removed.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ef4444",
      cancelButtonColor: "#64748b",
      confirmButtonText: "Yes, Discard Draft",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      setIsDiscarding(true);
      isDraftCleanedUpRef.current = true;
      const clientId = data?.id || data?.ID || data?.AssignedclientID;
      const draftDocId = draftIdRef.current;
      if (clientId && draftDocId) {
        try {
          localStorage.removeItem(`room_creation_draft_${clientId}_${draftDocId}`);
          localStorage.removeItem(`room_creation_draft_${clientId}_default`);
          for (let i = localStorage.length - 1; i >= 0; i--) {
            const k = localStorage.key(i);
            if (k && k.startsWith(`room_creation_draft_${clientId}_`) && (k.includes(draftDocId) || k.includes('default'))) {
              localStorage.removeItem(k);
            }
          }
        } catch (e) {}
        db.collection("client").doc(clientId).collection("RoomCreationDrafts").doc(draftDocId).delete().catch(() => {});
      }

      Swal.fire({
        icon: "success",
        title: "Draft Discarded",
        timer: 800,
        showConfirmButton: false,
      });

      if (data?.path === "assigneRooms") {
        navigation("/assigned/view-rooms", { state: data });
      } else {
        navigation("/projects/view-rooms", { state: data });
      }
    }
  };

  // Restoration effect when restored draft is passed
  useEffect(() => {
    if (restored) {
      if (restored.roomType) setRoomType(restored.roomType);
      if (restored.roomTypeName) setRoomTypeName(restored.roomTypeName);
      if (restored.roomTypeDesign) setRoomTypeDesign(restored.roomTypeDesign);
      if (restored.roomTypeDescription) setRoomTypeDescription(restored.roomTypeDescription);
      if (restored.roomTypeModal || restored.roomType) setRoomTypeModal(restored.roomTypeModal || restored.roomType);
      if (restored.priceGen) setPriceGen(restored.priceGen);
      if (restored.roomTypePrice) setRoomTypePrice(restored.roomTypePrice);
      if (restored.roomTypeWoodPrice) setRoomTypeWoodPrice(restored.roomTypeWoodPrice);
      if (restored.kitchenFormData && restored.kitchenFormData.length > 0) setKitchenFormData(restored.kitchenFormData);
      if (restored.kitchenThingsDataCopy && restored.kitchenThingsDataCopy.length > 0) setKitchenThingsDataCopy(restored.kitchenThingsDataCopy);
      if (restored.bedroomFormData && restored.bedroomFormData.length > 0) setBedroomFormData(restored.bedroomFormData);
      if (restored.bedroomThingsDataCopy && restored.bedroomThingsDataCopy.length > 0) setBedroomThingsDataCopy(restored.bedroomThingsDataCopy);
      if (restored.foyerFormData && restored.foyerFormData.length > 0) setFoyerFormData(restored.foyerFormData);
      if (restored.foyerThingsDataCopy && restored.foyerThingsDataCopy.length > 0) setFoyerThingsDataCopy(restored.foyerThingsDataCopy);
      if (restored.livingFormData && restored.livingFormData.length > 0) setLivingFormData(restored.livingFormData);
      if (restored.livingThingsDataCopy && restored.livingThingsDataCopy.length > 0) setLivingThingsDataCopy(restored.livingThingsDataCopy);
      if (restored.otherFormData && restored.otherFormData.length > 0) setOtherFormData(restored.otherFormData);
      if (restored.otherThings && restored.otherThings.length > 0) setOtherThings(restored.otherThings);
      if (restored.looseFormData && restored.looseFormData.length > 0) setLooseFormData(restored.looseFormData);
      if (restored.accessoriesFormData && restored.accessoriesFormData.length > 0) setAccessoriesFormData(restored.accessoriesFormData);
      if (restored.accessoriesThingsDataCopy && restored.accessoriesThingsDataCopy.length > 0) setAccessoriesThingsDataCopy(restored.accessoriesThingsDataCopy);
      if (restored.materialFields && restored.materialFields.length > 0) setMaterialFields(restored.materialFields);
      if (restored.materialFieldsTotal) setMaterialFieldsTotal(restored.materialFieldsTotal);
    }
  }, [restored]);

  const handleAddNewItem = async (item, name, index) => {
    console.log(item);
    console.log(name);
    console.log(index);
    const material = item.material;
    const ShapeOfKitchen = item.name === "Shape Of Kitchen";
    // console.log("ShapeOfKitchen", ShapeOfKitchen);

    const swalHtml = ShapeOfKitchen
      ? '<input id="swal-input1" class="swal2-input" placeholder="Label">'
      : '<input id="swal-input1" class="swal2-input" placeholder="Label">' +
      '<input id="swal-input2" class="swal2-input" placeholder="Value (numbers only)">';

    const { value: formValues } = await Swal.fire({
      title: `Add New Material (${item.name})`,
      html: swalHtml,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Add',
      preConfirm: () => {

        let label = "";
        let value = "";

        if (ShapeOfKitchen) {
          label = document.getElementById("swal-input1").value.trim();
          value = "0"; // or "" if you want it optional
        } else {
          label = document.getElementById("swal-input1").value.trim();
          value = document.getElementById("swal-input2").value.trim();
        }
        console.log('valuerrrr', value);


        const labelRegex = /^[a-zA-Z\s]+$/; // Only letters and spaces
        const valueRegex = /^[0-9]+(\.[0-9]+)?$/; // Only numbers (integer or decimal)

        if (!label || !value) {
          Swal.showValidationMessage('Both fields are required');
          return false;
        }

        if (!labelRegex.test(label)) {
          Swal.showValidationMessage('Label must contain only letters and spaces');
          return false;
        }

        if (!valueRegex.test(value)) {
          Swal.showValidationMessage('Value must contain only numbers');
          return false;
        }

        return {
          label,
          value,
          oldvalue: value
        };
      }
    });

    if (formValues) {
      // console.log('New Item:', formValues);

      let updatedFormData;
      let setDataFn;

      // console.log("item.table", item.table);

      switch (item.table || name) {
        case "kitchen":
          updatedFormData = [...kitchenThingsDataCopy];
          setDataFn = setKitchenThingsDataCopy;
          break;
        case "Bedroom":
          updatedFormData = [...bedroomThingsDataCopy];
          setDataFn = setBedroomThingsDataCopy;
          break;
        case "Foyer":
          updatedFormData = [...foyerThingsDataCopy];
          setDataFn = setFoyerThingsDataCopy;
          break;
        case "LivingRoom":
          updatedFormData = [...livingThingsDataCopy];
          setDataFn = setLivingThingsDataCopy;
          break;
        case "OtherWorks":
          updatedFormData = [...otherThings];
          setDataFn = setOtherThings;
          break;
        default:
          // console.error("Unknown table type:", item.table);
          return;
      }

      const current = {
        ...updatedFormData[index],
        material: [...(material || []), formValues],
      };

      updatedFormData[index] = current;
      setDataFn(updatedFormData);
      console.log("updatedFormData", updatedFormData);
    }
  };

  ///////////////////////////////////////////////////////////


  const [search, setSearch] = useState('');
  console.log('search', search);



  return (
    <Container fluid>
      <Row className='m-0 ' >
         <Col sm={1} >
        
                </Col>
        <Col sm={11}>
          <Row className="p-4">
            {/* Room name and type modal */}
            {roomTypeModal == '' ?
              <Row style={{ overflowY: 'auto', paddingTop: '5vh' }}>

                <Row >

                  <Col
                    sm={12}
                  >
                    <Container >
                      <Row style={{
                        width: '100%',
                        padding: '20px',
                        borderRadius: '15px',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                        backgroundColor: '#ffffff', // Light background color
                        marginBottom: '10px'

                      }}>
                        <Col>

                          <Col style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '14px',
                          }} >
                            <div>
                              <h4 style={{ color: '#e85d13', margin: 0 }} >What is this design option for?</h4>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              {Boolean(restored) && draftSaveStatus && (
                                <span
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    color: draftSaveStatus.includes('Error') ? "#ef4444" : "#15803d",
                                    backgroundColor: draftSaveStatus.includes('Error') ? "#fef2f2" : "#f0fdf4",
                                    padding: "4px 12px",
                                    borderRadius: "20px",
                                    border: `1px solid ${draftSaveStatus.includes('Error') ? "#fecaca" : "#bbf7d0"}`,
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  {draftSaveStatus}
                                </span>
                              )}
                              {Boolean(restored) && (
                                <button
                                  type="button"
                                  onClick={handleDiscardDraft} disabled={isDiscarding} style={{ fontSize: "12px", fontWeight: "600", color: "#dc2626", backgroundColor: "#fee2e2", padding: "4px 12px", borderRadius: "20px", border: "1px solid #fca5a5", cursor: isDiscarding ? "not-allowed" : "pointer", opacity: isDiscarding ? 0.6 : 1 }}>{isDiscarding ? "Discarding..." : "Discard Draft"}</button>
                              )}
                            </div>
                          </Col>
                          <Form onSubmit={handleRoomTypeSubmit}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                              <Form.Label>Room Type</Form.Label>

                              <Form.Select
                                value={roomType}
                                onChange={(e) => setRoomType(e.currentTarget.value)}
                                aria-label="Default select example"
                                required

                              >
                                <option>Select a Room</option>
                                <option value="Kitchen">Kitchen</option>
                                <option value="Bedroom">Bedroom</option>
                                <option value="Foyer">Foyer</option>
                                <option value="Living Room">Living Room</option>
                                <option value="Other Works">Other Works</option>
                                <option value="Loose Furniture">Loose Furniture</option>
                                <option value="Accessories">Accessories</option>
                                <option value="ExtraItems">Extra items</option>
                              </Form.Select>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicPassword">
                              <Form.Label>Room Name</Form.Label>
                              <Form.Control
                                type="text"
                                value={roomTypeName}
                                onChange={(e) => setRoomTypeName(e.target.value)}
                                placeholder="Kitchen / Bedroom / Foyer / Living Room / Other Works / Loose Furniture"
                                required
                              />
                            </Form.Group>
                            {!OriginalPriceType && <Col>
                              <Form.Group controlId="price-selector">
                                <Form.Label>Price Type</Form.Label>
                                <Form.Control
                                  className="w-50"
                                  as="select"
                                  name="price"
                                  value={priceGen}
                                  onChange={handleChange}
                                >
                                  <option value="">None</option>
                                  <option value="oldvalue">Old Price</option>
                                  <option value="value">New Price</option>
                                </Form.Control>
                              </Form.Group>
                            </Col>}

                            <Form.Group className="mb-3" controlId="formBasicPassword">
                              <Form.Label>Design options</Form.Label>
                              <Form.Control
                                type="text"
                                value={roomTypeDesign}
                                onChange={(e) => setRoomTypeDesign(e.target.value)}
                                placeholder="Lorraine U, Damaris Straight..."
                                required={false}
                              />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicPassword">
                              <Form.Label>Description</Form.Label>
                              <Form.Control
                                as="textarea"
                                value={roomTypeDescription}
                                onChange={(e) => setRoomTypeDescription(e.target.value)}
                                placeholder="Description"
                                required
                              />
                            </Form.Group>

                            <Form.Group>
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-around',
                              }}>
                                <button
                                  type="button"
                                  style={{
                                    width: '20vw'
                                  }}

                                  className="buttonDesign"
                                  onClick={() => handleRoomTypeCancel()}
                                >
                                  Cancel
                                </button>
                                <button
                                  type="button"
                                  style={{
                                    width: '20vw',
                                    border: '1px solid green'
                                  }}
                                  className="buttonDesign"
                                  onClick={() => handleSaveNameType()}
                                  disabled={!roomType || !roomTypeDesign || !roomTypeName || !priceGen}
                                >
                                  Save
                                </button>
                                <button
                                  type="button"
                                  style={{
                                    width: '20vw',
                                    border: '1px solid blue'
                                  }}
                                  className="buttonDesign"
                                  onClick={() => setRoomTypeModal(roomType)}
                                  disabled={!roomType || !roomTypeDesign || !roomTypeName || !priceGen}
                                >
                                  Next
                                </button>
                              </div>
                            </Form.Group>
                          </Form>
                        </Col>
                      </Row>
                    </Container>


                  </Col>
                </Row>


              </Row> : roomTypeModal == 'Kitchen' ?
                <Row
                  style={{
                    // marginBottom: '50px',
                    // height:'auto',

                    padding: '20px',
                    // marginLeft: '20px',
                    borderRadius: '15px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                    backgroundColor: '#ffff', // Light background color

                  }} >
                  <div style={{
                    display: "flex",
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '0.5rem'
                  }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} >
                      <h5>Kitchen -- </h5>
                      <h6 style={{ color: '#e85d13', margin: 0 }}>{priceGen === 'value' ? 'New Value' : 'Old Value'}</h6>
                      {Boolean(restored) && draftSaveStatus && (
                        <span style={{ fontSize: "11px", fontWeight: "600", color: draftSaveStatus.includes('Error') ? "#ef4444" : "#15803d", backgroundColor: draftSaveStatus.includes('Error') ? "#fef2f2" : "#f0fdf4", padding: "2px 8px", borderRadius: "12px", border: `1px solid ${draftSaveStatus.includes('Error') ? "#fecaca" : "#bbf7d0"}` }}>
                          {draftSaveStatus}
                        </span>
                      )}
                    </span>
                    <div>

                      <InputGroup>
                        <Form.Control
                          style={{
                            borderRadius: "15px",
                            padding: "12px 15px",
                            border: "1px solid #d1d5db",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                            background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                            transition: "all 0.3s ease",
                            width: "20vw",
                          }}
                          onChange={(e) => setSearch(e.target.value)}
                          placeholder="Search Labels"
                        />
                        {search && (
                          <InputGroup.Text
                            style={{ cursor: 'pointer' }}
                            onClick={() => setSearch('')}
                          >
                            ✕
                          </InputGroup.Text>
                        )}
                      </InputGroup>
                    </div>

                  </div>




                  <Row style={{
                    backgroundColor: "#F2F2F2",
                    height: 'auto',
                    marginLeft: '5px',
                    overflowY: 'auto',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                    borderRadius: '15px',
                    // padding: '0 0 0 10px',
                  }}>
                    <Col style={{ minHeight: 380, maxHeight: 480 }}>

                      <Form>

                        <Form.Group>
                          <Row>

                            <Col sm={12}>

                              {kitchenThingsDataCopy
                                .map((item, index) => ({ item, formData: kitchenFormData[index], index }))
                                .filter(({ item }) => {
                                  const searchQuery = search.toLowerCase();
                                  return searchQuery === '' || item.name?.toLowerCase().includes(searchQuery)
                                })
                                .map(({ item, formData, index }) => (
                                  item.measurement == "area" ?
                                    <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                      <Col sm={2}>
                                        <Form.Group>
                                          <Form.Label
                                            style={{
                                              fontSize: 16,
                                              fontWeight: "500",
                                            }}
                                          >
                                            <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                          </Form.Label>
                                        </Form.Group>
                                      </Col>

                                      {/* <Col sm={2}>
                                      <Form.Group>
                                        <Form.Select
                                          value={kitchenFormData[index].value}
                                          onChange={(e) => handleKitchenOptionChange(e, index)}


                                        >
                                          {kitchenFormData[index].label !== 0 ? (
                                            <option value={kitchenFormData[index].label}>
                                              {kitchenFormData[index].label}
                                            </option>

                                          ) : (
                                            <option value="0">None</option>
                                          )}

                                          {item.material.map((item2, index2) => (
                                            <option
                                              key={index2}
                                              value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                            >
                                              {item2.label}

                                            </option>
                                          ))}
                                        </Form.Select>
                                      </Form.Group>
                                    </Col> */}

                                      {/* add label option */}
                                      <Col sm={2} style={{ display: 'flex' }}>
                                        <Dropdown>
                                          <Dropdown.Toggle
                                            variant="outline-secondary"
                                            style={{
                                              width: '12vw',
                                              backgroundColor: 'white',
                                              color: 'black',
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'center',
                                              whiteSpace: 'normal',        // Allows text to wrap
                                              wordBreak: 'break-word',     // Breaks long words
                                              padding: '0.5rem',           // Optional: Adds padding for better appearance
                                            }}>
                                            {formData.label || 'None'}
                                          </Dropdown.Toggle>
                                          <Dropdown.Menu style={{ width: 'auto' }}>
                                            <Dropdown.Item onClick={() => handleKitchenOptionChange({ target: { value: '0' } }, index)}>
                                              None
                                            </Dropdown.Item>
                                            {item.material.map((item2, index2) => {
                                              const childList = item2.subMaterials;
                                              const hasChild = childList && childList.length > 0;

                                              return (
                                                <div
                                                  key={index2}
                                                  style={{ position: "relative" }}
                                                  onMouseEnter={() => setHoveredItem(item2.label)}
                                                  onMouseLeave={() => setHoveredItem(null)}
                                                >
                                                  <Dropdown.Item
                                                    onClick={() => {
                                                      if (!hasChild) {
                                                        handleKitchenOptionChange(
                                                          {
                                                            target: {
                                                              value:
                                                                priceGen === "oldvalue"
                                                                  ? item2.oldvalue
                                                                  : item2.value,
                                                              label: item2.label,
                                                            },
                                                          },
                                                          index
                                                        );
                                                      }
                                                    }}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent: "space-between",
                                                    }}
                                                  >
                                                    {item2.label}
                                                    {hasChild && <span>▶</span>}
                                                  </Dropdown.Item>

                                                  {/* ✅ Child Dropdown */}
                                                  {hasChild && hoveredItem === item2.label && (
                                                    <div
                                                      style={{
                                                        position: "absolute",
                                                        top: 0,
                                                        left: "100%",
                                                        background: "white",
                                                        border: "1px solid #ddd",
                                                        minWidth: "180px",
                                                        zIndex: 1050,
                                                      }}
                                                    >
                                                      {item2.subMaterials.map((child, childIndex) => (
                                                        <Dropdown.Item
                                                          onClick={() => {
                                                            handleKitchenOptionChange(
                                                              {
                                                                target: {
                                                                  value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                  // value: child.subValue,
                                                                  label: `${item2.label} (${child.subLabel})`,
                                                                },
                                                              },
                                                              index
                                                            );
                                                          }}
                                                        >
                                                          {child.subLabel}
                                                        </Dropdown.Item>
                                                      ))}
                                                    </div>
                                                  )}
                                                </div>
                                              );
                                            })}

                                            <Dropdown.Divider />

                                            <div className="px-3 py-2">
                                              <Button
                                                variant="outline-success"
                                                size="sm"
                                                onClick={(e) => {
                                                  e.stopPropagation(); // prevent dropdown from closing
                                                  handleAddNewItem(item, 'kitchen', index);
                                                }}
                                              >
                                                <i className="bi bi-plus-square-dotted"></i> Add Item
                                              </Button>
                                            </div>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      </Col>
                                      <Col sm={2}>
                                        <Form.Group>
                                          <Form.Control
                                            type="number"
                                            value={kitchenFormData[index].area === 0 ? '' : kitchenFormData[index].area}
                                            onChange={(e) => handleKitchenChange(e, index, "area")}
                                            placeholder="Area"
                                          />
                                        </Form.Group>
                                      </Col>

                                      <Col sm={1}>

                                      </Col>

                                      <Col sm={2}>
                                        <Form.Group>
                                          <Form.Control
                                            type="number"
                                            value={kitchenFormData[index].price}
                                            //  onChange={(e) => handleKitchenPriceChange(e, index, "price")}
                                            placeholder="Price"
                                            disabled={kitchenFormData[index].value ? false : true}

                                          />
                                        </Form.Group>
                                      </Col>
                                      <Col sm={2}>
                                        <Form.Group>
                                          <Form.Control

                                            value={kitchenFormData[index].remark}
                                            onChange={(e) => handleKitchenRemarkChange(e, index, "remark")}
                                            as="textarea" rows={1}
                                            placeholder="Remark"
                                          />

                                        </Form.Group>


                                      </Col>
                                      <Col sm={1}>
                                        {item.isUserAdded && (
                                          <Button variant="danger" onClick={() => deleteUserAddedKitchenItem(index)}>
                                            <i class="bi bi-x-circle-fill"></i>
                                          </Button>
                                        )}
                                      </Col>
                                    </Row>
                                    : item.measurement == "width" ?
                                      <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                        <Col sm={2}>
                                          <Form.Group>
                                            <Form.Label
                                              style={{
                                                fontSize: 16,
                                                fontWeight: "500",
                                              }}
                                            >
                                              <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                            </Form.Label>
                                          </Form.Group>
                                        </Col>

                                        {/* <Col sm={2}>
                                        <Form.Group>
                                          <Form.Select
                                            value={kitchenFormData[index].value}
                                            onChange={(e) => handleKitchenOptionChange(e, index)}


                                          >
                                            <option value="0">None</option>
                                            {item.material.map((item2, index2) => (
                                              <option
                                                key={index2}
                                                value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                              >
                                                {item2.label}
                                              </option>
                                            ))}

                                          </Form.Select>
                                        </Form.Group>
                                      </Col> */}

                                        {/* add label option */}
                                        <Col sm={2} style={{ display: 'flex' }}>
                                          <Dropdown>
                                            <Dropdown.Toggle
                                              variant="outline-secondary"
                                              style={{
                                                width: '12vw',
                                                backgroundColor: 'white',
                                                color: 'black',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                whiteSpace: 'normal',        // Allows text to wrap
                                                wordBreak: 'break-word',     // Breaks long words
                                                padding: '0.5rem',           // Optional: Adds padding for better appearance
                                              }}>
                                              {formData.label || 'None'}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu style={{ width: 'auto' }}>
                                              <Dropdown.Item onClick={() => handleKitchenOptionChange({ target: { value: '0' } }, index)}>
                                                None
                                              </Dropdown.Item>
                                              {item.material.map((item2, index2) => {
                                                const childList = item2.subMaterials;
                                                const hasChild = childList && childList.length > 0;

                                                return (
                                                  <div
                                                    key={index2}
                                                    style={{ position: "relative" }}
                                                    onMouseEnter={() => setHoveredItem(item2.label)}
                                                    onMouseLeave={() => setHoveredItem(null)}
                                                  >
                                                    <Dropdown.Item
                                                      onClick={() => {
                                                        if (!hasChild) {
                                                          handleKitchenOptionChange(
                                                            {
                                                              target: {
                                                                value:
                                                                  priceGen === "oldvalue"
                                                                    ? item2.oldvalue
                                                                    : item2.value,
                                                                label: item2.label,
                                                              },
                                                            },
                                                            index
                                                          );
                                                        }
                                                      }}
                                                      style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                      }}
                                                    >
                                                      {item2.label}
                                                      {hasChild && <span>▶</span>}
                                                    </Dropdown.Item>

                                                    {/* ✅ Child Dropdown */}
                                                    {hasChild && hoveredItem === item2.label && (
                                                      <div
                                                        style={{
                                                          position: "absolute",
                                                          top: 0,
                                                          left: "100%",
                                                          background: "white",
                                                          border: "1px solid #ddd",
                                                          minWidth: "180px",
                                                          zIndex: 1050,
                                                        }}
                                                      >
                                                        {item2.subMaterials.map((child, childIndex) => (
                                                          <Dropdown.Item
                                                            onClick={() => {
                                                              handleKitchenOptionChange(
                                                                {
                                                                  target: {
                                                                    value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                    // value: child.subValue,
                                                                    label: `${item2.label} (${child.subLabel})`,
                                                                  },
                                                                },
                                                                index
                                                              );
                                                            }}
                                                          >
                                                            {child.subLabel}
                                                          </Dropdown.Item>
                                                        ))}
                                                      </div>
                                                    )}
                                                  </div>
                                                );
                                              })}

                                              <Dropdown.Divider />

                                              <div className="px-3 py-2">
                                                <Button
                                                  variant="outline-success"
                                                  size="sm"
                                                  onClick={(e) => {
                                                    e.stopPropagation(); // prevent dropdown from closing
                                                    handleAddNewItem(item, 'kitchen', index);
                                                  }}
                                                >
                                                  <i className="bi bi-plus-square-dotted"></i> Add Item
                                                </Button>
                                              </div>
                                            </Dropdown.Menu>
                                          </Dropdown>



                                        </Col>
                                        <Col sm={1}>
                                          <Form.Group>
                                            <Form.Control
                                              type="number"
                                              value={kitchenFormData[index].width === 0 ? '' : kitchenFormData[index].width}
                                              onChange={(e) => handleKitchenChange(e, index, "width")}
                                              placeholder="Width"
                                            />
                                          </Form.Group>
                                        </Col>

                                        <Col sm={1}>
                                          <Form.Group>
                                            <Form.Control
                                              type="number"
                                              value={kitchenFormData[index].height === 0 ? '' : kitchenFormData[index].height}
                                              onChange={(e) => handleKitchenChange(e, index, "height")}
                                              placeholder="Height"
                                            />
                                          </Form.Group>
                                        </Col>

                                        <Col sm={1}>
                                          <Form.Group>
                                            <Form.Control
                                              type="number"
                                              value={kitchenFormData[index].qnty === 0 ? '' : kitchenFormData[index].qnty}
                                              onChange={(e) => handleKitchenChange(e, index, "qnty")}
                                              placeholder="Qty"
                                            />
                                          </Form.Group>
                                        </Col>

                                        <Col sm={2}>
                                          <Form.Group>
                                            <Form.Control
                                              type="number"
                                              value={kitchenFormData[index].price}
                                              // onChange={(e) => handleKitchenPriceChange(e, index, "price")} 
                                              placeholder="Price"
                                              disabled={kitchenFormData[index].value ? false : true}
                                              min={123}
                                              autoFocus={true}
                                            />
                                          </Form.Group>
                                        </Col>
                                        <Col sm={2}>
                                          <Form.Group>
                                            <Form.Control
                                              value={kitchenFormData[index].remark}
                                              onChange={(e) => handleKitchenRemarkChange(e, index, "remark")}
                                              as="textarea" rows={1}
                                              placeholder="Remark"
                                            />
                                          </Form.Group>
                                        </Col>
                                        <Col sm={1}>
                                          {item.isUserAdded && (
                                            <Button variant="danger" onClick={() => deleteUserAddedKitchenItem(index)}>
                                              <i class="bi bi-x-circle-fill"></i>
                                            </Button>
                                          )}
                                        </Col>
                                      </Row>
                                      : item.measurement == "qty" && item.removed !== true ?
                                        <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Label
                                                style={{
                                                  fontSize: 16,
                                                  fontWeight: "500",
                                                }}
                                              >
                                                <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                              </Form.Label>
                                            </Form.Group>
                                          </Col>
                                          {/* <Col sm={2}>
                                          <Form.Group>
                                            <Form.Select
                                              value={kitchenFormData[index].value}
                                              onChange={(e) => handleKitchenOptionChange(e, index)}


                                            >
                                              <option value="0">None</option>
                                              {item.material.map((item2, index2) => (
                                                <option
                                                  key={index2}
                                                  value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                >
                                                  {item2.label}
                                                </option>
                                              ))}

                                            </Form.Select>
                                          </Form.Group>
                                        </Col> */}
                                          {/* add label option */}
                                          <Col sm={2} style={{ display: 'flex' }}>
                                            <Dropdown>
                                              <Dropdown.Toggle
                                                variant="outline-secondary"
                                                style={{
                                                  width: '12vw',
                                                  backgroundColor: 'white',
                                                  color: 'black',
                                                  display: 'flex',
                                                  justifyContent: 'space-between',
                                                  alignItems: 'center',
                                                  whiteSpace: 'normal',        // Allows text to wrap
                                                  wordBreak: 'break-word',     // Breaks long words
                                                  padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                }}>
                                                {formData.label || 'None'}
                                              </Dropdown.Toggle>
                                              <Dropdown.Menu style={{ width: 'auto' }}>
                                                <Dropdown.Item onClick={() => handleKitchenOptionChange({ target: { value: '0' } }, index)}>
                                                  None
                                                </Dropdown.Item>
                                                {item.material.map((item2, index2) => {
                                                  const childList = item2.subMaterials;
                                                  const hasChild = childList && childList.length > 0;

                                                  return (
                                                    <div
                                                      key={index2}
                                                      style={{ position: "relative" }}
                                                      onMouseEnter={() => setHoveredItem(item2.label)}
                                                      onMouseLeave={() => setHoveredItem(null)}
                                                    >
                                                      <Dropdown.Item
                                                        onClick={() => {
                                                          if (!hasChild) {
                                                            handleKitchenOptionChange(
                                                              {
                                                                target: {
                                                                  value:
                                                                    priceGen === "oldvalue"
                                                                      ? item2.oldvalue
                                                                      : item2.value,
                                                                  label: item2.label,
                                                                },
                                                              },
                                                              index
                                                            );
                                                          }
                                                        }}
                                                        style={{
                                                          display: "flex",
                                                          justifyContent: "space-between",
                                                        }}
                                                      >
                                                        {item2.label}
                                                        {hasChild && <span>▶</span>}
                                                      </Dropdown.Item>

                                                      {/* ✅ Child Dropdown */}
                                                      {hasChild && hoveredItem === item2.label && (
                                                        <div
                                                          style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: "100%",
                                                            background: "white",
                                                            border: "1px solid #ddd",
                                                            minWidth: "180px",
                                                            zIndex: 1050,
                                                          }}
                                                        >
                                                          {item2.subMaterials.map((child, childIndex) => (
                                                            <Dropdown.Item
                                                              onClick={() => {
                                                                handleKitchenOptionChange(
                                                                  {
                                                                    target: {
                                                                      value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                      // value: child.subValue,
                                                                      label: `${item2.label} (${child.subLabel})`,
                                                                    },
                                                                  },
                                                                  index
                                                                );
                                                              }}
                                                            >
                                                              {child.subLabel}
                                                            </Dropdown.Item>
                                                          ))}
                                                        </div>
                                                      )}
                                                    </div>
                                                  );
                                                })}

                                                <Dropdown.Divider />

                                                <div className="px-3 py-2">
                                                  <Button
                                                    variant="outline-success"
                                                    size="sm"
                                                    onClick={(e) => {
                                                      e.stopPropagation(); // prevent dropdown from closing
                                                      handleAddNewItem(item, 'kitchen', index);
                                                    }}
                                                  >
                                                    <i className="bi bi-plus-square-dotted"></i> Add Item
                                                  </Button>
                                                </div>
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          </Col>
                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Control
                                                type="number"
                                                value={kitchenFormData[index].qnty === 0 ? '' : kitchenFormData[index].qnty}
                                                onChange={(e) => handleKitchenChange(e, index, "qnty")}
                                                placeholder="Qty"
                                              />
                                            </Form.Group>
                                          </Col>

                                          <Col sm={1}>

                                          </Col>

                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Control
                                                type="number"
                                                value={kitchenFormData[index].price}
                                                //  onChange={(e) => handleKitchenPriceChange(e, index, "price")}
                                                placeholder="Price"
                                                disabled={kitchenFormData[index].value ? false : true}
                                                min={123}
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Control
                                                value={kitchenFormData[index].remark}
                                                onChange={(e) => handleKitchenRemarkChange(e, index, "remark")}
                                                as="textarea" rows={1}
                                                placeholder="Remark"
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col sm={1}>
                                            {item.isUserAdded && (
                                              <Button variant="danger" onClick={() => deleteUserAddedKitchenItem(index)}>
                                                <i class="bi bi-x-circle-fill"></i>
                                              </Button>
                                            )}
                                          </Col>
                                        </Row>
                                        : item.measurement == "length" ?
                                          <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Label
                                                  style={{
                                                    fontSize: 16,
                                                    fontWeight: "500",
                                                  }}
                                                >
                                                  <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                </Form.Label>
                                              </Form.Group>
                                            </Col>
                                            {/* <Col sm={2}>
                                            <Form.Group>
                                              <Form.Select
                                                value={kitchenFormData[index].value}
                                                onChange={(e) => handleKitchenOptionChange(e, index)}


                                              >
                                                <option value="0">None</option>
                                                {item.material.map((item2, index2) => (
                                                  <option
                                                    key={index2}
                                                    value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                  >
                                                    {item2.label}
                                                  </option>
                                                ))}

                                              </Form.Select>
                                            </Form.Group>
                                          </Col> */}
                                            {/* add label option */}
                                            <Col sm={2} style={{ display: 'flex' }}>
                                              <Dropdown>
                                                <Dropdown.Toggle
                                                  variant="outline-secondary"
                                                  style={{
                                                    width: '12vw',
                                                    backgroundColor: 'white',
                                                    color: 'black',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    whiteSpace: 'normal',        // Allows text to wrap
                                                    wordBreak: 'break-word',     // Breaks long words
                                                    padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                  }}>
                                                  {formData.label || 'None'}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu style={{ width: 'auto' }}>
                                                  <Dropdown.Item onClick={() => handleKitchenOptionChange({ target: { value: '0' } }, index)}>
                                                    None
                                                  </Dropdown.Item>
                                                  {item.material.map((item2, index2) => {
                                                    const childList = item2.subMaterials;
                                                    const hasChild = childList && childList.length > 0;

                                                    return (
                                                      <div
                                                        key={index2}
                                                        style={{ position: "relative" }}
                                                        onMouseEnter={() => setHoveredItem(item2.label)}
                                                        onMouseLeave={() => setHoveredItem(null)}
                                                      >
                                                        <Dropdown.Item
                                                          onClick={() => {
                                                            if (!hasChild) {
                                                              handleKitchenOptionChange(
                                                                {
                                                                  target: {
                                                                    value:
                                                                      priceGen === "oldvalue"
                                                                        ? item2.oldvalue
                                                                        : item2.value,
                                                                    label: item2.label,
                                                                  },
                                                                },
                                                                index
                                                              );
                                                            }
                                                          }}
                                                          style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                          }}
                                                        >
                                                          {item2.label}
                                                          {hasChild && <span>▶</span>}
                                                        </Dropdown.Item>

                                                        {/* ✅ Child Dropdown */}
                                                        {hasChild && hoveredItem === item2.label && (
                                                          <div
                                                            style={{
                                                              position: "absolute",
                                                              top: 0,
                                                              left: "100%",
                                                              background: "white",
                                                              border: "1px solid #ddd",
                                                              minWidth: "180px",
                                                              zIndex: 1050,
                                                            }}
                                                          >
                                                            {item2.subMaterials.map((child, childIndex) => (
                                                              <Dropdown.Item
                                                                onClick={() => {
                                                                  handleKitchenOptionChange(
                                                                    {
                                                                      target: {
                                                                        value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                        // value: child.subValue,
                                                                        label: `${item2.label} (${child.subLabel})`,
                                                                      },
                                                                    },
                                                                    index
                                                                  );
                                                                }}
                                                              >
                                                                {child.subLabel}
                                                              </Dropdown.Item>
                                                            ))}
                                                          </div>
                                                        )}
                                                      </div>
                                                    );
                                                  })}

                                                  <Dropdown.Divider />

                                                  <div className="px-3 py-2">
                                                    <Button
                                                      variant="outline-success"
                                                      size="sm"
                                                      onClick={(e) => {
                                                        e.stopPropagation(); // prevent dropdown from closing
                                                        handleAddNewItem(item, 'kitchen', index);
                                                      }}
                                                    >
                                                      <i className="bi bi-plus-square-dotted"></i> Add Item
                                                    </Button>
                                                  </div>
                                                </Dropdown.Menu>
                                              </Dropdown>
                                            </Col>
                                            <Col sm={1}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={kitchenFormData[index].height === 0 ? '' : kitchenFormData[index].height}
                                                  onChange={(e) => handleKitchenChange(e, index, "height")}
                                                  placeholder="Length"
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col sm={1}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={kitchenFormData[index].width === 0 ? '' : kitchenFormData[index].width}
                                                  onChange={(e) => handleKitchenChange(e, index, "width")}
                                                  placeholder="Width"
                                                />
                                              </Form.Group>
                                            </Col>


                                            <Col sm={1}>

                                            </Col>

                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={kitchenFormData[index].price}
                                                  // onChange={(e) => handleKitchenPriceChange(e, index, "price")} 
                                                  placeholder="Price"
                                                  disabled={kitchenFormData[index].value ? false : true}
                                                  min={123}
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Control
                                                  value={kitchenFormData[index].remark}
                                                  onChange={(e) => handleKitchenRemarkChange(e, index, "remark")}
                                                  as="textarea" rows={1}
                                                  placeholder="Remark"
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col sm={1}>
                                              {item.isUserAdded && (
                                                <Button variant="danger" onClick={() => deleteUserAddedKitchenItem(index)}>
                                                  <i class="bi bi-x-circle-fill"></i>
                                                </Button>
                                              )}
                                            </Col>
                                          </Row> : item.measurement == "rft" ?
                                            <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Label
                                                    style={{
                                                      fontSize: 16,
                                                      fontWeight: "500",
                                                    }}
                                                  >
                                                    <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                  </Form.Label>
                                                </Form.Group>
                                              </Col>
                                              {/* <Col sm={2}>
                                              <Form.Group>
                                                <Form.Select
                                                  value={kitchenFormData[index].value}
                                                  onChange={(e) => handleKitchenOptionChange(e, index)}


                                                >
                                                  <option value="0">None</option>
                                                  {item.material.map((item2, index2) => (
                                                    <option
                                                      key={index2}
                                                      value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                    >
                                                      {item2.label}
                                                    </option>
                                                  ))}

                                                </Form.Select>
                                              </Form.Group>
                                            </Col> */}
                                              {/* add label option */}
                                              <Col sm={2} style={{ display: 'flex' }}>
                                                <Dropdown>
                                                  <Dropdown.Toggle
                                                    variant="outline-secondary"
                                                    style={{
                                                      width: '12vw',
                                                      backgroundColor: 'white',
                                                      color: 'black',
                                                      display: 'flex',
                                                      justifyContent: 'space-between',
                                                      alignItems: 'center',
                                                      whiteSpace: 'normal',        // Allows text to wrap
                                                      wordBreak: 'break-word',     // Breaks long words
                                                      padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                    }}>
                                                    {formData.label || 'None'}
                                                  </Dropdown.Toggle>
                                                  <Dropdown.Menu style={{ width: 'auto' }}>
                                                    <Dropdown.Item onClick={() => handleKitchenOptionChange({ target: { value: '0' } }, index)}>
                                                      None
                                                    </Dropdown.Item>
                                                    {item.material.map((item2, index2) => {
                                                      const childList = item2.subMaterials;
                                                      const hasChild = childList && childList.length > 0;

                                                      return (
                                                        <div
                                                          key={index2}
                                                          style={{ position: "relative" }}
                                                          onMouseEnter={() => setHoveredItem(item2.label)}
                                                          onMouseLeave={() => setHoveredItem(null)}
                                                        >
                                                          <Dropdown.Item
                                                            onClick={() => {
                                                              if (!hasChild) {
                                                                handleKitchenOptionChange(
                                                                  {
                                                                    target: {
                                                                      value:
                                                                        priceGen === "oldvalue"
                                                                          ? item2.oldvalue
                                                                          : item2.value,
                                                                      label: item2.label,
                                                                    },
                                                                  },
                                                                  index
                                                                );
                                                              }
                                                            }}
                                                            style={{
                                                              display: "flex",
                                                              justifyContent: "space-between",
                                                            }}
                                                          >
                                                            {item2.label}
                                                            {hasChild && <span>▶</span>}
                                                          </Dropdown.Item>

                                                          {/* ✅ Child Dropdown */}
                                                          {hasChild && hoveredItem === item2.label && (
                                                            <div
                                                              style={{
                                                                position: "absolute",
                                                                top: 0,
                                                                left: "100%",
                                                                background: "white",
                                                                border: "1px solid #ddd",
                                                                minWidth: "180px",
                                                                zIndex: 1050,
                                                              }}
                                                            >
                                                              {item2.subMaterials.map((child, childIndex) => (
                                                                <Dropdown.Item
                                                                  onClick={() => {
                                                                    handleKitchenOptionChange(
                                                                      {
                                                                        target: {
                                                                          value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                          // value: child.subValue,
                                                                          label: `${item2.label} (${child.subLabel})`,
                                                                        },
                                                                      },
                                                                      index
                                                                    );
                                                                  }}
                                                                >
                                                                  {child.subLabel}
                                                                </Dropdown.Item>
                                                              ))}
                                                            </div>
                                                          )}
                                                        </div>
                                                      );
                                                    })}

                                                    <Dropdown.Divider />

                                                    <div className="px-3 py-2">
                                                      <Button
                                                        variant="outline-success"
                                                        size="sm"
                                                        onClick={(e) => {
                                                          e.stopPropagation(); // prevent dropdown from closing
                                                          handleAddNewItem(item, 'kitchen', index);
                                                        }}
                                                      >
                                                        <i className="bi bi-plus-square-dotted"></i> Add Item
                                                      </Button>
                                                    </div>
                                                  </Dropdown.Menu>
                                                </Dropdown>
                                              </Col>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={kitchenFormData[index].rft === 0 ? '' : kitchenFormData[index].rft}
                                                    onChange={(e) => handleKitchenChange(e, index, "rft")}
                                                    placeholder="RFT"
                                                  />
                                                </Form.Group>
                                              </Col>

                                              <Col sm={1}>

                                              </Col>

                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={kitchenFormData[index].price}
                                                    // onChange={(e) => handleKitchenPriceChange(e, index, "price")} 
                                                    placeholder="Price"
                                                    disabled={kitchenFormData[index].value ? false : true}
                                                    min={123}
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    value={kitchenFormData[index].remark}
                                                    onChange={(e) => handleKitchenRemarkChange(e, index, "remark")}
                                                    as="textarea" rows={1}
                                                    placeholder="Remark"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={1}>
                                                {item.isUserAdded && (
                                                  <Button variant="danger" onClick={() => deleteUserAddedKitchenItem(index)}>
                                                    <i class="bi bi-x-circle-fill"></i>
                                                  </Button>
                                                )}
                                              </Col>
                                            </Row> : item.measurement == "selection" ?
                                              <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Label
                                                      style={{
                                                        fontSize: 16,
                                                        fontWeight: "500",
                                                      }}
                                                    >
                                                      <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                    </Form.Label>
                                                  </Form.Group>
                                                </Col>


                                                {/* add label option */}
                                                <Col sm={2} style={{ display: 'flex' }}>
                                                  <Dropdown>
                                                    <Dropdown.Toggle
                                                      variant="outline-secondary"
                                                      style={{
                                                        width: '12vw',
                                                        backgroundColor: 'white',
                                                        color: 'black',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        whiteSpace: 'normal',        // Allows text to wrap
                                                        wordBreak: 'break-word',     // Breaks long words
                                                        padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                      }}>
                                                      {formData.label || 'None'}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu style={{ width: 'auto' }}>
                                                      <Dropdown.Item onClick={() => handleKitchenOptionChange({ target: { value: '0' } }, index)}>
                                                        None
                                                      </Dropdown.Item>
                                                      {item.material.map((item2, index2) => {
                                                        const childList = item2.subMaterials;
                                                        const hasChild = childList && childList.length > 0;

                                                        return (
                                                          <div
                                                            key={index2}
                                                            style={{ position: "relative" }}
                                                            onMouseEnter={() => setHoveredItem(item2.label)}
                                                            onMouseLeave={() => setHoveredItem(null)}
                                                          >
                                                            <Dropdown.Item
                                                              onClick={() => {
                                                                if (!hasChild) {
                                                                  handleKitchenOptionChange(
                                                                    {
                                                                      target: {
                                                                        value:
                                                                          priceGen === "oldvalue"
                                                                            ? item2.oldvalue
                                                                            : item2.value,
                                                                        label: item2.label,
                                                                      },
                                                                    },
                                                                    index
                                                                  );
                                                                }
                                                              }}
                                                              style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                              }}
                                                            >
                                                              {item2.label}
                                                              {hasChild && <span>▶</span>}
                                                            </Dropdown.Item>

                                                            {/* ✅ Child Dropdown */}
                                                            {hasChild && hoveredItem === item2.label && (
                                                              <div
                                                                style={{
                                                                  position: "absolute",
                                                                  top: 0,
                                                                  left: "100%",
                                                                  background: "white",
                                                                  border: "1px solid #ddd",
                                                                  minWidth: "180px",
                                                                  zIndex: 1050,
                                                                }}
                                                              >
                                                                {item2.subMaterials.map((child, childIndex) => (
                                                                  <Dropdown.Item
                                                                    onClick={() => {
                                                                      handleKitchenOptionChange(
                                                                        {
                                                                          target: {
                                                                            value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                            // value: child.subValue,
                                                                            label: `${item2.label} (${child.subLabel})`,
                                                                          },
                                                                        },
                                                                        index
                                                                      );
                                                                    }}
                                                                  >
                                                                    {child.subLabel}
                                                                  </Dropdown.Item>
                                                                ))}
                                                              </div>
                                                            )}
                                                          </div>
                                                        );
                                                      })}

                                                      <Dropdown.Divider />

                                                      <div className="px-3 py-2">
                                                        <Button
                                                          variant="outline-success"
                                                          size="sm"
                                                          onClick={(e) => {
                                                            e.stopPropagation(); // prevent dropdown from closing
                                                            handleAddNewItem(item, 'kitchen', index);
                                                          }}
                                                        >
                                                          <i className="bi bi-plus-square-dotted"></i> Add Item
                                                        </Button>
                                                      </div>
                                                    </Dropdown.Menu>
                                                  </Dropdown>
                                                </Col>


                                                <Col sm={2}>

                                                </Col>

                                                <Col sm={1}>

                                                </Col>

                                                <Col sm={2}>

                                                </Col>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      value={kitchenFormData[index].remark}
                                                      onChange={(e) => handleKitchenRemarkChange(e, index, "remark")}
                                                      as="textarea" rows={1}
                                                      placeholder="Remark"
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={1}>
                                                  {item.isUserAdded && (
                                                    <Button variant="danger" onClick={() => deleteUserAddedKitchenItem(index)}>
                                                      <i class="bi bi-x-circle-fill"></i>
                                                    </Button>
                                                  )}
                                                </Col>
                                              </Row> : null
                                ))}


                            </Col>
                            {/* <button onClick={addNewKitchen}>Add New Accessory</button> */}
                          </Row>
                          <Row>
                            <Col>

                              <Row className="mx-1 my-3">
                                <Col sm={2}>
                                  <Form.Group >
                                    <Form.Control
                                      value={extraItemName}
                                      onChange={(e) => setExtraItemName(e.target.value)}
                                      type="text"
                                      placeholder="Item Name"
                                    />
                                  </Form.Group>
                                </Col>
                                <Col sm={2}>
                                  <Form.Group >
                                    <Form.Control
                                      value={extraItemMaterialName}
                                      onChange={(e) => setExtraItemMaterialName(e.target.value)}
                                      type="text"
                                      placeholder="Material Name"
                                    />
                                  </Form.Group>
                                </Col>
                                <Col sm={2}>
                                  <Form.Group >
                                    <Form.Control
                                      value={extraItemMaterialValue}
                                      onChange={(e) => setExtraItemMaterialValue(e.target.value)}
                                      type="number"
                                      placeholder="Material Value"
                                    />
                                  </Form.Group>
                                </Col>

                                <Col sm={3}>
                                  <Form.Select value={extraItemMeasure} onChange={(e) => { setExtraItemMeasure(e.currentTarget.value) }} >
                                    <option>Select Measurement Type</option>
                                    <option value="area">Area</option>
                                    <option value="width">Width &  Height</option>
                                    <option value="rft">RFT</option>
                                    <option value="qty">Quantity</option>
                                    <option value="length">Width & Length</option>
                                    <option value="selection">Selection</option>
                                  </Form.Select>
                                </Col>
                                <Col sm={1}>
                                  <Form.Check
                                    inline
                                    label="Wood"
                                    name="Wood"
                                    type="checkbox"
                                    id="inline-checkbox-1"
                                    checked={isChecked}
                                    onChange={handleCheckboxChange}
                                  />
                                </Col>
                                <Col sm={2}>
                                  <Button onClick={addNewKitchenItem}>Add Item</Button>
                                </Col>
                              </Row>





                            </Col>

                          </Row>

                        </Form.Group>


                      </Form>

                    </Col>
                  </Row>
                  <Row style={{
                    // marginBottom: '50px',
                    marginLeft: '1px',
                    padding: '20px',
                    borderRadius: '15px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                    backgroundColor: '#ffffff', // Light background color


                  }} >
                    <Col style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      gap: '12px',
                    }}>
                      <Button className="buttonDesign" style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold" }} onClick={handleCategoryGoBack} >Go Back</Button>
                      {Boolean(restored) && (
                        <Button style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold", backgroundColor: '#fee2e2', color: '#dc2626', border: '1px solid #fca5a5' }} onClick={handleDiscardDraft} disabled={isDiscarding}>{isDiscarding ? "Discarding..." : "Discard Draft"}</Button>
                      )}
                      <Button className="buttonDesign" style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold" }} disabled={isSaving} onClick={() => saveKitchenData()} >{isSaving ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Saving...</> : "Save"}</Button>
                    </Col>
                    <Col className="col-sm-3">

                    </Col>
                    <Col className="col-sm-2"><h4>Total Price</h4></Col>
                    <Col className="col-sm-2">
                      {/* <h4>
                        Rs:- {roomTypePrice}

                      </h4> */}
                      <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{roomTypePrice}</h4></span>
                    </Col>
                  </Row>

                </Row> : roomTypeModal == 'Bedroom' ?
                  <Row className="p-2" style={{
                    marginBottom: '50px',
                    padding: '20px',
                    marginLeft: '20px',
                    borderRadius: '15px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                    backgroundColor: '#ffffff', // Light background color

                  }}>

                    <div style={{
                      display: "flex",
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '1rem'
                    }}>
                      <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} >
                        <h5>Bedroom -- </h5>
                        <h6 style={{ color: '#e85d13', margin: 0 }}>{priceGen === 'value' ? 'New Value' : 'Old Value'}</h6>
                        {Boolean(restored) && draftSaveStatus && (
                          <span style={{ fontSize: "11px", fontWeight: "600", color: draftSaveStatus.includes('Error') ? "#ef4444" : "#15803d", backgroundColor: draftSaveStatus.includes('Error') ? "#fef2f2" : "#f0fdf4", padding: "2px 8px", borderRadius: "12px", border: `1px solid ${draftSaveStatus.includes('Error') ? "#fecaca" : "#bbf7d0"}` }}>
                            {draftSaveStatus}
                          </span>
                        )}
                      </span>

                      <div>
                        <InputGroup>
                          <Form.Control
                            style={{
                              borderRadius: "15px",
                              padding: "12px 15px",
                              border: "1px solid #d1d5db",
                              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                              background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                              transition: "all 0.3s ease",
                              width: "20vw",
                            }}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Search Labels"
                          />
                        </InputGroup>
                      </div>
                    </div>


                    <Row style={{
                      backgroundColor: "#F2F2F2",
                      height: 'auto',
                      marginLeft: '5px',
                      overflowY: 'auto',
                      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                      borderRadius: '15px',
                      padding: '0 0 0 10px',
                    }}>
                      <Col style={{ minHeight: 380, maxHeight: 480 }}>

                        <Form>

                          <Form.Group>
                            <Row>

                              <Col sm={12}>

                                {bedroomThingsDataCopy
                                  .map((item, index) => ({ item, formData: bedroomFormData[index], index }))
                                  .filter(({ item }) => {
                                    const searchQuery = search.toLowerCase();
                                    return searchQuery === '' || item.name?.toLowerCase().includes(searchQuery);
                                  })
                                  .map(({ item, formData, index }) => (
                                    item.measurement == "area" ?
                                      <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                        <Col sm={2}>
                                          <Form.Group>
                                            <Form.Label
                                              style={{
                                                fontSize: 16,
                                                fontWeight: "500",
                                              }}
                                            > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                            </Form.Label>
                                          </Form.Group>
                                        </Col>


                                        {/* add label option */}
                                        <Col sm={2} style={{ display: 'flex' }}>
                                          <Dropdown>
                                            <Dropdown.Toggle
                                              variant="outline-secondary"
                                              style={{
                                                width: '12vw',
                                                backgroundColor: 'white',
                                                color: 'black',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                whiteSpace: 'normal',        // Allows text to wrap
                                                wordBreak: 'break-word',     // Breaks long words
                                                padding: '0.5rem',           // Optional: Adds padding for better appearance
                                              }}>
                                              {formData.label || 'None'}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu style={{ width: 'auto' }}>
                                              <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0' } }, index)}>
                                                None
                                              </Dropdown.Item>
                                              {item.material.map((item2, index2) => {
                                                const childList = item2.subMaterials;
                                                const hasChild = childList && childList.length > 0;

                                                return (
                                                  <div
                                                    key={index2}
                                                    style={{ position: "relative" }}
                                                    onMouseEnter={() => setHoveredItem(item2.label)}
                                                    onMouseLeave={() => setHoveredItem(null)}
                                                  >
                                                    <Dropdown.Item
                                                      onClick={() => {
                                                        if (!hasChild) {
                                                          handleBedroomOptionChange(
                                                            {
                                                              target: {
                                                                value:
                                                                  priceGen === "oldvalue"
                                                                    ? item2.oldvalue
                                                                    : item2.value,
                                                                label: item2.label,
                                                              },
                                                            },
                                                            index
                                                          );
                                                        }
                                                      }}
                                                      style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                      }}
                                                    >
                                                      {item2.label}
                                                      {hasChild && <span>▶</span>}
                                                    </Dropdown.Item>

                                                    {/* ✅ Child Dropdown */}
                                                    {hasChild && hoveredItem === item2.label && (
                                                      <div
                                                        style={{
                                                          position: "absolute",
                                                          top: 0,
                                                          left: "100%",
                                                          background: "white",
                                                          border: "1px solid #ddd",
                                                          minWidth: "180px",
                                                          zIndex: 1050,
                                                        }}
                                                      >
                                                        {item2.subMaterials.map((child, childIndex) => (
                                                          <Dropdown.Item
                                                            onClick={() => {
                                                              handleBedroomOptionChange(
                                                                {
                                                                  target: {
                                                                    value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                    // value: child.subValue,
                                                                    label: `${item2.label} (${child.subLabel})`,
                                                                  },
                                                                },
                                                                index
                                                              );
                                                            }}
                                                          >
                                                            {child.subLabel}
                                                          </Dropdown.Item>
                                                        ))}
                                                      </div>
                                                    )}
                                                  </div>
                                                );
                                              })}

                                              <Dropdown.Divider />

                                              <div className="px-3 py-2">
                                                <Button
                                                  variant="outline-success"
                                                  size="sm"
                                                  onClick={(e) => {
                                                    e.stopPropagation(); // prevent dropdown from closing
                                                    handleAddNewItem(item, 'kitchen', index);
                                                  }}
                                                >
                                                  <i className="bi bi-plus-square-dotted"></i> Add Item
                                                </Button>
                                              </div>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </Col>
                                        <Col sm={2}>
                                          <Form.Group>
                                            <Form.Control
                                              type="number"
                                              value={bedroomFormData[index].area === 0 ? '' : bedroomFormData[index].area}
                                              onChange={(e) => handleBedroomChange(e, index, "area")}
                                              placeholder={"Area"}
                                            />
                                          </Form.Group>
                                        </Col>

                                        <Col sm={1}>

                                        </Col>

                                        <Col sm={2}>
                                          <Form.Group>
                                            <Form.Control
                                              type="number"
                                              value={bedroomFormData[index].price}
                                              onChange={(e) => handleBedroomChange(e, index, "price")}
                                              placeholder="Price"
                                              disabled={!bedroomFormData[index].value}

                                            />
                                          </Form.Group>
                                        </Col>
                                        <Col sm={2}>
                                          <Form.Group>
                                            <Form.Control
                                              value={bedroomFormData[index].remark}
                                              onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                              as="textarea" rows={1}
                                              placeholder="Remark"
                                            />
                                          </Form.Group>
                                        </Col>
                                        <Col sm={1}>
                                          {item.isUserAdded && (
                                            <Button variant="danger" onClick={() => deleteUserAddedBedroomItem(index)}>
                                              <i class="bi bi-x-circle-fill"></i>
                                            </Button>
                                          )}
                                        </Col>
                                      </Row>
                                      : item.measurement == "width" ?
                                        <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Label
                                                style={{
                                                  fontSize: 16,
                                                  fontWeight: "500",
                                                }}
                                              > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                              </Form.Label>
                                            </Form.Group>
                                          </Col>


                                          {/* add label option */}
                                          <Col sm={2} style={{ display: 'flex' }}>
                                            <Dropdown>
                                              <Dropdown.Toggle
                                                variant="outline-secondary"
                                                style={{
                                                  width: '12vw',
                                                  backgroundColor: 'white',
                                                  color: 'black',
                                                  display: 'flex',
                                                  justifyContent: 'space-between',
                                                  alignItems: 'center',
                                                  whiteSpace: 'normal',        // Allows text to wrap
                                                  wordBreak: 'break-word',     // Breaks long words
                                                  padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                }}>
                                                {formData.label || 'None'}
                                              </Dropdown.Toggle>
                                              <Dropdown.Menu style={{ width: 'auto' }}>
                                                <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0' } }, index)}>
                                                  None
                                                </Dropdown.Item>
                                                {item.material.map((item2, index2) => {
                                                  const childList = item2.subMaterials;
                                                  const hasChild = childList && childList.length > 0;

                                                  return (
                                                    <div
                                                      key={index2}
                                                      style={{ position: "relative" }}
                                                      onMouseEnter={() => setHoveredItem(item2.label)}
                                                      onMouseLeave={() => setHoveredItem(null)}
                                                    >
                                                      <Dropdown.Item
                                                        onClick={() => {
                                                          if (!hasChild) {
                                                            handleBedroomOptionChange(
                                                              {
                                                                target: {
                                                                  value:
                                                                    priceGen === "oldvalue"
                                                                      ? item2.oldvalue
                                                                      : item2.value,
                                                                  label: item2.label,
                                                                },
                                                              },
                                                              index
                                                            );
                                                          }
                                                        }}
                                                        style={{
                                                          display: "flex",
                                                          justifyContent: "space-between",
                                                        }}
                                                      >
                                                        {item2.label}
                                                        {hasChild && <span>▶</span>}
                                                      </Dropdown.Item>

                                                      {/* ✅ Child Dropdown */}
                                                      {hasChild && hoveredItem === item2.label && (
                                                        <div
                                                          style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: "100%",
                                                            background: "white",
                                                            border: "1px solid #ddd",
                                                            minWidth: "180px",
                                                            zIndex: 1050,
                                                          }}
                                                        >
                                                          {item2.subMaterials.map((child, childIndex) => (
                                                            <Dropdown.Item
                                                              onClick={() => {
                                                                handleBedroomOptionChange(
                                                                  {
                                                                    target: {
                                                                      value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                      // value: child.subValue,
                                                                      label: `${item2.label} (${child.subLabel})`,
                                                                    },
                                                                  },
                                                                  index
                                                                );
                                                              }}
                                                            >
                                                              {child.subLabel}
                                                            </Dropdown.Item>
                                                          ))}
                                                        </div>
                                                      )}
                                                    </div>
                                                  );
                                                })}

                                                <Dropdown.Divider />

                                                <div className="px-3 py-2">
                                                  <Button
                                                    variant="outline-success"
                                                    size="sm"
                                                    onClick={(e) => {
                                                      e.stopPropagation(); // prevent dropdown from closing
                                                      handleAddNewItem(item, 'kitchen', index);
                                                    }}
                                                  >
                                                    <i className="bi bi-plus-square-dotted"></i> Add Item
                                                  </Button>
                                                </div>
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          </Col>
                                          <Col sm={1}>
                                            <Form.Group>
                                              <Form.Control
                                                type="number"
                                                value={bedroomFormData[index].width === 0 ? '' : bedroomFormData[index].width}
                                                onChange={(e) => handleBedroomChange(e, index, "width")}
                                                placeholder="Width"
                                              />
                                            </Form.Group>
                                          </Col>

                                          <Col sm={1}>
                                            <Form.Group>
                                              <Form.Control
                                                type="number"
                                                value={bedroomFormData[index].height === 0 ? '' : bedroomFormData[index].height}
                                                onChange={(e) => handleBedroomChange(e, index, "height")}
                                                placeholder="Height"
                                              />
                                            </Form.Group>
                                          </Col>

                                          <Col sm={1}>
                                            <Form.Group>
                                              <Form.Control
                                                type="number"
                                                value={bedroomFormData[index].qnty === 0 ? '' : bedroomFormData[index].qnty}
                                                onChange={(e) => handleBedroomChange(e, index, "qnty")}
                                                placeholder="Qty"
                                              />
                                            </Form.Group>
                                          </Col>

                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Control
                                                type="number"
                                                value={bedroomFormData[index].price}
                                                // onChange={(e) => handleBedroomPriceChange(e, index, "price")}
                                                placeholder="Price"
                                                disabled={bedroomFormData[index].value ? false : true}
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Control
                                                value={bedroomFormData[index].remark}
                                                onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                as="textarea" rows={1}
                                                placeholder="Remark"
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col sm={1}>
                                            {item.isUserAdded && (
                                              <Button variant="danger" onClick={() => deleteUserAddedBedroomItem(index)}>
                                                <i class="bi bi-x-circle-fill"></i>
                                              </Button>
                                            )}
                                          </Col>
                                        </Row>
                                        : item.measurement == "qty" && item.removed !== true ?
                                          <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Label
                                                  style={{
                                                    fontSize: 16,
                                                    fontWeight: "500",
                                                  }}
                                                > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                </Form.Label>
                                              </Form.Group>
                                            </Col>
                                            {/* <Col sm={2}>
                                            <Form.Group>
                                              <Form.Select
                                                value={bedroomFormData[index].value}
                                                onChange={(e) => handleBedroomOptionChange(e, index)}


                                              >
                                                <option value="0">None</option>
                                                {item.material.map((item2, index2) => (
                                                  <option
                                                    key={index2}
                                                    value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                  >
                                                    {item2.label}
                                                  </option>
                                                ))}

                                              </Form.Select>
                                            </Form.Group>
                                          </Col> */}
                                            {/* add label option */}
                                            <Col sm={2} style={{ display: 'flex' }}>
                                              <Dropdown>
                                                <Dropdown.Toggle
                                                  variant="outline-secondary"
                                                  style={{
                                                    width: '12vw',
                                                    backgroundColor: 'white',
                                                    color: 'black',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    whiteSpace: 'normal',        // Allows text to wrap
                                                    wordBreak: 'break-word',     // Breaks long words
                                                    padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                  }}>
                                                  {formData.label || 'None'}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu style={{ width: 'auto' }}>
                                                  <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0' } }, index)}>
                                                    None
                                                  </Dropdown.Item>
                                                  {item.material.map((item2, index2) => {
                                                    const childList = item2.subMaterials;
                                                    const hasChild = childList && childList.length > 0;

                                                    return (
                                                      <div
                                                        key={index2}
                                                        style={{ position: "relative" }}
                                                        onMouseEnter={() => setHoveredItem(item2.label)}
                                                        onMouseLeave={() => setHoveredItem(null)}
                                                      >
                                                        <Dropdown.Item
                                                          onClick={() => {
                                                            if (!hasChild) {
                                                              handleBedroomOptionChange(
                                                                {
                                                                  target: {
                                                                    value:
                                                                      priceGen === "oldvalue"
                                                                        ? item2.oldvalue
                                                                        : item2.value,
                                                                    label: item2.label,
                                                                  },
                                                                },
                                                                index
                                                              );
                                                            }
                                                          }}
                                                          style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                          }}
                                                        >
                                                          {item2.label}
                                                          {hasChild && <span>▶</span>}
                                                        </Dropdown.Item>

                                                        {/* ✅ Child Dropdown */}
                                                        {hasChild && hoveredItem === item2.label && (
                                                          <div
                                                            style={{
                                                              position: "absolute",
                                                              top: 0,
                                                              left: "100%",
                                                              background: "white",
                                                              border: "1px solid #ddd",
                                                              minWidth: "180px",
                                                              zIndex: 1050,
                                                            }}
                                                          >
                                                            {item2.subMaterials.map((child, childIndex) => (
                                                              <Dropdown.Item
                                                                onClick={() => {
                                                                  handleBedroomOptionChange(
                                                                    {
                                                                      target: {
                                                                        value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                        // value: child.subValue,
                                                                        label: `${item2.label} (${child.subLabel})`,
                                                                      },
                                                                    },
                                                                    index
                                                                  );
                                                                }}
                                                              >
                                                                {child.subLabel}
                                                              </Dropdown.Item>
                                                            ))}
                                                          </div>
                                                        )}
                                                      </div>
                                                    );
                                                  })}

                                                  <Dropdown.Divider />

                                                  <div className="px-3 py-2">
                                                    <Button
                                                      variant="outline-success"
                                                      size="sm"
                                                      onClick={(e) => {
                                                        e.stopPropagation(); // prevent dropdown from closing
                                                        handleAddNewItem(item, 'kitchen', index);
                                                      }}
                                                    >
                                                      <i className="bi bi-plus-square-dotted"></i> Add Item
                                                    </Button>
                                                  </div>
                                                </Dropdown.Menu>
                                              </Dropdown>
                                            </Col>
                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={bedroomFormData[index].qnty === 0 ? '' : bedroomFormData[index].qnty}
                                                  onChange={(e) => handleBedroomChange(e, index, "qnty")}
                                                  placeholder="Qty"
                                                />
                                              </Form.Group>
                                            </Col>

                                            <Col sm={1}>

                                            </Col>

                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={bedroomFormData[index].price}
                                                  // onChange={(e) => handleBedroomPriceChange(e, index, "price")}
                                                  placeholder="Price"
                                                  disabled={bedroomFormData[index].value ? false : true}
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Control
                                                  value={bedroomFormData[index].remark}
                                                  onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                  as="textarea" rows={1}
                                                  placeholder="Remark"
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col sm={1}>
                                              {item.isUserAdded && (
                                                <Button variant="danger" onClick={() => deleteUserAddedBedroomItem(index)}>
                                                  <i class="bi bi-x-circle-fill"></i>
                                                </Button>
                                              )}
                                            </Col>
                                          </Row>
                                          : item.measurement == "length" ?
                                            <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Label
                                                    style={{
                                                      fontSize: 16,
                                                      fontWeight: "500",
                                                    }}
                                                  > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                  </Form.Label>
                                                </Form.Group>
                                              </Col>
                                              {/* <Col sm={2}>
                                              <Form.Group>
                                                <Form.Select
                                                  value={bedroomFormData[index].value}
                                                  onChange={(e) => handleBedroomOptionChange(e, index)}


                                                >
                                                  <option value="0">None</option>
                                                  {item.material.map((item2, index2) => (
                                                    <option
                                                      key={index2}
                                                      value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                    >
                                                      {item2.label}
                                                    </option>
                                                  ))}

                                                </Form.Select>
                                              </Form.Group>
                                            </Col> */}
                                              {/* add label option */}
                                              <Col sm={2} style={{ display: 'flex' }}>
                                                <Dropdown>
                                                  <Dropdown.Toggle
                                                    variant="outline-secondary"
                                                    style={{
                                                      width: '12vw',
                                                      backgroundColor: 'white',
                                                      color: 'black',
                                                      display: 'flex',
                                                      justifyContent: 'space-between',
                                                      alignItems: 'center',
                                                      whiteSpace: 'normal',        // Allows text to wrap
                                                      wordBreak: 'break-word',     // Breaks long words
                                                      padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                    }}>
                                                    {formData.label || 'None'}
                                                  </Dropdown.Toggle>
                                                  <Dropdown.Menu style={{ width: 'auto' }}>
                                                    <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0' } }, index)}>
                                                      None
                                                    </Dropdown.Item>
                                                    {item.material.map((item2, index2) => {
                                                      const childList = item2.subMaterials;
                                                      const hasChild = childList && childList.length > 0;

                                                      return (
                                                        <div
                                                          key={index2}
                                                          style={{ position: "relative" }}
                                                          onMouseEnter={() => setHoveredItem(item2.label)}
                                                          onMouseLeave={() => setHoveredItem(null)}
                                                        >
                                                          <Dropdown.Item
                                                            onClick={() => {
                                                              if (!hasChild) {
                                                                handleBedroomOptionChange(
                                                                  {
                                                                    target: {
                                                                      value:
                                                                        priceGen === "oldvalue"
                                                                          ? item2.oldvalue
                                                                          : item2.value,
                                                                      label: item2.label,
                                                                    },
                                                                  },
                                                                  index
                                                                );
                                                              }
                                                            }}
                                                            style={{
                                                              display: "flex",
                                                              justifyContent: "space-between",
                                                            }}
                                                          >
                                                            {item2.label}
                                                            {hasChild && <span>▶</span>}
                                                          </Dropdown.Item>

                                                          {/* ✅ Child Dropdown */}
                                                          {hasChild && hoveredItem === item2.label && (
                                                            <div
                                                              style={{
                                                                position: "absolute",
                                                                top: 0,
                                                                left: "100%",
                                                                background: "white",
                                                                border: "1px solid #ddd",
                                                                minWidth: "180px",
                                                                zIndex: 1050,
                                                              }}
                                                            >
                                                              {item2.subMaterials.map((child, childIndex) => (
                                                                <Dropdown.Item
                                                                  onClick={() => {
                                                                    handleBedroomOptionChange(
                                                                      {
                                                                        target: {
                                                                          value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                          // value: child.subValue,
                                                                          label: `${item2.label} (${child.subLabel})`,
                                                                        },
                                                                      },
                                                                      index
                                                                    );
                                                                  }}
                                                                >
                                                                  {child.subLabel}
                                                                </Dropdown.Item>
                                                              ))}
                                                            </div>
                                                          )}
                                                        </div>
                                                      );
                                                    })}

                                                    <Dropdown.Divider />

                                                    <div className="px-3 py-2">
                                                      <Button
                                                        variant="outline-success"
                                                        size="sm"
                                                        onClick={(e) => {
                                                          e.stopPropagation(); // prevent dropdown from closing
                                                          handleAddNewItem(item, 'kitchen', index);
                                                        }}
                                                      >
                                                        <i className="bi bi-plus-square-dotted"></i> Add Item
                                                      </Button>
                                                    </div>
                                                  </Dropdown.Menu>
                                                </Dropdown>
                                              </Col>
                                              <Col sm={1}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={bedroomFormData[index].height === 0 ? '' : bedroomFormData[index].height}
                                                    onChange={(e) => handleBedroomChange(e, index, "height")}
                                                    placeholder="Length"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={1}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={bedroomFormData[index].width === 0 ? '' : bedroomFormData[index].width}
                                                    onChange={(e) => handleBedroomChange(e, index, "width")}
                                                    placeholder="Width"
                                                  />
                                                </Form.Group>
                                              </Col>


                                              <Col sm={1}>

                                              </Col>

                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={bedroomFormData[index].price}
                                                    // onChange={(e) => handleBedroomPriceChange(e, index, "price")}
                                                    placeholder="Price"
                                                    disabled={bedroomFormData[index].value ? false : true}
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    value={bedroomFormData[index].remark}
                                                    onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                    as="textarea" rows={1}
                                                    placeholder="Remark"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={1}>
                                                {item.isUserAdded && (
                                                  <Button variant="danger" onClick={() => deleteUserAddedBedroomItem(index)}>
                                                    <i class="bi bi-x-circle-fill"></i>
                                                  </Button>
                                                )}
                                              </Col>
                                            </Row> : item.measurement == "rft" ?
                                              <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Label
                                                      style={{
                                                        fontSize: 16,
                                                        fontWeight: "500",
                                                      }}
                                                    > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                    </Form.Label>
                                                  </Form.Group>
                                                </Col>
                                                {/* <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Select
                                                    value={bedroomFormData[index].value}
                                                    onChange={(e) => handleBedroomOptionChange(e, index)}


                                                  >
                                                    <option value="0">None</option>
                                                    {item.material.map((item2, index2) => (
                                                      <option
                                                        key={index2}
                                                        value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                      >
                                                        {item2.label}
                                                      </option>
                                                    ))}

                                                  </Form.Select>
                                                </Form.Group>
                                              </Col> */}
                                                {/* add label option */}
                                                <Col sm={2} style={{ display: 'flex' }}>
                                                  <Dropdown>
                                                    <Dropdown.Toggle
                                                      variant="outline-secondary"
                                                      style={{
                                                        width: '12vw',
                                                        backgroundColor: 'white',
                                                        color: 'black',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        whiteSpace: 'normal',        // Allows text to wrap
                                                        wordBreak: 'break-word',     // Breaks long words
                                                        padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                      }}>
                                                      {formData.label || 'None'}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu style={{ width: 'auto' }}>
                                                      <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0' } }, index)}>
                                                        None
                                                      </Dropdown.Item>
                                                      {item.material.map((item2, index2) => {
                                                        const childList = item2.subMaterials;
                                                        const hasChild = childList && childList.length > 0;

                                                        return (
                                                          <div
                                                            key={index2}
                                                            style={{ position: "relative" }}
                                                            onMouseEnter={() => setHoveredItem(item2.label)}
                                                            onMouseLeave={() => setHoveredItem(null)}
                                                          >
                                                            <Dropdown.Item
                                                              onClick={() => {
                                                                if (!hasChild) {
                                                                  handleBedroomOptionChange(
                                                                    {
                                                                      target: {
                                                                        value:
                                                                          priceGen === "oldvalue"
                                                                            ? item2.oldvalue
                                                                            : item2.value,
                                                                        label: item2.label,
                                                                      },
                                                                    },
                                                                    index
                                                                  );
                                                                }
                                                              }}
                                                              style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                              }}
                                                            >
                                                              {item2.label}
                                                              {hasChild && <span>▶</span>}
                                                            </Dropdown.Item>

                                                            {/* ✅ Child Dropdown */}
                                                            {hasChild && hoveredItem === item2.label && (
                                                              <div
                                                                style={{
                                                                  position: "absolute",
                                                                  top: 0,
                                                                  left: "100%",
                                                                  background: "white",
                                                                  border: "1px solid #ddd",
                                                                  minWidth: "180px",
                                                                  zIndex: 1050,
                                                                }}
                                                              >
                                                                {item2.subMaterials.map((child, childIndex) => (
                                                                  <Dropdown.Item
                                                                    onClick={() => {
                                                                      handleBedroomOptionChange(
                                                                        {
                                                                          target: {
                                                                            value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                            // value: child.subValue,
                                                                            label: `${item2.label} (${child.subLabel})`,
                                                                          },
                                                                        },
                                                                        index
                                                                      );
                                                                    }}
                                                                  >
                                                                    {child.subLabel}
                                                                  </Dropdown.Item>
                                                                ))}
                                                              </div>
                                                            )}
                                                          </div>
                                                        );
                                                      })}

                                                      <Dropdown.Divider />

                                                      <div className="px-3 py-2">
                                                        <Button
                                                          variant="outline-success"
                                                          size="sm"
                                                          onClick={(e) => {
                                                            e.stopPropagation(); // prevent dropdown from closing
                                                            handleAddNewItem(item, 'kitchen', index);
                                                          }}
                                                        >
                                                          <i className="bi bi-plus-square-dotted"></i> Add Item
                                                        </Button>
                                                      </div>
                                                    </Dropdown.Menu>
                                                  </Dropdown>
                                                </Col>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={bedroomFormData[index].rft === 0 ? '' : bedroomFormData[index].rft}
                                                      onChange={(e) => handleBedroomChange(e, index, "rft")}
                                                      placeholder="RFT"
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={1}>

                                                </Col>

                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={bedroomFormData[index].price}
                                                      // onChange={(e) => handleBedroomPriceChange(e, index, "price")}
                                                      placeholder="Price"
                                                      disabled={bedroomFormData[index].value ? false : true}
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      value={bedroomFormData[index].remark}
                                                      onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                      as="textarea" rows={1}
                                                      placeholder="Remark"
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={1}>
                                                  {item.isUserAdded && (
                                                    <Button variant="danger" onClick={() => deleteUserAddedBedroomItem(index)}>
                                                      <i class="bi bi-x-circle-fill"></i>
                                                    </Button>
                                                  )}
                                                </Col>
                                              </Row> : item.measurement == "door" ?
                                                <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Label
                                                        style={{
                                                          fontSize: 16,
                                                          fontWeight: "500",
                                                        }}
                                                      > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                      </Form.Label>
                                                    </Form.Group>
                                                  </Col>
                                                  {/* <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Select
                                                      value={bedroomFormData[index].value}
                                                      onChange={(e) => handleBedroomOptionChange(e, index)}


                                                    >
                                                      <option value="0">None</option>
                                                      {item.material.map((item2, index2) => (
                                                        <option
                                                          key={index2}
                                                          value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                        >
                                                          {item2.label}
                                                        </option>
                                                      ))}

                                                    </Form.Select>
                                                  </Form.Group>
                                                </Col> */}
                                                  {/* add label option */}
                                                  <Col sm={2} style={{ display: 'flex' }}>
                                                    <Dropdown>
                                                      <Dropdown.Toggle
                                                        variant="outline-secondary"
                                                        style={{
                                                          width: '12vw',
                                                          backgroundColor: 'white',
                                                          color: 'black',
                                                          display: 'flex',
                                                          justifyContent: 'space-between',
                                                          alignItems: 'center',
                                                          whiteSpace: 'normal',        // Allows text to wrap
                                                          wordBreak: 'break-word',     // Breaks long words
                                                          padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                        }}>
                                                        {formData.label || 'None'}
                                                      </Dropdown.Toggle>
                                                      <Dropdown.Menu style={{ width: 'auto' }}>
                                                        <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0' } }, index)}>
                                                          None
                                                        </Dropdown.Item>
                                                        {item.material.map((item2, index2) => {
                                                          const childList = item2.subMaterials;
                                                          const hasChild = childList && childList.length > 0;

                                                          return (
                                                            <div
                                                              key={index2}
                                                              style={{ position: "relative" }}
                                                              onMouseEnter={() => setHoveredItem(item2.label)}
                                                              onMouseLeave={() => setHoveredItem(null)}
                                                            >
                                                              <Dropdown.Item
                                                                onClick={() => {
                                                                  if (!hasChild) {
                                                                    handleBedroomOptionChange(
                                                                      {
                                                                        target: {
                                                                          value:
                                                                            priceGen === "oldvalue"
                                                                              ? item2.oldvalue
                                                                              : item2.value,
                                                                          label: item2.label,
                                                                        },
                                                                      },
                                                                      index
                                                                    );
                                                                  }
                                                                }}
                                                                style={{
                                                                  display: "flex",
                                                                  justifyContent: "space-between",
                                                                }}
                                                              >
                                                                {item2.label}
                                                                {hasChild && <span>▶</span>}
                                                              </Dropdown.Item>

                                                              {/* ✅ Child Dropdown */}
                                                              {hasChild && hoveredItem === item2.label && (
                                                                <div
                                                                  style={{
                                                                    position: "absolute",
                                                                    top: 0,
                                                                    left: "100%",
                                                                    background: "white",
                                                                    border: "1px solid #ddd",
                                                                    minWidth: "180px",
                                                                    zIndex: 1050,
                                                                  }}
                                                                >
                                                                  {item2.subMaterials.map((child, childIndex) => (
                                                                    <Dropdown.Item
                                                                      onClick={() => {
                                                                        handleBedroomOptionChange(
                                                                          {
                                                                            target: {
                                                                              value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                              // value: child.subValue,
                                                                              label: `${item2.label} (${child.subLabel})`,
                                                                            },
                                                                          },
                                                                          index
                                                                        );
                                                                      }}
                                                                    >
                                                                      {child.subLabel}
                                                                    </Dropdown.Item>
                                                                  ))}
                                                                </div>
                                                              )}
                                                            </div>
                                                          );
                                                        })}

                                                        <Dropdown.Divider />

                                                        <div className="px-3 py-2">
                                                          <Button
                                                            variant="outline-success"
                                                            size="sm"
                                                            onClick={(e) => {
                                                              e.stopPropagation(); // prevent dropdown from closing
                                                              handleAddNewItem(item, 'kitchen', index);
                                                            }}
                                                          >
                                                            <i className="bi bi-plus-square-dotted"></i> Add Item
                                                          </Button>
                                                        </div>
                                                      </Dropdown.Menu>
                                                    </Dropdown>
                                                  </Col>
                                                  <Col sm={1}>
                                                    <Form.Group>
                                                      <Form.Select
                                                        value={bedroomFormData[index].value2}
                                                        onChange={(e) => handleBedroomOption2Change(e, index)}

                                                        disabled={bedroomFormData[index].price == 0 ? true : false}
                                                      >
                                                        <option value="0">None</option>
                                                        {item.door.map((item3, index3) => (
                                                          <option value={item3.value} key={index3}>{item3.label}</option>
                                                        ))}

                                                      </Form.Select>
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={1}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={bedroomFormData[index].width === 0 ? '' : bedroomFormData[index].width}
                                                        onChange={(e) => handleBedroomChange(e, index, "width")}
                                                        placeholder="Width"
                                                      />
                                                    </Form.Group>
                                                  </Col>

                                                  <Col sm={1}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={bedroomFormData[index].height === 0 ? '' : bedroomFormData[index].height}
                                                        onChange={(e) => handleBedroomChange(e, index, "height")}
                                                        placeholder="Height"
                                                      />
                                                    </Form.Group>
                                                  </Col>

                                                  <Col sm={1}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={bedroomFormData[index].qnty === 0 ? '' : bedroomFormData[index].qnty}
                                                        onChange={(e) => handleBedroomChange(e, index, "qnty")}
                                                        placeholder="Qty"
                                                      />
                                                    </Form.Group>
                                                  </Col>

                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={bedroomFormData[index].price}
                                                        // onChange={(e) => handleBedroomPriceChange(e, index, "price")}
                                                        placeholder="Price"
                                                        disabled={bedroomFormData[index].value ? false : true}
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        value={bedroomFormData[index].remark}
                                                        onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                        as="textarea" rows={1}
                                                        placeholder="Remark"
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                </Row> : item.measurement == "selection" ?
                                                  <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Label
                                                          style={{
                                                            fontSize: 16,
                                                            fontWeight: "500",
                                                          }}
                                                        >
                                                          <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                        </Form.Label>
                                                      </Form.Group>
                                                    </Col>


                                                    {/* add label option */}
                                                    <Col sm={2} style={{ display: 'flex' }}>
                                                      <Dropdown>
                                                        <Dropdown.Toggle
                                                          variant="outline-secondary"
                                                          style={{
                                                            width: '12vw',
                                                            backgroundColor: 'white',
                                                            color: 'black',
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            whiteSpace: 'normal',        // Allows text to wrap
                                                            wordBreak: 'break-word',     // Breaks long words
                                                            padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                          }}>
                                                          {formData.label || 'None'}
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu style={{ width: 'auto' }}>
                                                          <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0' } }, index)}>
                                                            None
                                                          </Dropdown.Item>
                                                          {item.material.map((item2, index2) => {
                                                            const childList = item2.subMaterials;
                                                            const hasChild = childList && childList.length > 0;

                                                            return (
                                                              <div
                                                                key={index2}
                                                                style={{ position: "relative" }}
                                                                onMouseEnter={() => setHoveredItem(item2.label)}
                                                                onMouseLeave={() => setHoveredItem(null)}
                                                              >
                                                                <Dropdown.Item
                                                                  onClick={() => {
                                                                    if (!hasChild) {
                                                                      handleBedroomOptionChange(
                                                                        {
                                                                          target: {
                                                                            value:
                                                                              priceGen === "oldvalue"
                                                                                ? item2.oldvalue
                                                                                : item2.value,
                                                                            label: item2.label,
                                                                          },
                                                                        },
                                                                        index
                                                                      );
                                                                    }
                                                                  }}
                                                                  style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                  }}
                                                                >
                                                                  {item2.label}
                                                                  {hasChild && <span>▶</span>}
                                                                </Dropdown.Item>

                                                                {/* ✅ Child Dropdown */}
                                                                {hasChild && hoveredItem === item2.label && (
                                                                  <div
                                                                    style={{
                                                                      position: "absolute",
                                                                      top: 0,
                                                                      left: "100%",
                                                                      background: "white",
                                                                      border: "1px solid #ddd",
                                                                      minWidth: "180px",
                                                                      zIndex: 1050,
                                                                    }}
                                                                  >
                                                                    {item2.subMaterials.map((child, childIndex) => (
                                                                      <Dropdown.Item
                                                                        onClick={() => {
                                                                          handleBedroomOptionChange(
                                                                            {
                                                                              target: {
                                                                                value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                // value: child.subValue,
                                                                                label: `${item2.label} (${child.subLabel})`,
                                                                              },
                                                                            },
                                                                            index
                                                                          );
                                                                        }}
                                                                      >
                                                                        {child.subLabel}
                                                                      </Dropdown.Item>
                                                                    ))}
                                                                  </div>
                                                                )}
                                                              </div>
                                                            );
                                                          })}

                                                          <Dropdown.Divider />

                                                          <div className="px-3 py-2">
                                                            <Button
                                                              variant="outline-success"
                                                              size="sm"
                                                              onClick={(e) => {
                                                                e.stopPropagation(); // prevent dropdown from closing
                                                                handleAddNewItem(item, 'kitchen', index);
                                                              }}
                                                            >
                                                              <i className="bi bi-plus-square-dotted"></i> Add Item
                                                            </Button>
                                                          </div>
                                                        </Dropdown.Menu>
                                                      </Dropdown>
                                                    </Col>


                                                    <Col sm={2}>

                                                    </Col>

                                                    <Col sm={1}>

                                                    </Col>

                                                    <Col sm={2}>

                                                    </Col>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          value={bedroomFormData[index].remark}
                                                          onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                          as="textarea" rows={1}
                                                          placeholder="Remark"
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={1}>
                                                      {item.isUserAdded && (
                                                        <Button variant="danger" onClick={() => deleteUserAddedBedroomItem(index)}>
                                                          <i class="bi bi-x-circle-fill"></i>
                                                        </Button>
                                                      )}
                                                    </Col>
                                                  </Row> : item.measurement == "depth" ?
                                                    <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Label
                                                            style={{
                                                              fontSize: 16,
                                                              fontWeight: "500",
                                                            }}
                                                          > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                          </Form.Label>
                                                        </Form.Group>
                                                      </Col>

                                                      {/* add label option */}
                                                      <Col sm={2} style={{ display: 'flex' }}>
                                                        <Dropdown>
                                                          <Dropdown.Toggle
                                                            variant="outline-secondary"
                                                            style={{
                                                              width: '12vw',
                                                              backgroundColor: 'white',
                                                              color: 'black',
                                                              display: 'flex',
                                                              justifyContent: 'space-between',
                                                              alignItems: 'center',
                                                              whiteSpace: 'normal',        // Allows text to wrap
                                                              wordBreak: 'break-word',     // Breaks long words
                                                              padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                            }}>
                                                            {formData.label || 'None'}
                                                          </Dropdown.Toggle>
                                                          <Dropdown.Menu style={{ width: 'auto' }}>
                                                            <Dropdown.Item onClick={() => handleBedroomOptionChange({ target: { value: '0' } }, index)}>
                                                              None
                                                            </Dropdown.Item>
                                                            {item.material.map((item2, index2) => {
                                                              const childList = item2.subMaterials;
                                                              const hasChild = childList && childList.length > 0;

                                                              return (
                                                                <div
                                                                  key={index2}
                                                                  style={{ position: "relative" }}
                                                                  onMouseEnter={() => setHoveredItem(item2.label)}
                                                                  onMouseLeave={() => setHoveredItem(null)}
                                                                >
                                                                  <Dropdown.Item
                                                                    onClick={() => {
                                                                      if (!hasChild) {
                                                                        handleBedroomOptionChange(
                                                                          {
                                                                            target: {
                                                                              value:
                                                                                priceGen === "oldvalue"
                                                                                  ? item2.oldvalue
                                                                                  : item2.value,
                                                                              label: item2.label,
                                                                            },
                                                                          },
                                                                          index
                                                                        );
                                                                      }
                                                                    }}
                                                                    style={{
                                                                      display: "flex",
                                                                      justifyContent: "space-between",
                                                                    }}
                                                                  >
                                                                    {item2.label}
                                                                    {hasChild && <span>▶</span>}
                                                                  </Dropdown.Item>

                                                                  {/* ✅ Child Dropdown */}
                                                                  {hasChild && hoveredItem === item2.label && (
                                                                    <div
                                                                      style={{
                                                                        position: "absolute",
                                                                        top: 0,
                                                                        left: "100%",
                                                                        background: "white",
                                                                        border: "1px solid #ddd",
                                                                        minWidth: "180px",
                                                                        zIndex: 1050,
                                                                      }}
                                                                    >
                                                                      {item2.subMaterials.map((child, childIndex) => (
                                                                        <Dropdown.Item
                                                                          onClick={() => {
                                                                            handleBedroomOptionChange(
                                                                              {
                                                                                target: {
                                                                                  value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                  // value: child.subValue,
                                                                                  label: `${item2.label} (${child.subLabel})`,
                                                                                },
                                                                              },
                                                                              index
                                                                            );
                                                                          }}
                                                                        >
                                                                          {child.subLabel}
                                                                        </Dropdown.Item>
                                                                      ))}
                                                                    </div>
                                                                  )}
                                                                </div>
                                                              );
                                                            })}

                                                            <Dropdown.Divider />

                                                            <div className="px-3 py-2">
                                                              <Button
                                                                variant="outline-success"
                                                                size="sm"
                                                                onClick={(e) => {
                                                                  e.stopPropagation(); // prevent dropdown from closing
                                                                  handleAddNewItem(item, 'kitchen', index);
                                                                }}
                                                              >
                                                                <i className="bi bi-plus-square-dotted"></i> Add Item
                                                              </Button>
                                                            </div>
                                                          </Dropdown.Menu>
                                                        </Dropdown>
                                                      </Col>
                                                      <Col sm={1}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={bedroomFormData[index].width === 0 ? '' : bedroomFormData[index].width}
                                                            onChange={(e) => handleBedroomChange(e, index, "width")}
                                                            placeholder="Length"
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={1}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={bedroomFormData[index].height === 0 ? '' : bedroomFormData[index].height}
                                                            onChange={(e) => handleBedroomChange(e, index, "height")}
                                                            placeholder="Height"
                                                          />
                                                        </Form.Group>
                                                      </Col>



                                                      <Col sm={1}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={bedroomFormData[index].depth === 0 ? '' : bedroomFormData[index].depth}
                                                            onChange={(e) => handleBedroomChange(e, index, "depth")}
                                                            placeholder="Depth"
                                                          />
                                                        </Form.Group>
                                                      </Col>

                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={bedroomFormData[index].price}
                                                            // onChange={(e) => handleBedroomPriceChange(e, index, "price")}
                                                            placeholder="Price"
                                                            disabled={bedroomFormData[index].value ? false : true}
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            value={bedroomFormData[index].remark}
                                                            onChange={(e) => handleBedroomRemarkChange(e, index, "remark")}
                                                            as="textarea" rows={1}
                                                            placeholder="Remark"
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={1}>
                                                        {item.isUserAdded && (
                                                          <Button variant="danger" onClick={() => deleteUserAddedBedroomItem(index)}>
                                                            <i class="bi bi-x-circle-fill"></i>
                                                          </Button>
                                                        )}
                                                      </Col>
                                                    </Row> : null
                                  ))}


                              </Col>
                            </Row>
                            <Row>
                              <Col>

                                <Row className="mx-1 my-3">
                                  <Col sm={2}>
                                    <Form.Group >
                                      <Form.Control
                                        value={extraItemName}
                                        onChange={(e) => setExtraItemName(e.target.value)}
                                        type="text"
                                        placeholder="Item Name"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col sm={2}>
                                    <Form.Group >
                                      <Form.Control
                                        value={extraItemMaterialName}
                                        onChange={(e) => setExtraItemMaterialName(e.target.value)}
                                        type="text"
                                        placeholder="Material Name"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col sm={2}>
                                    <Form.Group >
                                      <Form.Control
                                        value={extraItemMaterialValue}
                                        onChange={(e) => setExtraItemMaterialValue(e.target.value)}
                                        type="number"
                                        placeholder="Material Value"
                                      />
                                    </Form.Group>
                                  </Col>

                                  <Col sm={3}>
                                    <Form.Select value={extraItemMeasure} onChange={(e) => { setExtraItemMeasure(e.currentTarget.value) }} >
                                      <option>Select Measurement Type</option>
                                      <option value="area">Area</option>
                                      <option value="width">Width, Height & Qty</option>
                                      <option value="rft">RFT</option>
                                      <option value="qty">Quantity</option>
                                      <option value="length">Width & Length</option>
                                      <option value="selection">Selection</option>
                                    </Form.Select>
                                  </Col>

                                  <Col sm={1}>
                                    <Form.Check
                                      inline
                                      label="Wood"
                                      name="Wood"
                                      type="checkbox"
                                      id="inline-checkbox-1"
                                      checked={isChecked}
                                      onChange={handleCheckboxChange}
                                    />
                                  </Col>
                                  <Col sm={2}>
                                    <Button onClick={addNewBedroomItem}>Add Item</Button>
                                  </Col>
                                </Row>





                              </Col>

                            </Row>
                          </Form.Group>


                        </Form>


                      </Col>
                    </Row>

                    <Row style={{
                      // marginBottom: '50px',
                      marginLeft: '1px',
                      padding: '20px',
                      borderRadius: '15px',
                      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                      backgroundColor: '#ffffff', // Light background color


                    }} >
                      <Col style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        gap: '12px',
                      }}>
                        <Button className="buttonDesign" style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold" }} onClick={handleCategoryGoBack} >Go Back</Button>
                        {Boolean(restored) && (
                        <Button style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold", backgroundColor: '#fee2e2', color: '#dc2626', border: '1px solid #fca5a5' }} onClick={handleDiscardDraft} disabled={isDiscarding}>{isDiscarding ? "Discarding..." : "Discard Draft"}</Button>
                      )}
                        <Button className="buttonDesign" style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold" }} disabled={isSaving} onClick={calculateTotalPricesBeforeSave} >{isSaving ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Saving...</> : "Save"}</Button>
                      </Col>
                      <Col className="col-sm-3">

                      </Col>
                      <Col className="col-sm-2"><h4>Total Price</h4></Col>
                      <Col className="col-sm-2">
                        {/* <h4>
                        Rs:- {roomTypePrice}

                      </h4> */}
                        <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{roomTypePrice}</h4></span>
                      </Col>
                    </Row>

                  </Row> : roomTypeModal == 'Foyer' ?
                    <Row className="p-2" style={{
                      marginBottom: '50px',

                      padding: '20px',
                      marginLeft: '20px',
                      borderRadius: '15px',
                      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                      backgroundColor: '#ffffff', // Light background color

                    }} >


                      <div style={{
                        display: "flex",
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '1rem'
                      }}>
                        <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} >
                          <h5>Foyer -- </h5>
                          <h6 style={{ color: '#e85d13', margin: 0 }}>{priceGen === 'value' ? 'New Value' : 'Old Value'}</h6>
                          {Boolean(restored) && draftSaveStatus && (
                            <span style={{ fontSize: "11px", fontWeight: "600", color: draftSaveStatus.includes('Error') ? "#ef4444" : "#15803d", backgroundColor: draftSaveStatus.includes('Error') ? "#fef2f2" : "#f0fdf4", padding: "2px 8px", borderRadius: "12px", border: `1px solid ${draftSaveStatus.includes('Error') ? "#fecaca" : "#bbf7d0"}` }}>
                              {draftSaveStatus}
                            </span>
                          )}
                        </span>

                        <div>
                          <InputGroup>
                            <Form.Control
                              style={{
                                borderRadius: "15px",
                                padding: "12px 15px",
                                border: "1px solid #d1d5db",
                                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                                transition: "all 0.3s ease",
                                width: "20vw",
                              }}
                              onChange={(e) => setSearch(e.target.value)}
                              placeholder="Search Labels"
                            />
                          </InputGroup>
                        </div>
                      </div>


                      <Row style={{
                        backgroundColor: "#F2F2F2",
                        height: 'auto',
                        marginLeft: '5px',
                        overflowY: 'auto',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                        borderRadius: '15px',
                        padding: '0 0 0 10px',
                      }}>
                        <Col style={{ minHeight: 380, maxHeight: 480 }}>

                          <Form>

                            <Form.Group>
                              <Row>

                                <Col sm={12}>

                                  {foyerThingsDataCopy
                                    .map((item, index) => ({ item, formData: foyerFormData[index], index }))
                                    .filter(({ item }) => {
                                      const searchQuery = search.toLowerCase();
                                      return searchQuery === '' || item.name.toLowerCase().includes(searchQuery);
                                    })
                                    .map(({ item, formData, index }) => (
                                      item.measurement == "area" ?
                                        <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Label
                                                style={{
                                                  fontSize: 16,
                                                  fontWeight: "500",
                                                }}
                                              > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                              </Form.Label>
                                            </Form.Group>
                                          </Col>
                                          {/* <Col sm={2}>
                                          <Form.Group>
                                            <Form.Select
                                              value={foyerFormData[index].value}
                                              onChange={(e) => handleFoyerOptionChange(e, index)}


                                            >
                                              <option value="0">None</option>
                                              {item.material.map((item2, index2) => (
                                                <option
                                                  key={index2}
                                                  value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                >
                                                  {item2.label}
                                                </option>
                                              ))}

                                            </Form.Select>
                                          </Form.Group>
                                        </Col> */}
                                          {/* add label option */}
                                          <Col sm={2} style={{ display: 'flex' }}>
                                            <Dropdown>
                                              <Dropdown.Toggle
                                                variant="outline-secondary"
                                                style={{
                                                  width: '12vw',
                                                  backgroundColor: 'white',
                                                  color: 'black',
                                                  display: 'flex',
                                                  justifyContent: 'space-between',
                                                  alignItems: 'center',
                                                  whiteSpace: 'normal',        // Allows text to wrap
                                                  wordBreak: 'break-word',     // Breaks long words
                                                  padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                }}>
                                                {formData.label || 'None'}
                                              </Dropdown.Toggle>
                                              <Dropdown.Menu style={{ width: 'auto' }}>
                                                <Dropdown.Item onClick={() => handleFoyerOptionChange({ target: { value: '0' } }, index)}>
                                                  None
                                                </Dropdown.Item>
                                                {item.material.map((item2, index2) => {
                                                  const childList = item2.subMaterials;
                                                  const hasChild = childList && childList.length > 0;

                                                  return (
                                                    <div
                                                      key={index2}
                                                      style={{ position: "relative" }}
                                                      onMouseEnter={() => setHoveredItem(item2.label)}
                                                      onMouseLeave={() => setHoveredItem(null)}
                                                    >
                                                      <Dropdown.Item
                                                        onClick={() => {
                                                          if (!hasChild) {
                                                            handleFoyerOptionChange(
                                                              {
                                                                target: {
                                                                  value:
                                                                    priceGen === "oldvalue"
                                                                      ? item2.oldvalue
                                                                      : item2.value,
                                                                  label: item2.label,
                                                                },
                                                              },
                                                              index
                                                            );
                                                          }
                                                        }}
                                                        style={{
                                                          display: "flex",
                                                          justifyContent: "space-between",
                                                        }}
                                                      >
                                                        {item2.label}
                                                        {hasChild && <span>▶</span>}
                                                      </Dropdown.Item>

                                                      {/* ✅ Child Dropdown */}
                                                      {hasChild && hoveredItem === item2.label && (
                                                        <div
                                                          style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: "100%",
                                                            background: "white",
                                                            border: "1px solid #ddd",
                                                            minWidth: "180px",
                                                            zIndex: 1050,
                                                          }}
                                                        >
                                                          {item2.subMaterials.map((child, childIndex) => (
                                                            <Dropdown.Item
                                                              onClick={() => {
                                                                handleFoyerOptionChange(
                                                                  {
                                                                    target: {
                                                                      value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                      // value: child.subValue,
                                                                      label: `${item2.label} (${child.subLabel})`,
                                                                    },
                                                                  },
                                                                  index
                                                                );
                                                              }}
                                                            >
                                                              {child.subLabel}
                                                            </Dropdown.Item>
                                                          ))}
                                                        </div>
                                                      )}
                                                    </div>
                                                  );
                                                })}

                                                <Dropdown.Divider />

                                                <div className="px-3 py-2">
                                                  <Button
                                                    variant="outline-success"
                                                    size="sm"
                                                    onClick={(e) => {
                                                      e.stopPropagation(); // prevent dropdown from closing
                                                      handleAddNewItem(item, 'kitchen', index);
                                                    }}
                                                  >
                                                    <i className="bi bi-plus-square-dotted"></i> Add Item
                                                  </Button>
                                                </div>
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          </Col>
                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Control
                                                type="number"
                                                value={foyerFormData[index].area === 0 ? '' : foyerFormData[index].area}
                                                onChange={(e) => handleFoyerChange(e, index, "area")}
                                                placeholder="Area"
                                              />
                                            </Form.Group>
                                          </Col>

                                          <Col sm={1}>

                                          </Col>

                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Control
                                                type="number"
                                                value={foyerFormData[index].price}
                                                // onChange={(e) => handleFoyerPriceChange(e, index, "price")}
                                                placeholder="Price"
                                                disabled={foyerFormData[index].value ? false : true}
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col sm={2}>
                                            <Form.Group>
                                              <Form.Control
                                                value={foyerFormData[index].remark}
                                                onChange={(e) => handleFoyerRemarkChange(e, index, "remark")}
                                                as="textarea" rows={1}
                                                placeholder="Remark"
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col sm={1}>
                                            {item.isUserAdded && (
                                              <Button variant="danger" onClick={() => deleteUserAddedFoyerItem(index)}>
                                                <i class="bi bi-x-circle-fill"></i>
                                              </Button>
                                            )}
                                          </Col>
                                        </Row>
                                        : item.measurement == "width" ?
                                          <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Label
                                                  style={{
                                                    fontSize: 16,
                                                    fontWeight: "500",
                                                  }}
                                                > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                </Form.Label>
                                              </Form.Group>
                                            </Col>
                                            {/* <Col sm={2}>
                                            <Form.Group>
                                              <Form.Select
                                                value={foyerFormData[index].value}
                                                onChange={(e) => handleFoyerOptionChange(e, index)}


                                              >
                                                <option value="0">None</option>
                                                {item.material.map((item2, index2) => (
                                                  <option
                                                    key={index2}
                                                    value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                  >
                                                    {item2.label}
                                                  </option>
                                                ))}

                                              </Form.Select>
                                            </Form.Group>
                                          </Col> */}
                                            {/* add label option */}
                                            <Col sm={2} style={{ display: 'flex' }}>
                                              <Dropdown>
                                                <Dropdown.Toggle
                                                  variant="outline-secondary"
                                                  style={{
                                                    width: '12vw',
                                                    backgroundColor: 'white',
                                                    color: 'black',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    whiteSpace: 'normal',        // Allows text to wrap
                                                    wordBreak: 'break-word',     // Breaks long words
                                                    padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                  }}>
                                                  {formData.label || 'None'}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu style={{ width: 'auto' }}>
                                                  <Dropdown.Item onClick={() => handleFoyerOptionChange({ target: { value: '0' } }, index)}>
                                                    None
                                                  </Dropdown.Item>
                                                  {item.material.map((item2, index2) => {
                                                    const childList = item2.subMaterials;
                                                    const hasChild = childList && childList.length > 0;

                                                    return (
                                                      <div
                                                        key={index2}
                                                        style={{ position: "relative" }}
                                                        onMouseEnter={() => setHoveredItem(item2.label)}
                                                        onMouseLeave={() => setHoveredItem(null)}
                                                      >
                                                        <Dropdown.Item
                                                          onClick={() => {
                                                            if (!hasChild) {
                                                              handleFoyerOptionChange(
                                                                {
                                                                  target: {
                                                                    value:
                                                                      priceGen === "oldvalue"
                                                                        ? item2.oldvalue
                                                                        : item2.value,
                                                                    label: item2.label,
                                                                  },
                                                                },
                                                                index
                                                              );
                                                            }
                                                          }}
                                                          style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                          }}
                                                        >
                                                          {item2.label}
                                                          {hasChild && <span>▶</span>}
                                                        </Dropdown.Item>

                                                        {/* ✅ Child Dropdown */}
                                                        {hasChild && hoveredItem === item2.label && (
                                                          <div
                                                            style={{
                                                              position: "absolute",
                                                              top: 0,
                                                              left: "100%",
                                                              background: "white",
                                                              border: "1px solid #ddd",
                                                              minWidth: "180px",
                                                              zIndex: 1050,
                                                            }}
                                                          >
                                                            {item2.subMaterials.map((child, childIndex) => (
                                                              <Dropdown.Item
                                                                onClick={() => {
                                                                  handleFoyerOptionChange(
                                                                    {
                                                                      target: {
                                                                        value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                        // value: child.subValue,
                                                                        label: `${item2.label} (${child.subLabel})`,
                                                                      },
                                                                    },
                                                                    index
                                                                  );
                                                                }}
                                                              >
                                                                {child.subLabel}
                                                              </Dropdown.Item>
                                                            ))}
                                                          </div>
                                                        )}
                                                      </div>
                                                    );
                                                  })}

                                                  <Dropdown.Divider />

                                                  <div className="px-3 py-2">
                                                    <Button
                                                      variant="outline-success"
                                                      size="sm"
                                                      onClick={(e) => {
                                                        e.stopPropagation(); // prevent dropdown from closing
                                                        handleAddNewItem(item, 'kitchen', index);
                                                      }}
                                                    >
                                                      <i className="bi bi-plus-square-dotted"></i> Add Item
                                                    </Button>
                                                  </div>
                                                </Dropdown.Menu>
                                              </Dropdown>
                                            </Col>
                                            <Col sm={1}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={foyerFormData[index].width === 0 ? '' : foyerFormData[index].width}
                                                  onChange={(e) => handleFoyerChange(e, index, "width")}
                                                  placeholder="Width"
                                                />
                                              </Form.Group>
                                            </Col>

                                            <Col sm={1}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={foyerFormData[index].height === 0 ? '' : foyerFormData[index].height}
                                                  onChange={(e) => handleFoyerChange(e, index, "height")}
                                                  placeholder="Height"
                                                />
                                              </Form.Group>
                                            </Col>

                                            <Col sm={1}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={foyerFormData[index].qnty === 0 ? '' : foyerFormData[index].qnty}
                                                  onChange={(e) => handleFoyerChange(e, index, "qnty")}
                                                  placeholder="Qty"
                                                />
                                              </Form.Group>
                                            </Col>

                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={foyerFormData[index].price}
                                                  // onChange={(e) => handleFoyerPriceChange(e, index, "price")}
                                                  placeholder="Price"
                                                  disabled={foyerFormData[index].value ? false : true}
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Control
                                                  value={foyerFormData[index].remark}
                                                  onChange={(e) => handleFoyerRemarkChange(e, index, "remark")}
                                                  as="textarea" rows={1}
                                                  placeholder="Remark"
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col sm={1}>
                                              {item.isUserAdded && (
                                                <Button variant="danger" onClick={() => deleteUserAddedFoyerItem(index)}>
                                                  <i class="bi bi-x-circle-fill"></i>
                                                </Button>
                                              )}
                                            </Col>
                                          </Row>
                                          : item.measurement == "qty" && item.removed !== true ?
                                            <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Label
                                                    style={{
                                                      fontSize: 16,
                                                      fontWeight: "500",
                                                    }}
                                                  > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                  </Form.Label>
                                                </Form.Group>
                                              </Col>
                                              {/* <Col sm={2}>
                                              <Form.Group>
                                                <Form.Select
                                                  value={foyerFormData[index].value}
                                                  onChange={(e) => handleFoyerOptionChange(e, index)}


                                                >
                                                  <option value="0">None</option>
                                                  {item.material.map((item2, index2) => (
                                                    <option
                                                      key={index2}
                                                      value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                    >
                                                      {item2.label}
                                                    </option>
                                                  ))}

                                                </Form.Select>
                                              </Form.Group>
                                            </Col> */}
                                              {/* add label option */}
                                              <Col sm={2} style={{ display: 'flex' }}>
                                                <Dropdown>
                                                  <Dropdown.Toggle
                                                    variant="outline-secondary"
                                                    style={{
                                                      width: '12vw',
                                                      backgroundColor: 'white',
                                                      color: 'black',
                                                      display: 'flex',
                                                      justifyContent: 'space-between',
                                                      alignItems: 'center',
                                                      whiteSpace: 'normal',        // Allows text to wrap
                                                      wordBreak: 'break-word',     // Breaks long words
                                                      padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                    }}>
                                                    {formData.label || 'None'}
                                                  </Dropdown.Toggle>
                                                  <Dropdown.Menu style={{ width: 'auto' }}>
                                                    <Dropdown.Item onClick={() => handleFoyerOptionChange({ target: { value: '0' } }, index)}>
                                                      None
                                                    </Dropdown.Item>
                                                    {item.material.map((item2, index2) => {
                                                      const childList = item2.subMaterials;
                                                      const hasChild = childList && childList.length > 0;

                                                      return (
                                                        <div
                                                          key={index2}
                                                          style={{ position: "relative" }}
                                                          onMouseEnter={() => setHoveredItem(item2.label)}
                                                          onMouseLeave={() => setHoveredItem(null)}
                                                        >
                                                          <Dropdown.Item
                                                            onClick={() => {
                                                              if (!hasChild) {
                                                                handleFoyerOptionChange(
                                                                  {
                                                                    target: {
                                                                      value:
                                                                        priceGen === "oldvalue"
                                                                          ? item2.oldvalue
                                                                          : item2.value,
                                                                      label: item2.label,
                                                                    },
                                                                  },
                                                                  index
                                                                );
                                                              }
                                                            }}
                                                            style={{
                                                              display: "flex",
                                                              justifyContent: "space-between",
                                                            }}
                                                          >
                                                            {item2.label}
                                                            {hasChild && <span>▶</span>}
                                                          </Dropdown.Item>

                                                          {/* ✅ Child Dropdown */}
                                                          {hasChild && hoveredItem === item2.label && (
                                                            <div
                                                              style={{
                                                                position: "absolute",
                                                                top: 0,
                                                                left: "100%",
                                                                background: "white",
                                                                border: "1px solid #ddd",
                                                                minWidth: "180px",
                                                                zIndex: 1050,
                                                              }}
                                                            >
                                                              {item2.subMaterials.map((child, childIndex) => (
                                                                <Dropdown.Item
                                                                  onClick={() => {
                                                                    handleFoyerOptionChange(
                                                                      {
                                                                        target: {
                                                                          value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                          // value: child.subValue,
                                                                          label: `${item2.label} (${child.subLabel})`,
                                                                        },
                                                                      },
                                                                      index
                                                                    );
                                                                  }}
                                                                >
                                                                  {child.subLabel}
                                                                </Dropdown.Item>
                                                              ))}
                                                            </div>
                                                          )}
                                                        </div>
                                                      );
                                                    })}

                                                    <Dropdown.Divider />

                                                    <div className="px-3 py-2">
                                                      <Button
                                                        variant="outline-success"
                                                        size="sm"
                                                        onClick={(e) => {
                                                          e.stopPropagation(); // prevent dropdown from closing
                                                          handleAddNewItem(item, 'kitchen', index);
                                                        }}
                                                      >
                                                        <i className="bi bi-plus-square-dotted"></i> Add Item
                                                      </Button>
                                                    </div>
                                                  </Dropdown.Menu>
                                                </Dropdown>
                                              </Col>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={foyerFormData[index].qnty === 0 ? '' : foyerFormData[index].qnty}
                                                    onChange={(e) => handleFoyerChange(e, index, "qnty")}
                                                    placeholder="Qty"
                                                  />
                                                </Form.Group>
                                              </Col>

                                              <Col sm={1}>

                                              </Col>

                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={foyerFormData[index].price}
                                                    // onChange={(e) => handleFoyerPriceChange(e, index, "price")}
                                                    placeholder="Price"
                                                    disabled={foyerFormData[index].value ? false : true}
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    value={foyerFormData[index].remark}
                                                    onChange={(e) => handleFoyerRemarkChange(e, index, "remark")}
                                                    as="textarea" rows={1}
                                                    placeholder="Remark"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={1}>
                                                {item.isUserAdded && (
                                                  <Button variant="danger" onClick={() => deleteUserAddedFoyerItem(index)}>
                                                    <i class="bi bi-x-circle-fill"></i>
                                                  </Button>
                                                )}
                                              </Col>
                                            </Row>
                                            : item.measurement == "length" ?
                                              <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Label
                                                      style={{
                                                        fontSize: 16,
                                                        fontWeight: "500",
                                                      }}
                                                    > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                    </Form.Label>
                                                  </Form.Group>
                                                </Col>
                                                {/* <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Select
                                                    value={foyerFormData[index].value}
                                                    onChange={(e) => handleFoyerOptionChange(e, index)}


                                                  >
                                                    <option value="0">None</option>
                                                    {item.material.map((item2, index2) => (
                                                      <option
                                                        key={index2}
                                                        value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                      >
                                                        {item2.label}
                                                      </option>
                                                    ))}

                                                  </Form.Select>
                                                </Form.Group>
                                              </Col> */}
                                                {/* add label option */}
                                                <Col sm={2} style={{ display: 'flex' }}>
                                                  <Dropdown>
                                                    <Dropdown.Toggle
                                                      variant="outline-secondary"
                                                      style={{
                                                        width: '12vw',
                                                        backgroundColor: 'white',
                                                        color: 'black',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        whiteSpace: 'normal',        // Allows text to wrap
                                                        wordBreak: 'break-word',     // Breaks long words
                                                        padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                      }}>
                                                      {formData.label || 'None'}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu style={{ width: 'auto' }}>
                                                      <Dropdown.Item onClick={() => handleFoyerOptionChange({ target: { value: '0' } }, index)}>
                                                        None
                                                      </Dropdown.Item>
                                                      {item.material.map((item2, index2) => {
                                                        const childList = item2.subMaterials;
                                                        const hasChild = childList && childList.length > 0;

                                                        return (
                                                          <div
                                                            key={index2}
                                                            style={{ position: "relative" }}
                                                            onMouseEnter={() => setHoveredItem(item2.label)}
                                                            onMouseLeave={() => setHoveredItem(null)}
                                                          >
                                                            <Dropdown.Item
                                                              onClick={() => {
                                                                if (!hasChild) {
                                                                  handleFoyerOptionChange(
                                                                    {
                                                                      target: {
                                                                        value:
                                                                          priceGen === "oldvalue"
                                                                            ? item2.oldvalue
                                                                            : item2.value,
                                                                        label: item2.label,
                                                                      },
                                                                    },
                                                                    index
                                                                  );
                                                                }
                                                              }}
                                                              style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                              }}
                                                            >
                                                              {item2.label}
                                                              {hasChild && <span>▶</span>}
                                                            </Dropdown.Item>

                                                            {/* ✅ Child Dropdown */}
                                                            {hasChild && hoveredItem === item2.label && (
                                                              <div
                                                                style={{
                                                                  position: "absolute",
                                                                  top: 0,
                                                                  left: "100%",
                                                                  background: "white",
                                                                  border: "1px solid #ddd",
                                                                  minWidth: "180px",
                                                                  zIndex: 1050,
                                                                }}
                                                              >
                                                                {item2.subMaterials.map((child, childIndex) => (
                                                                  <Dropdown.Item
                                                                    onClick={() => {
                                                                      handleFoyerOptionChange(
                                                                        {
                                                                          target: {
                                                                            value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                            // value: child.subValue,
                                                                            label: `${item2.label} (${child.subLabel})`,
                                                                          },
                                                                        },
                                                                        index
                                                                      );
                                                                    }}
                                                                  >
                                                                    {child.subLabel}
                                                                  </Dropdown.Item>
                                                                ))}
                                                              </div>
                                                            )}
                                                          </div>
                                                        );
                                                      })}

                                                      <Dropdown.Divider />

                                                      <div className="px-3 py-2">
                                                        <Button
                                                          variant="outline-success"
                                                          size="sm"
                                                          onClick={(e) => {
                                                            e.stopPropagation(); // prevent dropdown from closing
                                                            handleAddNewItem(item, 'kitchen', index);
                                                          }}
                                                        >
                                                          <i className="bi bi-plus-square-dotted"></i> Add Item
                                                        </Button>
                                                      </div>
                                                    </Dropdown.Menu>
                                                  </Dropdown>
                                                </Col>
                                                <Col sm={1}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={foyerFormData[index].height === 0 ? '' : foyerFormData[index].height}
                                                      onChange={(e) => handleFoyerChange(e, index, "height")}
                                                      placeholder="Length"
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={1}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={foyerFormData[index].width === 0 ? '' : foyerFormData[index].width}
                                                      onChange={(e) => handleFoyerChange(e, index, "width")}
                                                      placeholder="Width"
                                                    />
                                                  </Form.Group>
                                                </Col>


                                                <Col sm={1}>

                                                </Col>

                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={foyerFormData[index].price}
                                                      // onChange={(e) => handleFoyerPriceChange(e, index, "price")}
                                                      placeholder="Price"
                                                      disabled={foyerFormData[index].value ? false : true}
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      value={foyerFormData[index].remark}
                                                      onChange={(e) => handleFoyerRemarkChange(e, index, "remark")}
                                                      as="textarea" rows={1}
                                                      placeholder="Remark"
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={1}>
                                                  {item.isUserAdded && (
                                                    <Button variant="danger" onClick={() => deleteUserAddedFoyerItem(index)}>
                                                      <i class="bi bi-x-circle-fill"></i>
                                                    </Button>
                                                  )}
                                                </Col>
                                              </Row> : item.measurement == "rft" ?
                                                <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Label
                                                        style={{
                                                          fontSize: 16,
                                                          fontWeight: "500",
                                                        }}
                                                      > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                      </Form.Label>
                                                    </Form.Group>
                                                  </Col>
                                                  {/* <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Select
                                                      value={foyerFormData[index].value}
                                                      onChange={(e) => handleFoyerOptionChange(e, index)}


                                                    >
                                                      <option value="0">None</option>
                                                      {item.material.map((item2, index2) => (
                                                        <option
                                                          key={index2}
                                                          value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                        >
                                                          {item2.label}
                                                        </option>
                                                      ))}

                                                    </Form.Select>
                                                  </Form.Group>
                                                </Col> */}
                                                  {/* add label option */}
                                                  <Col sm={2} style={{ display: 'flex' }}>
                                                    <Dropdown>
                                                      <Dropdown.Toggle
                                                        variant="outline-secondary"
                                                        style={{
                                                          width: '12vw',
                                                          backgroundColor: 'white',
                                                          color: 'black',
                                                          display: 'flex',
                                                          justifyContent: 'space-between',
                                                          alignItems: 'center',
                                                          whiteSpace: 'normal',        // Allows text to wrap
                                                          wordBreak: 'break-word',     // Breaks long words
                                                          padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                        }}>
                                                        {formData.label || 'None'}
                                                      </Dropdown.Toggle>
                                                      <Dropdown.Menu style={{ width: 'auto' }}>
                                                        <Dropdown.Item onClick={() => handleFoyerOptionChange({ target: { value: '0' } }, index)}>
                                                          None
                                                        </Dropdown.Item>
                                                        {item.material.map((item2, index2) => {
                                                          const childList = item2.subMaterials;
                                                          const hasChild = childList && childList.length > 0;

                                                          return (
                                                            <div
                                                              key={index2}
                                                              style={{ position: "relative" }}
                                                              onMouseEnter={() => setHoveredItem(item2.label)}
                                                              onMouseLeave={() => setHoveredItem(null)}
                                                            >
                                                              <Dropdown.Item
                                                                onClick={() => {
                                                                  if (!hasChild) {
                                                                    handleFoyerOptionChange(
                                                                      {
                                                                        target: {
                                                                          value:
                                                                            priceGen === "oldvalue"
                                                                              ? item2.oldvalue
                                                                              : item2.value,
                                                                          label: item2.label,
                                                                        },
                                                                      },
                                                                      index
                                                                    );
                                                                  }
                                                                }}
                                                                style={{
                                                                  display: "flex",
                                                                  justifyContent: "space-between",
                                                                }}
                                                              >
                                                                {item2.label}
                                                                {hasChild && <span>▶</span>}
                                                              </Dropdown.Item>

                                                              {/* ✅ Child Dropdown */}
                                                              {hasChild && hoveredItem === item2.label && (
                                                                <div
                                                                  style={{
                                                                    position: "absolute",
                                                                    top: 0,
                                                                    left: "100%",
                                                                    background: "white",
                                                                    border: "1px solid #ddd",
                                                                    minWidth: "180px",
                                                                    zIndex: 1050,
                                                                  }}
                                                                >
                                                                  {item2.subMaterials.map((child, childIndex) => (
                                                                    <Dropdown.Item
                                                                      onClick={() => {
                                                                        handleFoyerOptionChange(
                                                                          {
                                                                            target: {
                                                                              value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                              // value: child.subValue,
                                                                              label: `${item2.label} (${child.subLabel})`,
                                                                            },
                                                                          },
                                                                          index
                                                                        );
                                                                      }}
                                                                    >
                                                                      {child.subLabel}
                                                                    </Dropdown.Item>
                                                                  ))}
                                                                </div>
                                                              )}
                                                            </div>
                                                          );
                                                        })}

                                                        <Dropdown.Divider />

                                                        <div className="px-3 py-2">
                                                          <Button
                                                            variant="outline-success"
                                                            size="sm"
                                                            onClick={(e) => {
                                                              e.stopPropagation(); // prevent dropdown from closing
                                                              handleAddNewItem(item, 'kitchen', index);
                                                            }}
                                                          >
                                                            <i className="bi bi-plus-square-dotted"></i> Add Item
                                                          </Button>
                                                        </div>
                                                      </Dropdown.Menu>
                                                    </Dropdown>
                                                  </Col>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={foyerFormData[index].rft === 0 ? '' : foyerFormData[index].rft}
                                                        onChange={(e) => handleFoyerChange(e, index, "rft")}
                                                        placeholder="RFT"
                                                      />
                                                    </Form.Group>
                                                  </Col>

                                                  <Col sm={1}>

                                                  </Col>

                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={foyerFormData[index].price}
                                                        // onChange={(e) => handleFoyerPriceChange(e, index, "price")}
                                                        placeholder="Price"
                                                        disabled={foyerFormData[index].value ? false : true}
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        value={foyerFormData[index].remark}
                                                        onChange={(e) => handleFoyerRemarkChange(e, index, "remark")}
                                                        as="textarea" rows={1}
                                                        placeholder="Remark"
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={1}>
                                                    {item.isUserAdded && (
                                                      <Button variant="danger" onClick={() => deleteUserAddedFoyerItem(index)}>
                                                        <i class="bi bi-x-circle-fill"></i>
                                                      </Button>
                                                    )}
                                                  </Col>
                                                </Row> : item.measurement == "selection" ?
                                                  <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Label
                                                          style={{
                                                            fontSize: 16,
                                                            fontWeight: "500",
                                                          }}
                                                        >
                                                          <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                        </Form.Label>
                                                      </Form.Group>
                                                    </Col>


                                                    {/* add label option */}
                                                    <Col sm={2} style={{ display: 'flex' }}>
                                                      <Dropdown>
                                                        <Dropdown.Toggle
                                                          variant="outline-secondary"
                                                          style={{
                                                            width: '12vw',
                                                            backgroundColor: 'white',
                                                            color: 'black',
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            whiteSpace: 'normal',        // Allows text to wrap
                                                            wordBreak: 'break-word',     // Breaks long words
                                                            padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                          }}>
                                                          {formData.label || 'None'}
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu style={{ width: 'auto' }}>
                                                          <Dropdown.Item onClick={() => handleFoyerOptionChange({ target: { value: '0' } }, index)}>
                                                            None
                                                          </Dropdown.Item>
                                                          {item.material.map((item2, index2) => {
                                                            const childList = item2.subMaterials;
                                                            const hasChild = childList && childList.length > 0;

                                                            return (
                                                              <div
                                                                key={index2}
                                                                style={{ position: "relative" }}
                                                                onMouseEnter={() => setHoveredItem(item2.label)}
                                                                onMouseLeave={() => setHoveredItem(null)}
                                                              >
                                                                <Dropdown.Item
                                                                  onClick={() => {
                                                                    if (!hasChild) {
                                                                      handleFoyerOptionChange(
                                                                        {
                                                                          target: {
                                                                            value:
                                                                              priceGen === "oldvalue"
                                                                                ? item2.oldvalue
                                                                                : item2.value,
                                                                            label: item2.label,
                                                                          },
                                                                        },
                                                                        index
                                                                      );
                                                                    }
                                                                  }}
                                                                  style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                  }}
                                                                >
                                                                  {item2.label}
                                                                  {hasChild && <span>▶</span>}
                                                                </Dropdown.Item>

                                                                {/* ✅ Child Dropdown */}
                                                                {hasChild && hoveredItem === item2.label && (
                                                                  <div
                                                                    style={{
                                                                      position: "absolute",
                                                                      top: 0,
                                                                      left: "100%",
                                                                      background: "white",
                                                                      border: "1px solid #ddd",
                                                                      minWidth: "180px",
                                                                      zIndex: 1050,
                                                                    }}
                                                                  >
                                                                    {item2.subMaterials.map((child, childIndex) => (
                                                                      <Dropdown.Item
                                                                        onClick={() => {
                                                                          handleFoyerOptionChange(
                                                                            {
                                                                              target: {
                                                                                value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                // value: child.subValue,
                                                                                label: `${item2.label} (${child.subLabel})`,
                                                                              },
                                                                            },
                                                                            index
                                                                          );
                                                                        }}
                                                                      >
                                                                        {child.subLabel}
                                                                      </Dropdown.Item>
                                                                    ))}
                                                                  </div>
                                                                )}
                                                              </div>
                                                            );
                                                          })}

                                                          <Dropdown.Divider />

                                                          <div className="px-3 py-2">
                                                            <Button
                                                              variant="outline-success"
                                                              size="sm"
                                                              onClick={(e) => {
                                                                e.stopPropagation(); // prevent dropdown from closing
                                                                handleAddNewItem(item, 'kitchen', index);
                                                              }}
                                                            >
                                                              <i className="bi bi-plus-square-dotted"></i> Add Item
                                                            </Button>
                                                          </div>
                                                        </Dropdown.Menu>
                                                      </Dropdown>
                                                    </Col>


                                                    <Col sm={2}>

                                                    </Col>

                                                    <Col sm={1}>

                                                    </Col>

                                                    <Col sm={2}>

                                                    </Col>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          value={foyerFormData[index].remark}
                                                          onChange={(e) => handleFoyerRemarkChange(e, index, "remark")}
                                                          as="textarea" rows={1}
                                                          placeholder="Remark"
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={1}>
                                                      {item.isUserAdded && (
                                                        <Button variant="danger" onClick={() => deleteUserAddedFoyerItem(index)}>
                                                          <i class="bi bi-x-circle-fill"></i>
                                                        </Button>
                                                      )}
                                                    </Col>
                                                  </Row> : item.measurement == "depth" ?
                                                    <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Label
                                                            style={{
                                                              fontSize: 16,
                                                              fontWeight: "500",
                                                            }}
                                                          > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                          </Form.Label>
                                                        </Form.Group>
                                                      </Col>

                                                      {/* add label option */}
                                                      <Col sm={2} style={{ display: 'flex' }}>
                                                        <Dropdown>
                                                          <Dropdown.Toggle
                                                            variant="outline-secondary"
                                                            style={{
                                                              width: '12vw',
                                                              backgroundColor: 'white',
                                                              color: 'black',
                                                              display: 'flex',
                                                              justifyContent: 'space-between',
                                                              alignItems: 'center',
                                                              whiteSpace: 'normal',        // Allows text to wrap
                                                              wordBreak: 'break-word',     // Breaks long words
                                                              padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                            }}>
                                                            {formData.label || 'None'}
                                                          </Dropdown.Toggle>
                                                          <Dropdown.Menu style={{ width: 'auto' }}>
                                                            <Dropdown.Item onClick={() => handleFoyerOptionChange({ target: { value: '0' } }, index)}>
                                                              None
                                                            </Dropdown.Item>
                                                            {item.material.map((item2, index2) => {
                                                              const childList = item2.subMaterials;
                                                              const hasChild = childList && childList.length > 0;

                                                              return (
                                                                <div
                                                                  key={index2}
                                                                  style={{ position: "relative" }}
                                                                  onMouseEnter={() => setHoveredItem(item2.label)}
                                                                  onMouseLeave={() => setHoveredItem(null)}
                                                                >
                                                                  <Dropdown.Item
                                                                    onClick={() => {
                                                                      if (!hasChild) {
                                                                        handleFoyerOptionChange(
                                                                          {
                                                                            target: {
                                                                              value:
                                                                                priceGen === "oldvalue"
                                                                                  ? item2.oldvalue
                                                                                  : item2.value,
                                                                              label: item2.label,
                                                                            },
                                                                          },
                                                                          index
                                                                        );
                                                                      }
                                                                    }}
                                                                    style={{
                                                                      display: "flex",
                                                                      justifyContent: "space-between",
                                                                    }}
                                                                  >
                                                                    {item2.label}
                                                                    {hasChild && <span>▶</span>}
                                                                  </Dropdown.Item>

                                                                  {/* ✅ Child Dropdown */}
                                                                  {hasChild && hoveredItem === item2.label && (
                                                                    <div
                                                                      style={{
                                                                        position: "absolute",
                                                                        top: 0,
                                                                        left: "100%",
                                                                        background: "white",
                                                                        border: "1px solid #ddd",
                                                                        minWidth: "180px",
                                                                        zIndex: 1050,
                                                                      }}
                                                                    >
                                                                      {item2.subMaterials.map((child, childIndex) => (
                                                                        <Dropdown.Item
                                                                          onClick={() => {
                                                                            handleFoyerOptionChange(
                                                                              {
                                                                                target: {
                                                                                  value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                  // value: child.subValue,
                                                                                  label: `${item2.label} (${child.subLabel})`,
                                                                                },
                                                                              },
                                                                              index
                                                                            );
                                                                          }}
                                                                        >
                                                                          {child.subLabel}
                                                                        </Dropdown.Item>
                                                                      ))}
                                                                    </div>
                                                                  )}
                                                                </div>
                                                              );
                                                            })}

                                                            <Dropdown.Divider />

                                                            <div className="px-3 py-2">
                                                              <Button
                                                                variant="outline-success"
                                                                size="sm"
                                                                onClick={(e) => {
                                                                  e.stopPropagation(); // prevent dropdown from closing
                                                                  handleAddNewItem(item, 'kitchen', index);
                                                                }}
                                                              >
                                                                <i className="bi bi-plus-square-dotted"></i> Add Item
                                                              </Button>
                                                            </div>
                                                          </Dropdown.Menu>
                                                        </Dropdown>
                                                      </Col>
                                                      <Col sm={1}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={foyerFormData[index].width === 0 ? '' : foyerFormData[index].width}
                                                            onChange={(e) => handleFoyerChange(e, index, "width")}
                                                            placeholder="Length"
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={1}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={foyerFormData[index].height === 0 ? '' : foyerFormData[index].height}
                                                            onChange={(e) => handleFoyerChange(e, index, "height")}
                                                            placeholder="Height"
                                                          />
                                                        </Form.Group>
                                                      </Col>



                                                      <Col sm={1}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={foyerFormData[index].depth === 0 ? '' : foyerFormData[index].depth}
                                                            onChange={(e) => handleFoyerChange(e, index, "depth")}
                                                            placeholder="Depth"
                                                          />
                                                        </Form.Group>
                                                      </Col>

                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={foyerFormData[index].price}
                                                            // onChange={(e) => handleBedroomPriceChange(e, index, "price")}
                                                            placeholder="Price"
                                                            disabled={foyerFormData[index].value ? false : true}
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            value={foyerFormData[index].remark}
                                                            onChange={(e) => handleFoyerRemarkChange(e, index, "remark")}
                                                            as="textarea" rows={1}
                                                            placeholder="Remark"
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={1}>
                                                        {item.isUserAdded && (
                                                          <Button variant="danger" onClick={() => deleteUserAddedFoyerItem(index)}>
                                                            <i class="bi bi-x-circle-fill"></i>
                                                          </Button>
                                                        )}
                                                      </Col>
                                                    </Row> : null
                                    ))}


                                </Col>
                              </Row>
                              <Row>
                                <Col>

                                  <Row className="mx-1 my-3">
                                    <Col sm={2}>
                                      <Form.Group >
                                        <Form.Control
                                          value={extraItemName}
                                          onChange={(e) => setExtraItemName(e.target.value)}
                                          type="text"
                                          placeholder="Item Name"
                                        />
                                      </Form.Group>
                                    </Col>
                                    <Col sm={2}>
                                      <Form.Group >
                                        <Form.Control
                                          value={extraItemMaterialName}
                                          onChange={(e) => setExtraItemMaterialName(e.target.value)}
                                          type="text"
                                          placeholder="Material Name"
                                        />
                                      </Form.Group>
                                    </Col>
                                    <Col sm={2}>
                                      <Form.Group >
                                        <Form.Control
                                          value={extraItemMaterialValue}
                                          onChange={(e) => setExtraItemMaterialValue(e.target.value)}
                                          type="number"
                                          placeholder="Material Value"
                                        />
                                      </Form.Group>
                                    </Col>

                                    <Col sm={3}>
                                      <Form.Select value={extraItemMeasure} onChange={(e) => { setExtraItemMeasure(e.currentTarget.value) }} >
                                        <option>Select Measurement Type</option>
                                        <option value="area">Area</option>
                                        <option value="width">Width &  Height</option>
                                        <option value="rft">RFT</option>
                                        <option value="qty">Quantity</option>
                                        <option value="length">Width & Length</option>
                                        <option value="selection">Selection</option>
                                      </Form.Select>
                                    </Col>
                                    <Col sm={1}>
                                      <Form.Check
                                        inline
                                        label="Wood"
                                        name="Wood"
                                        type="checkbox"
                                        id="inline-checkbox-1"
                                        checked={isChecked}
                                        onChange={handleCheckboxChange}
                                      />
                                    </Col>
                                    <Col sm={2}>
                                      <Button onClick={addNewFoyerItem}>Add Item</Button>
                                    </Col>
                                  </Row>





                                </Col>

                              </Row>
                            </Form.Group>


                          </Form>
                        </Col>
                      </Row>

                      <Row style={{
                        // marginBottom: '50px',
                        marginLeft: '1px',
                        padding: '20px',
                        borderRadius: '15px',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                        backgroundColor: '#ffffff', // Light background color


                      }} >
                        <Col style={{
                          display: 'flex',
                          justifyContent: 'flex-start',
                          gap: '12px',
                        }}>
                          <Button className="buttonDesign" style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold" }} onClick={handleCategoryGoBack} >Go Back</Button>
                          {Boolean(restored) && (
                        <Button style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold", backgroundColor: '#fee2e2', color: '#dc2626', border: '1px solid #fca5a5' }} onClick={handleDiscardDraft} disabled={isDiscarding}>{isDiscarding ? "Discarding..." : "Discard Draft"}</Button>
                      )}
                          <Button className="buttonDesign" style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold" }} disabled={isSaving} onClick={() => saveFoyerData()}  >{isSaving ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Saving...</> : "Save"}</Button>
                        </Col>
                        <Col className="col-sm-3">

                        </Col>
                        <Col className="col-sm-2"><h4>Total Price</h4></Col>
                        <Col className="col-sm-2">
                          {/* <h4>
                        Rs:- {roomTypePrice}

                      </h4> */}
                          <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{roomTypePrice}</h4></span>
                        </Col>
                      </Row>


                    </Row> : roomTypeModal == 'Living Room' ?
                      <Row className="p-2" style={{
                        marginBottom: '50px',

                        padding: '20px',
                        marginLeft: '20px',
                        borderRadius: '15px',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                        backgroundColor: '#ffffff', // Light background color

                      }}>

                        <div style={{
                          display: "flex",
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '1rem'
                        }}>
                          <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} >
                            <h5>living -- </h5>
                            <h6 style={{ color: '#e85d13', margin: 0 }}>{priceGen === 'value' ? 'New Value' : 'Old Value'}</h6>
                            {Boolean(restored) && draftSaveStatus && (
                              <span style={{ fontSize: "11px", fontWeight: "600", color: draftSaveStatus.includes('Error') ? "#ef4444" : "#15803d", backgroundColor: draftSaveStatus.includes('Error') ? "#fef2f2" : "#f0fdf4", padding: "2px 8px", borderRadius: "12px", border: `1px solid ${draftSaveStatus.includes('Error') ? "#fecaca" : "#bbf7d0"}` }}>
                                {draftSaveStatus}
                              </span>
                            )}
                          </span>

                          <div>
                            <InputGroup>
                              <Form.Control
                                style={{
                                  borderRadius: "15px",
                                  padding: "12px 15px",
                                  border: "1px solid #d1d5db",
                                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                  background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                                  transition: "all 0.3s ease",
                                  width: "20vw",
                                }}
                                onChange={(e) => setSearch(e.target.value)}
                                placeholder="Search Labels"
                              />
                            </InputGroup>
                          </div>
                        </div>

                        <Row style={{
                          backgroundColor: "#F2F2F2",
                          height: 'auto',
                          marginLeft: '5px',
                          overflowY: 'auto',
                          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                          borderRadius: '15px',
                          padding: '0 0 0 10px',
                        }}>
                          <Col style={{ minHeight: 380, maxHeight: 480 }}>

                            <Form>

                              <Form.Group>
                                <Row>

                                  <Col sm={12}>

                                    {livingThingsDataCopy
                                      .map((item, index) => ({ item, formData: livingFormData[index], index }))
                                      .filter(({ item }) => {
                                        const searchQuery = search.toLowerCase();
                                        return searchQuery === '' || item.name.toLowerCase().includes(searchQuery);
                                      })
                                      .map(({ item, formData, index }) => (
                                        item.measurement == "area" ?
                                          <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Label
                                                  style={{
                                                    fontSize: 16,
                                                    fontWeight: "500",
                                                  }}
                                                > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                </Form.Label>
                                              </Form.Group>
                                            </Col>
                                            {/* <Col sm={2}>
                                            <Form.Group>
                                              <Form.Select
                                                value={livingFormData[index].value}
                                                onChange={(e) => handleLivingOptionChange(e, index)}
                                              >
                                                <option value="0">None</option>
                                                {item.material.map((item2, index2) => (
                                                  <option
                                                    key={index2}
                                                    value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                  >
                                                    {item2.label}
                                                  </option>
                                                ))}

                                              </Form.Select>
                                            </Form.Group>
                                          </Col> */}
                                            {/* add label option */}
                                            <Col sm={2} style={{ display: 'flex' }}>
                                              <Dropdown>
                                                <Dropdown.Toggle
                                                  variant="outline-secondary"
                                                  style={{
                                                    width: '12vw',
                                                    backgroundColor: 'white',
                                                    color: 'black',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    whiteSpace: 'normal',        // Allows text to wrap
                                                    wordBreak: 'break-word',     // Breaks long words
                                                    padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                  }}>
                                                  {formData.label || 'None'}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu style={{ width: 'auto' }}>
                                                  <Dropdown.Item onClick={() => handleLivingOptionChange({ target: { value: '0' } }, index)}>
                                                    None
                                                  </Dropdown.Item>
                                                  {item.material.map((item2, index2) => {
                                                    const childList = item2.subMaterials;
                                                    const hasChild = childList && childList.length > 0;

                                                    return (
                                                      <div
                                                        key={index2}
                                                        style={{ position: "relative" }}
                                                        onMouseEnter={() => setHoveredItem(item2.label)}
                                                        onMouseLeave={() => setHoveredItem(null)}
                                                      >
                                                        <Dropdown.Item
                                                          onClick={() => {
                                                            if (!hasChild) {
                                                              handleLivingOptionChange(
                                                                {
                                                                  target: {
                                                                    value:
                                                                      priceGen === "oldvalue"
                                                                        ? item2.oldvalue
                                                                        : item2.value,
                                                                    label: item2.label,
                                                                  },
                                                                },
                                                                index
                                                              );
                                                            }
                                                          }}
                                                          style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                          }}
                                                        >
                                                          {item2.label}
                                                          {hasChild && <span>▶</span>}
                                                        </Dropdown.Item>

                                                        {/* ✅ Child Dropdown */}
                                                        {hasChild && hoveredItem === item2.label && (
                                                          <div
                                                            style={{
                                                              position: "absolute",
                                                              top: 0,
                                                              left: "100%",
                                                              background: "white",
                                                              border: "1px solid #ddd",
                                                              minWidth: "180px",
                                                              zIndex: 1050,
                                                            }}
                                                          >
                                                            {item2.subMaterials.map((child, childIndex) => (
                                                              <Dropdown.Item
                                                                onClick={() => {
                                                                  handleLivingOptionChange(
                                                                    {
                                                                      target: {
                                                                        value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                        // value: child.subValue,
                                                                        label: `${item2.label} (${child.subLabel})`,
                                                                      },
                                                                    },
                                                                    index
                                                                  );
                                                                }}
                                                              >
                                                                {child.subLabel}
                                                              </Dropdown.Item>
                                                            ))}
                                                          </div>
                                                        )}
                                                      </div>
                                                    );
                                                  })}

                                                  <Dropdown.Divider />

                                                  <div className="px-3 py-2">
                                                    <Button
                                                      variant="outline-success"
                                                      size="sm"
                                                      onClick={(e) => {
                                                        e.stopPropagation(); // prevent dropdown from closing
                                                        handleAddNewItem(item, 'kitchen', index);
                                                      }}
                                                    >
                                                      <i className="bi bi-plus-square-dotted"></i> Add Item
                                                    </Button>
                                                  </div>
                                                </Dropdown.Menu>
                                              </Dropdown>
                                            </Col>
                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={livingFormData[index].area === 0 ? '' : livingFormData[index].area}
                                                  onChange={(e) => handleLivingChange(e, index, "area")}
                                                  placeholder="Area"
                                                />
                                              </Form.Group>
                                            </Col>

                                            <Col sm={1}>

                                            </Col>

                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Control
                                                  type="number"
                                                  value={livingFormData[index].price}
                                                  // onChange={(e) => handleLivingPriceChange(e, index, "price")}
                                                  placeholder="Price"
                                                  disabled={livingFormData[index].value ? false : true}
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col sm={2}>
                                              <Form.Group>
                                                <Form.Control
                                                  value={livingFormData[index].remark}
                                                  onChange={(e) => handleLivingRemarkChange(e, index, "remark")}
                                                  as="textarea" rows={1}
                                                  placeholder="Remark"
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col sm={1}>
                                              {item.isUserAdded && (
                                                <Button variant="danger" onClick={() => deleteUserAddedLivingItem(index)}>
                                                  <i class="bi bi-x-circle-fill"></i>
                                                </Button>
                                              )}
                                            </Col>
                                          </Row>
                                          : item.measurement == "width" ?
                                            <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Label
                                                    style={{
                                                      fontSize: 16,
                                                      fontWeight: "500",
                                                    }}
                                                  > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                  </Form.Label>
                                                </Form.Group>
                                              </Col>
                                              {/* <Col sm={2}>
                                              <Form.Group>
                                                <Form.Select
                                                  value={livingFormData[index].value}
                                                  onChange={(e) => handleLivingOptionChange(e, index)}


                                                >
                                                  <option value="0">None</option>
                                                  {item.material.map((item2, index2) => (
                                                    <option
                                                      key={index2}
                                                      value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                    >
                                                      {item2.label}
                                                    </option>
                                                  ))}

                                                </Form.Select>
                                              </Form.Group>
                                            </Col> */}
                                              {/* add label option */}
                                              <Col sm={2} style={{ display: 'flex' }}>
                                                <Dropdown>
                                                  <Dropdown.Toggle
                                                    variant="outline-secondary"
                                                    style={{
                                                      width: '12vw',
                                                      backgroundColor: 'white',
                                                      color: 'black',
                                                      display: 'flex',
                                                      justifyContent: 'space-between',
                                                      alignItems: 'center',
                                                      whiteSpace: 'normal',        // Allows text to wrap
                                                      wordBreak: 'break-word',     // Breaks long words
                                                      padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                    }}>
                                                    {formData.label || 'None'}
                                                  </Dropdown.Toggle>
                                                  <Dropdown.Menu style={{ width: 'auto' }}>
                                                    <Dropdown.Item onClick={() => handleLivingOptionChange({ target: { value: '0' } }, index)}>
                                                      None
                                                    </Dropdown.Item>
                                                    {item.material.map((item2, index2) => {
                                                      const childList = item2.subMaterials;
                                                      const hasChild = childList && childList.length > 0;

                                                      return (
                                                        <div
                                                          key={index2}
                                                          style={{ position: "relative" }}
                                                          onMouseEnter={() => setHoveredItem(item2.label)}
                                                          onMouseLeave={() => setHoveredItem(null)}
                                                        >
                                                          <Dropdown.Item
                                                            onClick={() => {
                                                              if (!hasChild) {
                                                                handleLivingOptionChange(
                                                                  {
                                                                    target: {
                                                                      value:
                                                                        priceGen === "oldvalue"
                                                                          ? item2.oldvalue
                                                                          : item2.value,
                                                                      label: item2.label,
                                                                    },
                                                                  },
                                                                  index
                                                                );
                                                              }
                                                            }}
                                                            style={{
                                                              display: "flex",
                                                              justifyContent: "space-between",
                                                            }}
                                                          >
                                                            {item2.label}
                                                            {hasChild && <span>▶</span>}
                                                          </Dropdown.Item>

                                                          {/* ✅ Child Dropdown */}
                                                          {hasChild && hoveredItem === item2.label && (
                                                            <div
                                                              style={{
                                                                position: "absolute",
                                                                top: 0,
                                                                left: "100%",
                                                                background: "white",
                                                                border: "1px solid #ddd",
                                                                minWidth: "180px",
                                                                zIndex: 1050,
                                                              }}
                                                            >
                                                              {item2.subMaterials.map((child, childIndex) => (
                                                                <Dropdown.Item
                                                                  onClick={() => {
                                                                    handleLivingOptionChange(
                                                                      {
                                                                        target: {
                                                                          value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                          // value: child.subValue,
                                                                          label: `${item2.label} (${child.subLabel})`,
                                                                        },
                                                                      },
                                                                      index
                                                                    );
                                                                  }}
                                                                >
                                                                  {child.subLabel}
                                                                </Dropdown.Item>
                                                              ))}
                                                            </div>
                                                          )}
                                                        </div>
                                                      );
                                                    })}

                                                    <Dropdown.Divider />

                                                    <div className="px-3 py-2">
                                                      <Button
                                                        variant="outline-success"
                                                        size="sm"
                                                        onClick={(e) => {
                                                          e.stopPropagation(); // prevent dropdown from closing
                                                          handleAddNewItem(item, 'kitchen', index);
                                                        }}
                                                      >
                                                        <i className="bi bi-plus-square-dotted"></i> Add Item
                                                      </Button>
                                                    </div>
                                                  </Dropdown.Menu>
                                                </Dropdown>
                                              </Col>
                                              <Col sm={1}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={livingFormData[index].width === 0 ? '' : livingFormData[index].width}
                                                    onChange={(e) => handleLivingChange(e, index, "width")}
                                                    placeholder="Width"
                                                  />
                                                </Form.Group>
                                              </Col>

                                              <Col sm={1}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={livingFormData[index].height === 0 ? '' : livingFormData[index].height}
                                                    onChange={(e) => handleLivingChange(e, index, "height")}
                                                    placeholder="Height"
                                                  />
                                                </Form.Group>
                                              </Col>

                                              <Col sm={1}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={livingFormData[index].qnty === 0 ? '' : livingFormData[index].qnty}
                                                    onChange={(e) => handleLivingChange(e, index, "qnty")}
                                                    placeholder="Qty"
                                                  />
                                                </Form.Group>
                                              </Col>

                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={livingFormData[index].price}
                                                    // onChange={(e) => handleLivingPriceChange(e, index, "price")}
                                                    placeholder="Price"
                                                    disabled={livingFormData[index].value ? false : true}
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    value={livingFormData[index].remark}
                                                    onChange={(e) => handleLivingRemarkChange(e, index, "remark")}
                                                    as="textarea" rows={1}
                                                    placeholder="Remark"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={1}>
                                                {item.isUserAdded && (
                                                  <Button variant="danger" onClick={() => deleteUserAddedLivingItem(index)}>
                                                    <i class="bi bi-x-circle-fill"></i>
                                                  </Button>
                                                )}
                                              </Col>
                                            </Row>
                                            : item.measurement == "qty" && item.removed !== true ?
                                              <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Label
                                                      style={{
                                                        fontSize: 16,
                                                        fontWeight: "500",
                                                      }}
                                                    > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                    </Form.Label>
                                                  </Form.Group>
                                                </Col>
                                                {/* <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Select
                                                    value={livingFormData[index].value}
                                                    onChange={(e) => handleLivingOptionChange(e, index)}


                                                  >
                                                    <option value="0">None</option>
                                                    {item.material.map((item2, index2) => (
                                                      <option
                                                        key={index2}
                                                        value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                      >
                                                        {item2.label}
                                                      </option>
                                                    ))}

                                                  </Form.Select>
                                                </Form.Group>
                                              </Col> */}
                                                {/* add label option */}
                                                <Col sm={2} style={{ display: 'flex' }}>
                                                  <Dropdown>
                                                    <Dropdown.Toggle
                                                      variant="outline-secondary"
                                                      style={{
                                                        width: '12vw',
                                                        backgroundColor: 'white',
                                                        color: 'black',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        whiteSpace: 'normal',        // Allows text to wrap
                                                        wordBreak: 'break-word',     // Breaks long words
                                                        padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                      }}>
                                                      {formData.label || 'None'}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu style={{ width: 'auto' }}>
                                                      <Dropdown.Item onClick={() => handleLivingOptionChange({ target: { value: '0' } }, index)}>
                                                        None
                                                      </Dropdown.Item>
                                                      {item.material.map((item2, index2) => {
                                                        const childList = item2.subMaterials;
                                                        const hasChild = childList && childList.length > 0;

                                                        return (
                                                          <div
                                                            key={index2}
                                                            style={{ position: "relative" }}
                                                            onMouseEnter={() => setHoveredItem(item2.label)}
                                                            onMouseLeave={() => setHoveredItem(null)}
                                                          >
                                                            <Dropdown.Item
                                                              onClick={() => {
                                                                if (!hasChild) {
                                                                  handleLivingOptionChange(
                                                                    {
                                                                      target: {
                                                                        value:
                                                                          priceGen === "oldvalue"
                                                                            ? item2.oldvalue
                                                                            : item2.value,
                                                                        label: item2.label,
                                                                      },
                                                                    },
                                                                    index
                                                                  );
                                                                }
                                                              }}
                                                              style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                              }}
                                                            >
                                                              {item2.label}
                                                              {hasChild && <span>▶</span>}
                                                            </Dropdown.Item>

                                                            {/* ✅ Child Dropdown */}
                                                            {hasChild && hoveredItem === item2.label && (
                                                              <div
                                                                style={{
                                                                  position: "absolute",
                                                                  top: 0,
                                                                  left: "100%",
                                                                  background: "white",
                                                                  border: "1px solid #ddd",
                                                                  minWidth: "180px",
                                                                  zIndex: 1050,
                                                                }}
                                                              >
                                                                {item2.subMaterials.map((child, childIndex) => (
                                                                  <Dropdown.Item
                                                                    onClick={() => {
                                                                      handleLivingOptionChange(
                                                                        {
                                                                          target: {
                                                                            value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                            // value: child.subValue,
                                                                            label: `${item2.label} (${child.subLabel})`,
                                                                          },
                                                                        },
                                                                        index
                                                                      );
                                                                    }}
                                                                  >
                                                                    {child.subLabel}
                                                                  </Dropdown.Item>
                                                                ))}
                                                              </div>
                                                            )}
                                                          </div>
                                                        );
                                                      })}

                                                      <Dropdown.Divider />

                                                      <div className="px-3 py-2">
                                                        <Button
                                                          variant="outline-success"
                                                          size="sm"
                                                          onClick={(e) => {
                                                            e.stopPropagation(); // prevent dropdown from closing
                                                            handleAddNewItem(item, 'kitchen', index);
                                                          }}
                                                        >
                                                          <i className="bi bi-plus-square-dotted"></i> Add Item
                                                        </Button>
                                                      </div>
                                                    </Dropdown.Menu>
                                                  </Dropdown>
                                                </Col>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={livingFormData[index].qnty === 0 ? '' : livingFormData[index].qnty}
                                                      onChange={(e) => handleLivingChange(e, index, "qnty")}
                                                      placeholder="Qty"
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={1}>

                                                </Col>

                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={livingFormData[index].price}
                                                      // onChange={(e) => handleLivingPriceChange(e, index, "price")}
                                                      placeholder="Price"
                                                      disabled={livingFormData[index].value ? false : true}
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      value={livingFormData[index].remark}
                                                      onChange={(e) => handleLivingRemarkChange(e, index, "remark")}
                                                      as="textarea" rows={1}
                                                      placeholder="Remark"
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={1}>
                                                  {item.isUserAdded && (
                                                    <Button variant="danger" onClick={() => deleteUserAddedLivingItem(index)}>
                                                      <i class="bi bi-x-circle-fill"></i>
                                                    </Button>
                                                  )}
                                                </Col>
                                              </Row>
                                              : item.measurement == "length" ?
                                                <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Label
                                                        style={{
                                                          fontSize: 16,
                                                          fontWeight: "500",
                                                        }}
                                                      > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                      </Form.Label>
                                                    </Form.Group>
                                                  </Col>
                                                  {/* <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Select
                                                      value={livingFormData[index].value}
                                                      onChange={(e) => handleLivingOptionChange(e, index)}


                                                    >
                                                      <option value="0">None</option>
                                                      {item.material.map((item2, index2) => (
                                                        <option
                                                          key={index2}
                                                          value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                        >
                                                          {item2.label}
                                                        </option>
                                                      ))}

                                                    </Form.Select>
                                                  </Form.Group>
                                                </Col> */}
                                                  {/* add label option */}
                                                  <Col sm={2} style={{ display: 'flex' }}>
                                                    <Dropdown>
                                                      <Dropdown.Toggle
                                                        variant="outline-secondary"
                                                        style={{
                                                          width: '12vw',
                                                          backgroundColor: 'white',
                                                          color: 'black',
                                                          display: 'flex',
                                                          justifyContent: 'space-between',
                                                          alignItems: 'center',
                                                          whiteSpace: 'normal',        // Allows text to wrap
                                                          wordBreak: 'break-word',     // Breaks long words
                                                          padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                        }}>
                                                        {formData.label || 'None'}
                                                      </Dropdown.Toggle>
                                                      <Dropdown.Menu style={{ width: 'auto' }}>
                                                        <Dropdown.Item onClick={() => handleLivingOptionChange({ target: { value: '0' } }, index)}>
                                                          None
                                                        </Dropdown.Item>
                                                        {item.material.map((item2, index2) => {
                                                          const childList = item2.subMaterials;
                                                          const hasChild = childList && childList.length > 0;

                                                          return (
                                                            <div
                                                              key={index2}
                                                              style={{ position: "relative" }}
                                                              onMouseEnter={() => setHoveredItem(item2.label)}
                                                              onMouseLeave={() => setHoveredItem(null)}
                                                            >
                                                              <Dropdown.Item
                                                                onClick={() => {
                                                                  if (!hasChild) {
                                                                    handleLivingOptionChange(
                                                                      {
                                                                        target: {
                                                                          value:
                                                                            priceGen === "oldvalue"
                                                                              ? item2.oldvalue
                                                                              : item2.value,
                                                                          label: item2.label,
                                                                        },
                                                                      },
                                                                      index
                                                                    );
                                                                  }
                                                                }}
                                                                style={{
                                                                  display: "flex",
                                                                  justifyContent: "space-between",
                                                                }}
                                                              >
                                                                {item2.label}
                                                                {hasChild && <span>▶</span>}
                                                              </Dropdown.Item>

                                                              {/* ✅ Child Dropdown */}
                                                              {hasChild && hoveredItem === item2.label && (
                                                                <div
                                                                  style={{
                                                                    position: "absolute",
                                                                    top: 0,
                                                                    left: "100%",
                                                                    background: "white",
                                                                    border: "1px solid #ddd",
                                                                    minWidth: "180px",
                                                                    zIndex: 1050,
                                                                  }}
                                                                >
                                                                  {item2.subMaterials.map((child, childIndex) => (
                                                                    <Dropdown.Item
                                                                      onClick={() => {
                                                                        handleLivingOptionChange(
                                                                          {
                                                                            target: {
                                                                              value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                              // value: child.subValue,
                                                                              label: `${item2.label} (${child.subLabel})`,
                                                                            },
                                                                          },
                                                                          index
                                                                        );
                                                                      }}
                                                                    >
                                                                      {child.subLabel}
                                                                    </Dropdown.Item>
                                                                  ))}
                                                                </div>
                                                              )}
                                                            </div>
                                                          );
                                                        })}

                                                        <Dropdown.Divider />

                                                        <div className="px-3 py-2">
                                                          <Button
                                                            variant="outline-success"
                                                            size="sm"
                                                            onClick={(e) => {
                                                              e.stopPropagation(); // prevent dropdown from closing
                                                              handleAddNewItem(item, 'kitchen', index);
                                                            }}
                                                          >
                                                            <i className="bi bi-plus-square-dotted"></i> Add Item
                                                          </Button>
                                                        </div>
                                                      </Dropdown.Menu>
                                                    </Dropdown>
                                                  </Col>
                                                  <Col sm={1}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={livingFormData[index].height === 0 ? '' : livingFormData[index].height}
                                                        onChange={(e) => handleLivingChange(e, index, "height")}
                                                        placeholder="Length"
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={1}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={livingFormData[index].width === 0 ? '' : livingFormData[index].width}
                                                        onChange={(e) => handleLivingChange(e, index, "width")}
                                                        placeholder="Width"
                                                      />
                                                    </Form.Group>
                                                  </Col>


                                                  <Col sm={1}>

                                                  </Col>

                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={livingFormData[index].price}
                                                        // onChange={(e) => handleLivingPriceChange(e, index, "price")}
                                                        placeholder="Price"
                                                        disabled={livingFormData[index].value ? false : true}
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        value={livingFormData[index].remark}
                                                        onChange={(e) => handleLivingRemarkChange(e, index, "remark")}
                                                        as="textarea" rows={1}
                                                        placeholder="Remark"
                                                      />
                                                    </Form.Group>
                                                  </Col>

                                                </Row> : item.measurement == "rft" ?
                                                  <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Label
                                                          style={{
                                                            fontSize: 16,
                                                            fontWeight: "500",
                                                          }}
                                                        > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                        </Form.Label>
                                                      </Form.Group>
                                                    </Col>
                                                    {/* <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Select
                                                        value={livingFormData[index].value}
                                                        onChange={(e) => handleLivingOptionChange(e, index)}


                                                      >
                                                        <option value="0">None</option>
                                                        {item.material.map((item2, index2) => (
                                                          <option
                                                            key={index2}
                                                            value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                          >
                                                            {item2.label}
                                                          </option>
                                                        ))}

                                                      </Form.Select>
                                                    </Form.Group>
                                                  </Col> */}
                                                    {/* add label option */}
                                                    <Col sm={2} style={{ display: 'flex' }}>
                                                      <Dropdown>
                                                        <Dropdown.Toggle
                                                          variant="outline-secondary"
                                                          style={{
                                                            width: '12vw',
                                                            backgroundColor: 'white',
                                                            color: 'black',
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            whiteSpace: 'normal',        // Allows text to wrap
                                                            wordBreak: 'break-word',     // Breaks long words
                                                            padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                          }}>
                                                          {formData.label || 'None'}
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu style={{ width: 'auto' }}>
                                                          <Dropdown.Item onClick={() => handleLivingOptionChange({ target: { value: '0' } }, index)}>
                                                            None
                                                          </Dropdown.Item>
                                                          {item.material.map((item2, index2) => {
                                                            const childList = item2.subMaterials;
                                                            const hasChild = childList && childList.length > 0;

                                                            return (
                                                              <div
                                                                key={index2}
                                                                style={{ position: "relative" }}
                                                                onMouseEnter={() => setHoveredItem(item2.label)}
                                                                onMouseLeave={() => setHoveredItem(null)}
                                                              >
                                                                <Dropdown.Item
                                                                  onClick={() => {
                                                                    if (!hasChild) {
                                                                      handleLivingOptionChange(
                                                                        {
                                                                          target: {
                                                                            value:
                                                                              priceGen === "oldvalue"
                                                                                ? item2.oldvalue
                                                                                : item2.value,
                                                                            label: item2.label,
                                                                          },
                                                                        },
                                                                        index
                                                                      );
                                                                    }
                                                                  }}
                                                                  style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                  }}
                                                                >
                                                                  {item2.label}
                                                                  {hasChild && <span>▶</span>}
                                                                </Dropdown.Item>

                                                                {/* ✅ Child Dropdown */}
                                                                {hasChild && hoveredItem === item2.label && (
                                                                  <div
                                                                    style={{
                                                                      position: "absolute",
                                                                      top: 0,
                                                                      left: "100%",
                                                                      background: "white",
                                                                      border: "1px solid #ddd",
                                                                      minWidth: "180px",
                                                                      zIndex: 1050,
                                                                    }}
                                                                  >
                                                                    {item2.subMaterials.map((child, childIndex) => (
                                                                      <Dropdown.Item
                                                                        onClick={() => {
                                                                          handleLivingOptionChange(
                                                                            {
                                                                              target: {
                                                                                value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                // value: child.subValue,
                                                                                label: `${item2.label} (${child.subLabel})`,
                                                                              },
                                                                            },
                                                                            index
                                                                          );
                                                                        }}
                                                                      >
                                                                        {child.subLabel}
                                                                      </Dropdown.Item>
                                                                    ))}
                                                                  </div>
                                                                )}
                                                              </div>
                                                            );
                                                          })}

                                                          <Dropdown.Divider />

                                                          <div className="px-3 py-2">
                                                            <Button
                                                              variant="outline-success"
                                                              size="sm"
                                                              onClick={(e) => {
                                                                e.stopPropagation(); // prevent dropdown from closing
                                                                handleAddNewItem(item, 'kitchen', index);
                                                              }}
                                                            >
                                                              <i className="bi bi-plus-square-dotted"></i> Add Item
                                                            </Button>
                                                          </div>
                                                        </Dropdown.Menu>
                                                      </Dropdown>
                                                    </Col>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={livingFormData[index].rft === 0 ? '' : livingFormData[index].rft}
                                                          onChange={(e) => handleLivingChange(e, index, "rft")}
                                                          placeholder="RFT"
                                                        />
                                                      </Form.Group>
                                                    </Col>

                                                    <Col sm={1}>

                                                    </Col>

                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={livingFormData[index].price}
                                                          // onChange={(e) => handleLivingPriceChange(e, index, "price")}
                                                          placeholder="Price"
                                                          disabled={livingFormData[index].value ? false : true}
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          value={livingFormData[index].remark}
                                                          onChange={(e) => handleLivingRemarkChange(e, index, "remark")}
                                                          as="textarea" rows={1}
                                                          placeholder="Remark"
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={1}>
                                                      {item.isUserAdded && (
                                                        <Button variant="danger" onClick={() => deleteUserAddedLivingItem(index)}>
                                                          <i class="bi bi-x-circle-fill"></i>
                                                        </Button>
                                                      )}
                                                    </Col>
                                                  </Row> : item.measurement == "selection" ?
                                                    <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Label
                                                            style={{
                                                              fontSize: 16,
                                                              fontWeight: "500",
                                                            }}
                                                          >
                                                            <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                          </Form.Label>
                                                        </Form.Group>
                                                      </Col>


                                                      {/* add label option */}
                                                      <Col sm={2} style={{ display: 'flex' }}>
                                                        <Dropdown>
                                                          <Dropdown.Toggle
                                                            variant="outline-secondary"
                                                            style={{
                                                              width: '12vw',
                                                              backgroundColor: 'white',
                                                              color: 'black',
                                                              display: 'flex',
                                                              justifyContent: 'space-between',
                                                              alignItems: 'center',
                                                              whiteSpace: 'normal',        // Allows text to wrap
                                                              wordBreak: 'break-word',     // Breaks long words
                                                              padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                            }}>
                                                            {formData.label || 'None'}
                                                          </Dropdown.Toggle>
                                                          <Dropdown.Menu style={{ width: 'auto' }}>
                                                            <Dropdown.Item onClick={() => handleLivingOptionChange({ target: { value: '0' } }, index)}>
                                                              None
                                                            </Dropdown.Item>
                                                            {item.material.map((item2, index2) => {
                                                              const childList = item2.subMaterials;
                                                              const hasChild = childList && childList.length > 0;

                                                              return (
                                                                <div
                                                                  key={index2}
                                                                  style={{ position: "relative" }}
                                                                  onMouseEnter={() => setHoveredItem(item2.label)}
                                                                  onMouseLeave={() => setHoveredItem(null)}
                                                                >
                                                                  <Dropdown.Item
                                                                    onClick={() => {
                                                                      if (!hasChild) {
                                                                        handleLivingOptionChange(
                                                                          {
                                                                            target: {
                                                                              value:
                                                                                priceGen === "oldvalue"
                                                                                  ? item2.oldvalue
                                                                                  : item2.value,
                                                                              label: item2.label,
                                                                            },
                                                                          },
                                                                          index
                                                                        );
                                                                      }
                                                                    }}
                                                                    style={{
                                                                      display: "flex",
                                                                      justifyContent: "space-between",
                                                                    }}
                                                                  >
                                                                    {item2.label}
                                                                    {hasChild && <span>▶</span>}
                                                                  </Dropdown.Item>

                                                                  {/* ✅ Child Dropdown */}
                                                                  {hasChild && hoveredItem === item2.label && (
                                                                    <div
                                                                      style={{
                                                                        position: "absolute",
                                                                        top: 0,
                                                                        left: "100%",
                                                                        background: "white",
                                                                        border: "1px solid #ddd",
                                                                        minWidth: "180px",
                                                                        zIndex: 1050,
                                                                      }}
                                                                    >
                                                                      {item2.subMaterials.map((child, childIndex) => (
                                                                        <Dropdown.Item
                                                                          onClick={() => {
                                                                            handleLivingOptionChange(
                                                                              {
                                                                                target: {
                                                                                  value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                  // value: child.subValue,
                                                                                  label: `${item2.label} (${child.subLabel})`,
                                                                                },
                                                                              },
                                                                              index
                                                                            );
                                                                          }}
                                                                        >
                                                                          {child.subLabel}
                                                                        </Dropdown.Item>
                                                                      ))}
                                                                    </div>
                                                                  )}
                                                                </div>
                                                              );
                                                            })}

                                                            <Dropdown.Divider />

                                                            <div className="px-3 py-2">
                                                              <Button
                                                                variant="outline-success"
                                                                size="sm"
                                                                onClick={(e) => {
                                                                  e.stopPropagation(); // prevent dropdown from closing
                                                                  handleAddNewItem(item, 'kitchen', index);
                                                                }}
                                                              >
                                                                <i className="bi bi-plus-square-dotted"></i> Add Item
                                                              </Button>
                                                            </div>
                                                          </Dropdown.Menu>
                                                        </Dropdown>
                                                      </Col>


                                                      <Col sm={2}>

                                                      </Col>

                                                      <Col sm={1}>

                                                      </Col>

                                                      <Col sm={2}>

                                                      </Col>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            value={livingFormData[index].remark}
                                                            onChange={(e) => handleLivingRemarkChange(e, index, "remark")}
                                                            as="textarea" rows={1}
                                                            placeholder="Remark"
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={1}>
                                                        {item.isUserAdded && (
                                                          <Button variant="danger" onClick={() => deleteUserAddedLivingItem(index)}>
                                                            <i class="bi bi-x-circle-fill"></i>
                                                          </Button>
                                                        )}
                                                      </Col>
                                                    </Row> : item.measurement == "depth" ?
                                                      <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Label
                                                              style={{
                                                                fontSize: 16,
                                                                fontWeight: "500",
                                                              }}
                                                            > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                            </Form.Label>
                                                          </Form.Group>
                                                        </Col>

                                                        {/* add label option */}
                                                        <Col sm={2} style={{ display: 'flex' }}>
                                                          <Dropdown>
                                                            <Dropdown.Toggle
                                                              variant="outline-secondary"
                                                              style={{
                                                                width: '12vw',
                                                                backgroundColor: 'white',
                                                                color: 'black',
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                whiteSpace: 'normal',        // Allows text to wrap
                                                                wordBreak: 'break-word',     // Breaks long words
                                                                padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                              }}>
                                                              {formData.label || 'None'}
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu style={{ width: 'auto' }}>
                                                              <Dropdown.Item onClick={() => handleLivingOptionChange({ target: { value: '0' } }, index)}>
                                                                None
                                                              </Dropdown.Item>
                                                              {item.material.map((item2, index2) => {
                                                                const childList = item2.subMaterials;
                                                                const hasChild = childList && childList.length > 0;

                                                                return (
                                                                  <div
                                                                    key={index2}
                                                                    style={{ position: "relative" }}
                                                                    onMouseEnter={() => setHoveredItem(item2.label)}
                                                                    onMouseLeave={() => setHoveredItem(null)}
                                                                  >
                                                                    <Dropdown.Item
                                                                      onClick={() => {
                                                                        if (!hasChild) {
                                                                          handleLivingOptionChange(
                                                                            {
                                                                              target: {
                                                                                value:
                                                                                  priceGen === "oldvalue"
                                                                                    ? item2.oldvalue
                                                                                    : item2.value,
                                                                                label: item2.label,
                                                                              },
                                                                            },
                                                                            index
                                                                          );
                                                                        }
                                                                      }}
                                                                      style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                      }}
                                                                    >
                                                                      {item2.label}
                                                                      {hasChild && <span>▶</span>}
                                                                    </Dropdown.Item>

                                                                    {/* ✅ Child Dropdown */}
                                                                    {hasChild && hoveredItem === item2.label && (
                                                                      <div
                                                                        style={{
                                                                          position: "absolute",
                                                                          top: 0,
                                                                          left: "100%",
                                                                          background: "white",
                                                                          border: "1px solid #ddd",
                                                                          minWidth: "180px",
                                                                          zIndex: 1050,
                                                                        }}
                                                                      >
                                                                        {item2.subMaterials.map((child, childIndex) => (
                                                                          <Dropdown.Item
                                                                            onClick={() => {
                                                                              handleLivingOptionChange(
                                                                                {
                                                                                  target: {
                                                                                    value: priceGen === "oldvalue" ? child.subOldValue : child.subValue,
                                                                                    // value: child.subValue,
                                                                                    label: `${item2.label} (${child.subLabel})`,
                                                                                  },
                                                                                },
                                                                                index
                                                                              );
                                                                            }}
                                                                          >
                                                                            {child.subLabel}
                                                                          </Dropdown.Item>
                                                                        ))}
                                                                      </div>
                                                                    )}
                                                                  </div>
                                                                );
                                                              })}

                                                              <Dropdown.Divider />

                                                              <div className="px-3 py-2">
                                                                <Button
                                                                  variant="outline-success"
                                                                  size="sm"
                                                                  onClick={(e) => {
                                                                    e.stopPropagation(); // prevent dropdown from closing
                                                                    handleAddNewItem(item, 'kitchen', index);
                                                                  }}
                                                                >
                                                                  <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                </Button>
                                                              </div>
                                                            </Dropdown.Menu>
                                                          </Dropdown>
                                                        </Col>
                                                        <Col sm={1}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={livingFormData[index].width === 0 ? '' : livingFormData[index].width}
                                                              onChange={(e) => handleLivingChange(e, index, "width")}
                                                              placeholder="Length"
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={1}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={livingFormData[index].height === 0 ? '' : livingFormData[index].height}
                                                              onChange={(e) => handleLivingChange(e, index, "height")}
                                                              placeholder="Height"
                                                            />
                                                          </Form.Group>
                                                        </Col>



                                                        <Col sm={1}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={livingFormData[index].depth === 0 ? '' : livingFormData[index].depth}
                                                              onChange={(e) => handleLivingChange(e, index, "depth")}
                                                              placeholder="Depth"
                                                            />
                                                          </Form.Group>
                                                        </Col>

                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={livingFormData[index].price}
                                                              // onChange={(e) => handleBedroomPriceChange(e, index, "price")}
                                                              placeholder="Price"
                                                              disabled={livingFormData[index].value ? false : true}
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              value={livingFormData[index].remark}
                                                              onChange={(e) => handleLivingRemarkChange(e, index, "remark")}
                                                              as="textarea" rows={1}
                                                              placeholder="Remark"
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={1}>
                                                          {item.isUserAdded && (
                                                            <Button variant="danger" onClick={() => deleteUserAddedLivingItem(index)}>
                                                              <i class="bi bi-x-circle-fill"></i>
                                                            </Button>
                                                          )}
                                                        </Col>
                                                      </Row> : null
                                      ))}


                                  </Col>
                                </Row>
                                <Row>
                                  <Col>

                                    <Row className="mx-1 my-3">
                                      <Col sm={2}>
                                        <Form.Group >
                                          <Form.Control
                                            value={extraItemName}
                                            onChange={(e) => setExtraItemName(e.target.value)}
                                            type="text"
                                            placeholder="Item Name"
                                          />
                                        </Form.Group>
                                      </Col>
                                      <Col sm={2}>
                                        <Form.Group >
                                          <Form.Control
                                            value={extraItemMaterialName}
                                            onChange={(e) => setExtraItemMaterialName(e.target.value)}
                                            type="text"
                                            placeholder="Material Name"
                                          />
                                        </Form.Group>
                                      </Col>
                                      <Col sm={2}>
                                        <Form.Group >
                                          <Form.Control
                                            value={extraItemMaterialValue}
                                            onChange={(e) => setExtraItemMaterialValue(e.target.value)}
                                            type="number"
                                            placeholder="Material Value"
                                          />
                                        </Form.Group>
                                      </Col>

                                      <Col sm={3}>
                                        <Form.Select value={extraItemMeasure} onChange={(e) => { setExtraItemMeasure(e.currentTarget.value) }} >
                                          <option>Select Measurement Type</option>
                                          <option value="area">Area</option>
                                          <option value="width">Width &  Height</option>
                                          <option value="rft">RFT</option>
                                          <option value="qty">Quantity</option>
                                          <option value="length">Width & Length</option>
                                          <option value="selection">Selection</option>
                                        </Form.Select>
                                      </Col>
                                      <Col sm={1}>
                                        <Form.Check
                                          inline
                                          label="Wood"
                                          name="Wood"
                                          type="checkbox"
                                          id="inline-checkbox-1"
                                          checked={isChecked}
                                          onChange={handleCheckboxChange}
                                        />
                                      </Col>
                                      <Col sm={2}>
                                        <Button onClick={addNewLivingItem}>Add Item</Button>
                                      </Col>
                                    </Row>





                                  </Col>

                                </Row>
                              </Form.Group>


                            </Form>
                          </Col>
                        </Row>



                        <Row style={{
                          // marginBottom: '50px',
                          marginLeft: '1px',
                          padding: '20px',
                          borderRadius: '15px',
                          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                          backgroundColor: '#ffffff', // Light background color


                        }} >
                          <Col style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            gap: '12px',
                          }}>
                            <Button className="buttonDesign" style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold" }} onClick={handleCategoryGoBack} >Go Back</Button>
                            {Boolean(restored) && (
                        <Button style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold", backgroundColor: '#fee2e2', color: '#dc2626', border: '1px solid #fca5a5' }} onClick={handleDiscardDraft} disabled={isDiscarding}>{isDiscarding ? "Discarding..." : "Discard Draft"}</Button>
                      )}
                            <Button className="buttonDesign" style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold" }} disabled={isSaving} onClick={() => saveLivingData()}  >{isSaving ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Saving...</> : "Save"}</Button>
                          </Col>
                          <Col className="col-sm-3">

                          </Col>
                          <Col className="col-sm-2"><h4>Total Price</h4></Col>
                          <Col className="col-sm-2">
                            {/* <h4>
                        Rs:- {roomTypePrice}

                      </h4> */}
                            <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{roomTypePrice}</h4></span>
                          </Col>
                        </Row>

                      </Row> : roomTypeModal == 'Other Works' ?
                        <Row className="p-2" style={{
                          marginBottom: '50px',

                          padding: '20px',
                          marginLeft: '20px',
                          borderRadius: '15px',
                          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                          backgroundColor: '#ffffff', // Light background color

                        }} >

                          <div style={{
                            display: "flex",
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '1rem'
                          }}>
                            <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} >
                              <h5>Other Works -- </h5>
                              <h6 style={{ color: '#e85d13', margin: 0 }}>{priceGen === 'value' ? 'New Value' : 'Old Value'}</h6>
                              {Boolean(restored) && draftSaveStatus && (
                                <span style={{ fontSize: "11px", fontWeight: "600", color: draftSaveStatus.includes('Error') ? "#ef4444" : "#15803d", backgroundColor: draftSaveStatus.includes('Error') ? "#fef2f2" : "#f0fdf4", padding: "2px 8px", borderRadius: "12px", border: `1px solid ${draftSaveStatus.includes('Error') ? "#fecaca" : "#bbf7d0"}` }}>
                                  {draftSaveStatus}
                                </span>
                              )}
                            </span>

                            <div>
                              <InputGroup>
                                <Form.Control
                                  style={{
                                    borderRadius: "15px",
                                    padding: "12px 15px",
                                    border: "1px solid #d1d5db",
                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                    background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                                    transition: "all 0.3s ease",
                                    width: "20vw",
                                  }}
                                  onChange={(e) => setSearch(e.target.value)}
                                  placeholder="Search Labels"
                                />
                              </InputGroup>
                            </div>
                          </div>


                          <Row style={{
                            backgroundColor: "#F2F2F2",
                            height: 'auto',
                            marginLeft: '5px',
                            overflowY: 'auto',
                            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                            borderRadius: '15px',
                            padding: '0 0 0 10px',
                          }}>
                            <Col style={{ minHeight: 380, maxHeight: 480 }}>

                              <Form>

                                <Form.Group>
                                  <Row>

                                    <Col sm={12}>

                                      {otherThings
                                        .map((item, index) => ({ item, formData: otherFormData[index], index }))
                                        .filter(({ item }) => {
                                          const searchQuery = search.toLowerCase();
                                          return searchQuery === '' || item.name.toLowerCase().includes(searchQuery);
                                        })
                                        .map(({ item, formData, index }) => (
                                          item.measurement == "area" ?
                                            <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Label
                                                    style={{
                                                      fontSize: 16,
                                                      fontWeight: "500",
                                                    }}
                                                  > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                  </Form.Label>
                                                </Form.Group>
                                              </Col>
                                              {/* <Col sm={2}>
                                              <Form.Group>
                                                <Form.Select
                                                  value={otherFormData[index].value}
                                                  onChange={(e) => handleOtherOptionChange(e, index)}


                                                >
                                                  <option value="0">None</option>
                                                  {item.material.map((item2, index2) => (
                                                    <option
                                                      key={index2}
                                                      value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                    >
                                                      {item2.label}
                                                    </option>
                                                  ))}

                                                </Form.Select>
                                              </Form.Group>
                                            </Col> */}
                                              {/* add label option */}
                                              <Col sm={2} style={{ display: 'flex' }}>
                                                <Dropdown>
                                                  <Dropdown.Toggle
                                                    variant="outline-secondary"
                                                    style={{
                                                      width: '12vw',
                                                      backgroundColor: 'white',
                                                      color: 'black',
                                                      display: 'flex',
                                                      justifyContent: 'space-between',
                                                      alignItems: 'center',
                                                      whiteSpace: 'normal',        // Allows text to wrap
                                                      wordBreak: 'break-word',     // Breaks long words
                                                      padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                    }}>
                                                    {formData.label || 'None'}
                                                  </Dropdown.Toggle>
                                                  <Dropdown.Menu style={{ width: 'auto' }}>
                                                    <Dropdown.Item onClick={() => handleOtherOptionChange({ target: { value: '0' } }, index)}>
                                                      None
                                                    </Dropdown.Item>
                                                    {item.material.map((item2, index2) => (
                                                      <Dropdown.Item
                                                        key={index2}
                                                        onClick={() =>
                                                          handleOtherOptionChange(
                                                            {
                                                              target: {
                                                                value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                label: item2.label
                                                              }
                                                            },
                                                            index
                                                          )
                                                        }
                                                      >
                                                        {item2.label}
                                                      </Dropdown.Item>
                                                    ))}

                                                    <Dropdown.Divider />

                                                    <div className="px-3 py-2">
                                                      <Button
                                                        variant="outline-success"
                                                        size="sm"
                                                        onClick={(e) => {
                                                          e.stopPropagation(); // prevent dropdown from closing
                                                          handleAddNewItem(item, 'OtherWorks', index);
                                                        }}
                                                      >
                                                        <i className="bi bi-plus-square-dotted"></i> Add Item
                                                      </Button>
                                                    </div>
                                                  </Dropdown.Menu>
                                                </Dropdown>
                                              </Col>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={otherFormData[index].area === 0 ? '' : otherFormData[index].area}
                                                    onChange={(e) => handleOtherChange(e, index, "area")}
                                                    placeholder="Area"
                                                  />
                                                </Form.Group>
                                              </Col>

                                              <Col sm={1}>

                                              </Col>

                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={otherFormData[index].price}
                                                    // onChange={(e) => handleOtherPriceChange(e, index, "price")}
                                                    placeholder="Price"
                                                    disabled={otherFormData[index].value ? false : true}
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    value={otherFormData[index].remark}
                                                    onChange={(e) => handleOtherRemarkChange(e, index, "remark")}
                                                    as="textarea" rows={1}
                                                    placeholder="Remark"
                                                  />
                                                </Form.Group>
                                              </Col>

                                              <Col sm={1}>
                                                {item.isUserAdded && (
                                                  <Button variant="danger" onClick={() => deleteUserAddedOtherWorks(index)}>
                                                    <i class="bi bi-x-circle-fill"></i>
                                                  </Button>
                                                )}
                                              </Col>
                                            </Row>
                                            : item.measurement == "width" ?
                                              <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Label
                                                      style={{
                                                        fontSize: 16,
                                                        fontWeight: "500",
                                                      }}
                                                    > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                    </Form.Label>
                                                  </Form.Group>
                                                </Col>
                                                {/* <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Select
                                                    value={otherFormData[index].value}
                                                    onChange={(e) => handleOtherOptionChange(e, index)}


                                                  >
                                                    <option value="0">None</option>
                                                    {item.material.map((item2, index2) => (
                                                      <option
                                                        key={index2}
                                                        value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                      >
                                                        {item2.label}
                                                      </option>
                                                    ))}

                                                  </Form.Select>
                                                </Form.Group>
                                              </Col> */}
                                                {/* add label option */}
                                                <Col sm={2} style={{ display: 'flex' }}>
                                                  <Dropdown>
                                                    <Dropdown.Toggle
                                                      variant="outline-secondary"
                                                      style={{
                                                        width: '12vw',
                                                        backgroundColor: 'white',
                                                        color: 'black',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        whiteSpace: 'normal',        // Allows text to wrap
                                                        wordBreak: 'break-word',     // Breaks long words
                                                        padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                      }}>
                                                      {formData.label || 'None'}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu style={{ width: 'auto' }}>
                                                      <Dropdown.Item onClick={() => handleOtherOptionChange({ target: { value: '0' } }, index)}>
                                                        None
                                                      </Dropdown.Item>
                                                      {item.material.map((item2, index2) => (
                                                        <Dropdown.Item
                                                          key={index2}
                                                          onClick={() =>
                                                            handleOtherOptionChange(
                                                              {
                                                                target: {
                                                                  value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                  label: item2.label
                                                                }
                                                              },
                                                              index
                                                            )
                                                          }
                                                        >
                                                          {item2.label}
                                                        </Dropdown.Item>
                                                      ))}

                                                      <Dropdown.Divider />

                                                      <div className="px-3 py-2">
                                                        <Button
                                                          variant="outline-success"
                                                          size="sm"
                                                          onClick={(e) => {
                                                            e.stopPropagation(); // prevent dropdown from closing
                                                            handleAddNewItem(item, 'OtherWorks', index);
                                                          }}
                                                        >
                                                          <i className="bi bi-plus-square-dotted"></i> Add Item
                                                        </Button>
                                                      </div>
                                                    </Dropdown.Menu>
                                                  </Dropdown>
                                                </Col>
                                                <Col sm={1}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={otherFormData[index].width === 0 ? '' : otherFormData[index].width}
                                                      onChange={(e) => handleOtherChange(e, index, "width")}
                                                      placeholder="Width"
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={1}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={otherFormData[index].height === 0 ? '' : otherFormData[index].height}
                                                      onChange={(e) => handleOtherChange(e, index, "height")}
                                                      placeholder="Height"
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={1}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={otherFormData[index].qnty === 0 ? '' : otherFormData[index].qnty}
                                                      onChange={(e) => handleOtherChange(e, index, "qnty")}
                                                      placeholder="Qty"
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={otherFormData[index].price}
                                                      // onChange={(e) => handleOtherPriceChange(e, index, "price")}
                                                      placeholder="Price"
                                                      disabled={otherFormData[index].value ? false : true}
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      value={otherFormData[index].remark}
                                                      onChange={(e) => handleOtherRemarkChange(e, index, "remark")}
                                                      as="textarea" rows={1}
                                                      placeholder="Remark"
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={1}>
                                                  {item.isUserAdded && (
                                                    <Button variant="danger" onClick={() => deleteUserAddedOtherWorks(index)}>
                                                      <i class="bi bi-x-circle-fill"></i>
                                                    </Button>
                                                  )}
                                                </Col>
                                              </Row>
                                              : item.measurement == "qty" && item.removed !== true ?
                                                <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Label
                                                        style={{
                                                          fontSize: 16,
                                                          fontWeight: "500",
                                                        }}
                                                      > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                      </Form.Label>
                                                    </Form.Group>
                                                  </Col>
                                                  {/* <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Select
                                                      value={otherFormData[index].value}
                                                      onChange={(e) => handleOtherOptionChange(e, index)}


                                                    >
                                                      <option value="0">None</option>
                                                      {item.material.map((item2, index2) => (
                                                        <option
                                                          key={index2}
                                                          value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                        >
                                                          {item2.label}
                                                        </option>
                                                      ))}

                                                    </Form.Select>
                                                  </Form.Group>
                                                </Col> */}
                                                  {/* add label option */}
                                                  <Col sm={2} style={{ display: 'flex' }}>
                                                    <Dropdown>
                                                      <Dropdown.Toggle
                                                        variant="outline-secondary"
                                                        style={{
                                                          width: '12vw',
                                                          backgroundColor: 'white',
                                                          color: 'black',
                                                          display: 'flex',
                                                          justifyContent: 'space-between',
                                                          alignItems: 'center',
                                                          whiteSpace: 'normal',        // Allows text to wrap
                                                          wordBreak: 'break-word',     // Breaks long words
                                                          padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                        }}>
                                                        {formData.label || 'None'}
                                                      </Dropdown.Toggle>
                                                      <Dropdown.Menu style={{ width: 'auto' }}>
                                                        <Dropdown.Item onClick={() => handleOtherOptionChange({ target: { value: '0' } }, index)}>
                                                          None
                                                        </Dropdown.Item>
                                                        {item.material.map((item2, index2) => (
                                                          <Dropdown.Item
                                                            key={index2}
                                                            onClick={() =>
                                                              handleOtherOptionChange(
                                                                {
                                                                  target: {
                                                                    value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                    label: item2.label
                                                                  }
                                                                },
                                                                index
                                                              )
                                                            }
                                                          >
                                                            {item2.label}
                                                          </Dropdown.Item>
                                                        ))}

                                                        <Dropdown.Divider />

                                                        <div className="px-3 py-2">
                                                          <Button
                                                            variant="outline-success"
                                                            size="sm"
                                                            onClick={(e) => {
                                                              e.stopPropagation(); // prevent dropdown from closing
                                                              handleAddNewItem(item, 'OtherWorks', index);
                                                            }}
                                                          >
                                                            <i className="bi bi-plus-square-dotted"></i> Add Item
                                                          </Button>
                                                        </div>
                                                      </Dropdown.Menu>
                                                    </Dropdown>
                                                  </Col>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={otherFormData[index].qnty === 0 ? '' : otherFormData[index].qnty}
                                                        onChange={(e) => handleOtherChange(e, index, "qnty")}
                                                        placeholder="Qty"
                                                      />
                                                    </Form.Group>
                                                  </Col>

                                                  <Col sm={1}>

                                                  </Col>

                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={otherFormData[index].price}
                                                        // onChange={(e) => handleOtherPriceChange(e, index, "price")}
                                                        placeholder="Price"
                                                        disabled={otherFormData[index].value ? false : true}
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        value={otherFormData[index].remark}
                                                        onChange={(e) => handleOtherRemarkChange(e, index, "remark")}
                                                        as="textarea" rows={1}
                                                        placeholder="Remark"
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={1}>
                                                    {item.isUserAdded && (
                                                      <Button variant="danger" onClick={() => deleteUserAddedOtherWorks(index)}>
                                                        <i class="bi bi-x-circle-fill"></i>
                                                      </Button>
                                                    )}
                                                  </Col>
                                                </Row>
                                                : item.measurement == "length" ?
                                                  <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Label
                                                          style={{
                                                            fontSize: 16,
                                                            fontWeight: "500",
                                                          }}
                                                        > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                        </Form.Label>
                                                      </Form.Group>
                                                    </Col>
                                                    {/* <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Select
                                                        value={otherFormData[index].value}
                                                        onChange={(e) => handleOtherOptionChange(e, index)}


                                                      >
                                                        <option value="0">None</option>
                                                        {item.material.map((item2, index2) => (
                                                          <option
                                                            key={index2}
                                                            value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                          >
                                                            {item2.label}
                                                          </option>
                                                        ))}

                                                      </Form.Select>
                                                    </Form.Group>
                                                  </Col> */}
                                                    {/* add label option */}
                                                    <Col sm={2} style={{ display: 'flex' }}>
                                                      <Dropdown>
                                                        <Dropdown.Toggle
                                                          variant="outline-secondary"
                                                          style={{
                                                            width: '12vw',
                                                            backgroundColor: 'white',
                                                            color: 'black',
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            whiteSpace: 'normal',        // Allows text to wrap
                                                            wordBreak: 'break-word',     // Breaks long words
                                                            padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                          }}>
                                                          {formData.label || 'None'}
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu style={{ width: 'auto' }}>
                                                          <Dropdown.Item onClick={() => handleOtherOptionChange({ target: { value: '0' } }, index)}>
                                                            None
                                                          </Dropdown.Item>
                                                          {item.material.map((item2, index2) => (
                                                            <Dropdown.Item
                                                              key={index2}
                                                              onClick={() =>
                                                                handleOtherOptionChange(
                                                                  {
                                                                    target: {
                                                                      value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                      label: item2.label
                                                                    }
                                                                  },
                                                                  index
                                                                )
                                                              }
                                                            >
                                                              {item2.label}
                                                            </Dropdown.Item>
                                                          ))}

                                                          <Dropdown.Divider />

                                                          <div className="px-3 py-2">
                                                            <Button
                                                              variant="outline-success"
                                                              size="sm"
                                                              onClick={(e) => {
                                                                e.stopPropagation(); // prevent dropdown from closing
                                                                handleAddNewItem(item, 'OtherWorks', index);
                                                              }}
                                                            >
                                                              <i className="bi bi-plus-square-dotted"></i> Add Item
                                                            </Button>
                                                          </div>
                                                        </Dropdown.Menu>
                                                      </Dropdown>
                                                    </Col>
                                                    <Col sm={1}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={otherFormData[index].height === 0 ? '' : otherFormData[index].height}
                                                          onChange={(e) => handleOtherChange(e, index, "height")}
                                                          placeholder="Length"
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={1}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={otherFormData[index].width === 0 ? '' : otherFormData[index].width}
                                                          onChange={(e) => handleOtherChange(e, index, "width")}
                                                          placeholder="Width"
                                                        />
                                                      </Form.Group>
                                                    </Col>


                                                    <Col sm={1}>

                                                    </Col>

                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={otherFormData[index].price}
                                                          // onChange={(e) => handleOtherPriceChange(e, index, "price")}
                                                          placeholder="Price"
                                                          disabled={otherFormData[index].value ? false : true}
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          value={otherFormData[index].remark}
                                                          onChange={(e) => handleOtherRemarkChange(e, index, "remark")}
                                                          as="textarea" rows={1}
                                                          placeholder="Remark"
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={1}>
                                                      {item.isUserAdded && (
                                                        <Button variant="danger" onClick={() => deleteUserAddedOtherWorks(index)}>
                                                          <i class="bi bi-x-circle-fill"></i>
                                                        </Button>
                                                      )}
                                                    </Col>
                                                  </Row> : item.measurement == "rft" ?
                                                    <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Label
                                                            style={{
                                                              fontSize: 16,
                                                              fontWeight: "500",
                                                            }}
                                                          > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                          </Form.Label>
                                                        </Form.Group>
                                                      </Col>
                                                      {/* <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Select
                                                          value={otherFormData[index].value}
                                                          onChange={(e) => handleOtherOptionChange(e, index)}


                                                        >
                                                          <option value="0">None</option>
                                                          {item.material.map((item2, index2) => (
                                                            <option
                                                              key={index2}
                                                              value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                            >
                                                              {item2.label}
                                                            </option>
                                                          ))}

                                                        </Form.Select>
                                                      </Form.Group>
                                                    </Col> */}
                                                      {/* add label option */}
                                                      <Col sm={2} style={{ display: 'flex' }}>
                                                        <Dropdown>
                                                          <Dropdown.Toggle
                                                            variant="outline-secondary"
                                                            style={{
                                                              width: '12vw',
                                                              backgroundColor: 'white',
                                                              color: 'black',
                                                              display: 'flex',
                                                              justifyContent: 'space-between',
                                                              alignItems: 'center',
                                                              whiteSpace: 'normal',        // Allows text to wrap
                                                              wordBreak: 'break-word',     // Breaks long words
                                                              padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                            }}>
                                                            {formData.label || 'None'}
                                                          </Dropdown.Toggle>
                                                          <Dropdown.Menu style={{ width: 'auto' }}>
                                                            <Dropdown.Item onClick={() => handleOtherOptionChange({ target: { value: '0' } }, index)}>
                                                              None
                                                            </Dropdown.Item>
                                                            {item.material.map((item2, index2) => (
                                                              <Dropdown.Item
                                                                key={index2}
                                                                onClick={() =>
                                                                  handleOtherOptionChange(
                                                                    {
                                                                      target: {
                                                                        value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                        label: item2.label
                                                                      }
                                                                    },
                                                                    index
                                                                  )
                                                                }
                                                              >
                                                                {item2.label}
                                                              </Dropdown.Item>
                                                            ))}

                                                            <Dropdown.Divider />

                                                            <div className="px-3 py-2">
                                                              <Button
                                                                variant="outline-success"
                                                                size="sm"
                                                                onClick={(e) => {
                                                                  e.stopPropagation(); // prevent dropdown from closing
                                                                  handleAddNewItem(item, 'OtherWorks', index);
                                                                }}
                                                              >
                                                                <i className="bi bi-plus-square-dotted"></i> Add Item
                                                              </Button>
                                                            </div>
                                                          </Dropdown.Menu>
                                                        </Dropdown>
                                                      </Col>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={otherFormData[index].rft === 0 ? '' : otherFormData[index].rft}
                                                            onChange={(e) => handleOtherChange(e, index, "rft")}
                                                            placeholder="RFT"
                                                          />
                                                        </Form.Group>
                                                      </Col>

                                                      <Col sm={1}>

                                                      </Col>

                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={otherFormData[index].price}
                                                            // onChange={(e) => handleOtherPriceChange(e, index, "price")}
                                                            placeholder="Price"
                                                            disabled={otherFormData[index].value ? false : true}
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            value={otherFormData[index].remark}
                                                            onChange={(e) => handleOtherRemarkChange(e, index, "remark")}
                                                            as="textarea" rows={1}
                                                            placeholder="Remark"
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={1}>
                                                        {item.isUserAdded && (
                                                          <Button variant="danger" onClick={() => deleteUserAddedOtherWorks(index)}>
                                                            <i class="bi bi-x-circle-fill"></i>
                                                          </Button>
                                                        )}
                                                      </Col>
                                                    </Row> : item.measurement == "painting" ?
                                                      <Row className={`mx-1 my-3 ${isItemFilled(formData) ? 'selected-row' : ''}`}>
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Label
                                                              style={{
                                                                fontSize: 16,
                                                                fontWeight: "500",
                                                              }}
                                                            > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                            </Form.Label>
                                                          </Form.Group>
                                                        </Col>
                                                        {/* <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Select
                                                            value={otherFormData[index].value}
                                                            onChange={(e) => handleOtherOptionChange(e, index)}


                                                          >
                                                            <option value="0">None</option>
                                                            {item.material.map((item2, index2) => (
                                                              <option
                                                                key={index2}
                                                                value={priceGen === 'oldvalue' ? item2.oldvalue : item2.value}
                                                              >
                                                                {item2.label}
                                                              </option>
                                                            ))}

                                                          </Form.Select>
                                                        </Form.Group>
                                                      </Col> */}
                                                        {/* add label option */}
                                                        <Col sm={2} style={{ display: 'flex' }}>
                                                          <Dropdown>
                                                            <Dropdown.Toggle
                                                              variant="outline-secondary"
                                                              style={{
                                                                width: '12vw',
                                                                backgroundColor: 'white',
                                                                color: 'black',
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                whiteSpace: 'normal',        // Allows text to wrap
                                                                wordBreak: 'break-word',     // Breaks long words
                                                                padding: '0.5rem',           // Optional: Adds padding for better appearance
                                                              }}>
                                                              {formData.label || 'None'}
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu style={{ width: 'auto' }}>
                                                              <Dropdown.Item onClick={() => handleOtherOptionChange({ target: { value: '0' } }, index)}>
                                                                None
                                                              </Dropdown.Item>
                                                              {item.material.map((item2, index2) => (
                                                                <Dropdown.Item
                                                                  key={index2}
                                                                  onClick={() =>
                                                                    handleOtherOptionChange(
                                                                      {
                                                                        target: {
                                                                          value: priceGen === 'oldvalue' ? item2.oldvalue : item2.value,
                                                                          label: item2.label
                                                                        }
                                                                      },
                                                                      index
                                                                    )
                                                                  }
                                                                >
                                                                  {item2.label}
                                                                </Dropdown.Item>
                                                              ))}

                                                              <Dropdown.Divider />

                                                              <div className="px-3 py-2">
                                                                <Button
                                                                  variant="outline-success"
                                                                  size="sm"
                                                                  onClick={(e) => {
                                                                    e.stopPropagation(); // prevent dropdown from closing
                                                                    handleAddNewItem(item, 'OtherWorks', index);
                                                                  }}
                                                                >
                                                                  <i className="bi bi-plus-square-dotted"></i> Add Item
                                                                </Button>
                                                              </div>
                                                            </Dropdown.Menu>
                                                          </Dropdown>
                                                        </Col>
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={otherFormData[index].painting === 0 ? '' : otherFormData[index].painting}
                                                              onChange={(e) => handleOtherChange(e, index, "painting")}
                                                              placeholder="Area"
                                                            />
                                                          </Form.Group>
                                                        </Col>

                                                        <Col sm={1}>

                                                        </Col>

                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={otherFormData[index].price}
                                                              // onChange={(e) => handleOtherPriceChange(e, index, "price")}
                                                              placeholder="Price"
                                                              disabled={otherFormData[index].value ? false : true}
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              value={otherFormData[index].remark}
                                                              onChange={(e) => handleOtherRemarkChange(e, index, "remark")}
                                                              as="textarea" rows={1}
                                                              placeholder="Remark"
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={1}>
                                                          {item.isUserAdded && (
                                                            <Button variant="danger" onClick={() => deleteUserAddedOtherWorks(index)}>
                                                              <i class="bi bi-x-circle-fill"></i>
                                                            </Button>
                                                          )}
                                                        </Col>
                                                      </Row> : null
                                        ))}


                                    </Col>
                                  </Row>

                                  <Row>
                                    <Col>

                                      <Row className="mx-1 my-3">
                                        <Col sm={2}>
                                          <Form.Group >
                                            <Form.Control
                                              value={extraItemName}
                                              onChange={(e) => setExtraItemName(e.target.value)}
                                              type="text"
                                              placeholder="Item Name"
                                            />
                                          </Form.Group>
                                        </Col>
                                        <Col sm={2}>
                                          <Form.Group >
                                            <Form.Control
                                              value={extraItemMaterialName}
                                              onChange={(e) => setExtraItemMaterialName(e.target.value)}
                                              type="text"
                                              placeholder="Material Name"
                                            />
                                          </Form.Group>
                                        </Col>
                                        <Col sm={2}>
                                          <Form.Group >
                                            <Form.Control
                                              value={extraItemMaterialValue}
                                              onChange={(e) => setExtraItemMaterialValue(e.target.value)}
                                              type="number"
                                              placeholder="Material Value"
                                            />
                                          </Form.Group>
                                        </Col>

                                        <Col sm={3}>
                                          <Form.Select value={extraItemMeasure} onChange={(e) => { setExtraItemMeasure(e.currentTarget.value) }} >
                                            <option>Select Measurement Type</option>
                                            <option value="area">Area</option>
                                            <option value="width">Width &  Height</option>
                                            <option value="rft">RFT</option>
                                            <option value="qty">Quantity</option>
                                            <option value="length">Width & Length</option>
                                            <option value="selection">Selection</option>
                                          </Form.Select>
                                        </Col>
                                        <Col sm={1}>
                                          {/* <Form.Check
                                          inline
                                          label="Wood"
                                          name="Wood"
                                          type="checkbox"
                                          id="inline-checkbox-1"
                                          checked={isChecked}
                                          onChange={handleCheckboxChange}
                                        /> */}
                                        </Col>
                                        <Col sm={2}>
                                          <Button onClick={addNewOtherWorkItem}>Add Item</Button>
                                        </Col>
                                      </Row>





                                    </Col>

                                  </Row>

                                </Form.Group>


                              </Form>
                            </Col>
                          </Row>

                          <Row style={{
                            // marginBottom: '50px',
                            marginLeft: '1px',
                            padding: '20px',
                            borderRadius: '15px',
                            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                            backgroundColor: '#ffffff', // Light background color


                          }} >
                            <Col style={{
                              display: 'flex',
                              justifyContent: 'flex-start',
                              gap: '12px',
                            }}>
                              <Button className="buttonDesign" style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold" }} onClick={handleCategoryGoBack} >Go Back</Button>
                              {Boolean(restored) && (
                        <Button style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold", backgroundColor: '#fee2e2', color: '#dc2626', border: '1px solid #fca5a5' }} onClick={handleDiscardDraft} disabled={isDiscarding}>{isDiscarding ? "Discarding..." : "Discard Draft"}</Button>
                      )}
                              <Button className="buttonDesign" style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold" }} disabled={isSaving} onClick={() => saveOtherData()}  >{isSaving ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Saving...</> : "Save"}</Button>
                            </Col>
                            <Col className="col-sm-3">

                            </Col>
                            <Col className="col-sm-2"><h4>Total Price</h4></Col>
                            <Col className="col-sm-2">
                              {/* <h4>
                        Rs:- {roomTypePrice}

                      </h4> */}
                              <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{roomTypePrice}</h4></span>
                            </Col>
                          </Row>

                        </Row> : roomTypeModal == 'Loose Furniture' ?
                          <Row className="p-2" style={{
                            marginBottom: '50px',

                            padding: '20px',
                            marginLeft: '20px',
                            borderRadius: '15px',
                            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                            backgroundColor: '#ffffff', // Light background color

                          }} >

                            <div style={{
                              display: "flex",
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              padding: '1rem'
                            }}>
                              <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} >
                                <h5>loose Furniture-- </h5>
                                <h6 style={{ color: '#e85d13', margin: 0 }}>{priceGen === 'value' ? 'New Value' : 'Old Value'}</h6>
                                {Boolean(restored) && draftSaveStatus && (
                                  <span style={{ fontSize: "11px", fontWeight: "600", color: draftSaveStatus.includes('Error') ? "#ef4444" : "#15803d", backgroundColor: draftSaveStatus.includes('Error') ? "#fef2f2" : "#f0fdf4", padding: "2px 8px", borderRadius: "12px", border: `1px solid ${draftSaveStatus.includes('Error') ? "#fecaca" : "#bbf7d0"}` }}>
                                    {draftSaveStatus}
                                  </span>
                                )}
                              </span>

                              <div>
                                <InputGroup>
                                  <Form.Control
                                    style={{
                                      borderRadius: "15px",
                                      padding: "12px 15px",
                                      border: "1px solid #d1d5db",
                                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                      background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                                      transition: "all 0.3s ease",
                                      width: "20vw",
                                    }}
                                    onChange={(e) => setSearch(e.target.value)}
                                    placeholder="Search Labels"
                                  />
                                </InputGroup>
                              </div>
                            </div>

                            <Row style={{
                              backgroundColor: "#F2F2F2",
                              height: 'auto',
                              marginLeft: '5px',
                              overflowY: 'auto',
                              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                              borderRadius: '15px',
                              padding: '0 0 0 10px',
                            }}>
                              <Col style={{ minHeight: 380, maxHeight: 480 }}>

                                <Form>

                                  <Form.Group>
                                    <Row>

                                      <Col sm={12}>

                                        {looseThingsData.map((item, index) => (
                                          item.measurement == "area" ?
                                            <Row className={`mx-1 my-3 ${isItemFilled(looseFormData && looseFormData[index]) ? 'selected-row' : ''}`}>
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Label
                                                    style={{
                                                      fontSize: 16,
                                                      fontWeight: "500",
                                                    }}
                                                  > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                  </Form.Label>
                                                </Form.Group>
                                              </Col>
                                              {/* <Col sm={2}>
                                                {/* <Form.Group>
                                                  <Form.Select
                                                    value={looseFormData[index].value}
                                                    onChange={(e) => handleLooseOptionChange(e, index)}


                                                  >
                                                    <option value="0">None</option>
                                                   {item.material.map((item2, index2) => (
                                                priceGen === 'oldvalue' ? (
                                                  <option value={item2.oldvalue} key={index2}>
                                                    {item2.label}
                                                  </option>
                                                ) : (
                                                  <option value={item2.value} key={index2}>
                                                    {item2.label}
                                                  </option>
                                                )
                                              ))}   

                                                  </Form.Select>
                                                </Form.Group> 
                                              </Col> */}
                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={looseFormData[index].area}
                                                    onChange={(e) => handleLooseChange(e, index, "area")}
                                                    placeholder="Area"
                                                  />
                                                </Form.Group>
                                              </Col>

                                              <Col sm={1}>

                                              </Col>

                                              <Col sm={2}>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="number"
                                                    value={looseFormData[index].price}
                                                    // onChange={(e) => handleLoosePriceChange(e, index, "price")}
                                                    placeholder="Price"
                                                    disabled={looseFormData[index].value ? false : true}
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col sm={3}>
                                                <Form.Group>
                                                  <Form.Control
                                                    value={looseFormData[index].remark}
                                                    onChange={(e) => handleLooseRemarkChange(e, index, "remark")}
                                                    as="textarea" rows={1}
                                                    placeholder="Remark"
                                                  />
                                                </Form.Group>
                                              </Col>
                                            </Row>
                                            : item.measurement == "width" ?
                                              <Row className={`mx-1 my-3 ${isItemFilled(looseFormData && looseFormData[index]) ? 'selected-row' : ''}`}>
                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Label
                                                      style={{
                                                        fontSize: 16,
                                                        fontWeight: "500",
                                                      }}
                                                    > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                    </Form.Label>
                                                  </Form.Group>
                                                </Col>
                                                {/* <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Select
                                                      value={looseFormData[index].value}
                                                      onChange={(e) => handleLooseOptionChange(e, index)}


                                                    >
                                                      <option value="0">None</option>
                                                      {item.material.map((item2, index2) => (
                                                priceGen === 'oldvalue' ? (
                                                  <option value={item2.oldvalue} key={index2}>
                                                    {item2.label}
                                                  </option>
                                                ) : (
                                                  <option value={item2.value} key={index2}>
                                                    {item2.label}
                                                  </option>
                                                )
                                              ))}

                                                    </Form.Select>
                                                  </Form.Group>
                                                </Col> */}
                                                <Col sm={1}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={looseFormData[index].width}
                                                      onChange={(e) => handleLooseChange(e, index, "width")}
                                                      placeholder="Width"
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={1}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={looseFormData[index].height}
                                                      onChange={(e) => handleLooseChange(e, index, "height")}
                                                      placeholder="Height"
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={1}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={looseFormData[index].qnty}
                                                      onChange={(e) => handleLooseChange(e, index, "qnty")}
                                                      placeholder="Qty"
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm={2}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      type="number"
                                                      value={looseFormData[index].price}
                                                      // onChange={(e) => handleLoosePriceChange(e, index, "price")}
                                                      placeholder="Price"
                                                      disabled={looseFormData[index].value ? false : true}
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm={3}>
                                                  <Form.Group>
                                                    <Form.Control
                                                      value={looseFormData[index].remark}
                                                      onChange={(e) => handleLooseRemarkChange(e, index, "remark")}
                                                      as="textarea" rows={1}
                                                      placeholder="Remark"
                                                    />
                                                  </Form.Group>
                                                </Col>
                                              </Row>
                                              : item.measurement == "qty" && item.removed !== true ?
                                                <Row className={`mx-1 my-3 ${isItemFilled(looseFormData && looseFormData[index]) ? 'selected-row' : ''}`}>
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Label
                                                        style={{
                                                          fontSize: 16,
                                                          fontWeight: "500",
                                                        }}
                                                      > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                      </Form.Label>
                                                    </Form.Group>
                                                  </Col>
                                                  {/* <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Select
                                                        value={looseFormData[index].value}
                                                        onChange={(e) => handleLooseOptionChange(e, index)}


                                                      >
                                                        <option value="0">None</option>
                                                        {item.material.map((item2, index2) => (
                                                priceGen === 'oldvalue' ? (
                                                  <option value={item2.oldvalue} key={index2}>
                                                    {item2.label}
                                                  </option>
                                                ) : (
                                                  <option value={item2.value} key={index2}>
                                                    {item2.label}
                                                  </option>
                                                )
                                              ))}

                                                      </Form.Select>
                                                    </Form.Group>
                                                  </Col> */}
                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={looseFormData[index].qnty}
                                                        onChange={(e) => handleLooseChange(e, index, "qnty")}
                                                        placeholder="Qty"
                                                      />
                                                    </Form.Group>
                                                  </Col>

                                                  <Col sm={1}>

                                                  </Col>

                                                  <Col sm={2}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        type="number"
                                                        value={looseFormData[index].price}
                                                        // onChange={(e) => handleLoosePriceChange(e, index, "price")}
                                                        placeholder="Price"
                                                        disabled={looseFormData[index].value ? false : true}
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                  <Col sm={3}>
                                                    <Form.Group>
                                                      <Form.Control
                                                        value={looseFormData[index].remark}
                                                        onChange={(e) => handleLooseRemarkChange(e, index, "remark")}
                                                        as="textarea" rows={1}
                                                        placeholder="Remark"
                                                      />
                                                    </Form.Group>
                                                  </Col>
                                                </Row>
                                                : item.measurement == "length" ?
                                                  <Row className={`mx-1 my-3 ${isItemFilled(looseFormData && looseFormData[index]) ? 'selected-row' : ''}`}>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Label
                                                          style={{
                                                            fontSize: 16,
                                                            fontWeight: "500",
                                                          }}
                                                        > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                        </Form.Label>
                                                      </Form.Group>
                                                    </Col>
                                                    {/* <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Select
                                                          value={looseFormData[index].value}
                                                          onChange={(e) => handleLooseOptionChange(e, index)}


                                                        >
                                                          <option value="0">None</option>
                                                          {item.material.map((item2, index2) => (
                                                priceGen === 'oldvalue' ? (
                                                  <option value={item2.oldvalue} key={index2}>
                                                    {item2.label}
                                                  </option>
                                                ) : (
                                                  <option value={item2.value} key={index2}>
                                                    {item2.label}
                                                  </option>
                                                )
                                              ))}

                                                        </Form.Select>
                                                      </Form.Group>
                                                    </Col> */}
                                                    <Col sm={1}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={looseFormData[index].height}
                                                          onChange={(e) => handleLooseChange(e, index, "height")}
                                                          placeholder="Length"
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={1}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={looseFormData[index].width}
                                                          onChange={(e) => handleLooseChange(e, index, "width")}
                                                          placeholder="Width"
                                                        />
                                                      </Form.Group>
                                                    </Col>


                                                    <Col sm={1}>

                                                    </Col>

                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={looseFormData[index].price}
                                                          // onChange={(e) => handleLoosePriceChange(e, index, "price")}
                                                          placeholder="Price"
                                                          disabled={looseFormData[index].value ? false : true}
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={3}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          value={looseFormData[index].remark}
                                                          onChange={(e) => handleLooseRemarkChange(e, index, "remark")}
                                                          as="textarea" rows={1}
                                                          placeholder="Remark"
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                  </Row> : item.measurement == "rft" ?
                                                    <Row className={`mx-1 my-3 ${isItemFilled(looseFormData && looseFormData[index]) ? 'selected-row' : ''}`}>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Label
                                                            style={{
                                                              fontSize: 16,
                                                              fontWeight: "500",
                                                            }}
                                                          > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                          </Form.Label>
                                                        </Form.Group>
                                                      </Col>
                                                      {/* <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Select
                                                            value={looseFormData[index].value}
                                                            onChange={(e) => handleLooseOptionChange(e, index)}


                                                          >
                                                            <option value="0">None</option>
                                                            {item.material.map((item2, index2) => (
                                                priceGen === 'oldvalue' ? (
                                                  <option value={item2.oldvalue} key={index2}>
                                                    {item2.label}
                                                  </option>
                                                ) : (
                                                  <option value={item2.value} key={index2}>
                                                    {item2.label}
                                                  </option>
                                                )
                                              ))}

                                                          </Form.Select>
                                                        </Form.Group>
                                                      </Col> */}
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={looseFormData[index].rft}
                                                            onChange={(e) => handleLooseChange(e, index, "rft")}
                                                            placeholder="RFT"
                                                          />
                                                        </Form.Group>
                                                      </Col>

                                                      <Col sm={1}>

                                                      </Col>

                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={looseFormData[index].price}
                                                            // onChange={(e) => handleLoosePriceChange(e, index, "price")}
                                                            placeholder="Price"
                                                            disabled={looseFormData[index].value ? false : true}
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={3}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            value={looseFormData[index].remark}
                                                            onChange={(e) => handleLooseRemarkChange(e, index, "remark")}
                                                            as="textarea" rows={1}
                                                            placeholder="Remark"
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                    </Row> : null
                                        ))}


                                      </Col>
                                    </Row>

                                  </Form.Group>


                                </Form>
                              </Col>
                            </Row>

                            <Row style={{
                              // marginBottom: '50px',
                              marginLeft: '1px',
                              padding: '20px',
                              borderRadius: '15px',
                              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                              backgroundColor: '#ffffff', // Light background color


                            }} >
                              <Col style={{
                                display: 'flex',
                                justifyContent: 'flex-start',
                                gap: '12px',
                              }}>
                                <Button className="buttonDesign" style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold" }} onClick={handleCategoryGoBack} >Go Back</Button>
                                {Boolean(restored) && (
                        <Button style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold", backgroundColor: '#fee2e2', color: '#dc2626', border: '1px solid #fca5a5' }} onClick={handleDiscardDraft} disabled={isDiscarding}>{isDiscarding ? "Discarding..." : "Discard Draft"}</Button>
                      )}
                                <Button className="buttonDesign" style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold" }} disabled={isSaving} onClick={() => saveLooseData()}  >{isSaving ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Saving...</> : "Save"}</Button>
                              </Col>
                              <Col className="col-sm-3">

                              </Col>
                              <Col className="col-sm-2"><h4>Total Price</h4></Col>
                              <Col className="col-sm-2">
                                {/* <h4>
                        Rs:- {roomTypePrice}

                      </h4> */}
                                <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{roomTypePrice}</h4></span>
                              </Col>
                            </Row>

                          </Row> : roomTypeModal == 'Accessories' ?
                            <Row className="p-2" style={{
                              marginBottom: '50px',

                              padding: '20px',
                              marginLeft: '20px',
                              borderRadius: '15px',
                              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                              backgroundColor: '#ffffff', // Light background color

                            }}>


                              <div style={{
                                display: "flex",
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '1rem'
                              }}>
                                <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} >
                                  <h5> Accessories-- </h5>
                                  <h6 style={{ color: '#e85d13', margin: 0 }}>{priceGen === 'value' ? 'New Value' : 'Old Value'}</h6>
                                  {Boolean(restored) && draftSaveStatus && (
                                    <span style={{ fontSize: "11px", fontWeight: "600", color: draftSaveStatus.includes('Error') ? "#ef4444" : "#15803d", backgroundColor: draftSaveStatus.includes('Error') ? "#fef2f2" : "#f0fdf4", padding: "2px 8px", borderRadius: "12px", border: `1px solid ${draftSaveStatus.includes('Error') ? "#fecaca" : "#bbf7d0"}` }}>
                                      {draftSaveStatus}
                                    </span>
                                  )}
                                </span>
                                <div>
                                  <InputGroup>
                                    <Form.Control
                                      style={{
                                        borderRadius: "15px",
                                        padding: "12px 15px",
                                        border: "1px solid #d1d5db",
                                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                        background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
                                        transition: "all 0.3s ease",
                                        width: "20vw",
                                      }}
                                      onChange={(e) => setSearch(e.target.value)}
                                      placeholder="Search Labels"
                                    />
                                  </InputGroup>
                                </div>
                              </div>


                              <Row style={{
                                backgroundColor: "#F2F2F2",
                                height: 'auto',
                                marginLeft: '5px',
                                overflowY: 'auto',
                                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                                borderRadius: '15px',
                                padding: '0 0 0 10px',
                              }}>
                                <Col style={{ minHeight: 380, maxHeight: 480 }}>

                                  <Form>

                                    <Form.Group>
                                      <Row>

                                        <Col sm={12}>

                                          {accessoriesThingsDataCopy.map((item, index) => ({ item, index }))
                                            .filter(({ item }) => {
                                              const searchQuery = search.toLowerCase();
                                              return searchQuery === '' || item.name.toLowerCase().includes(searchQuery)
                                            }).map(({ item, index }) => (
                                              (
                                                item.measurement == "area" ?
                                                  <Row className={`mx-1 my-3 ${isItemFilled(accessoriesFormData && accessoriesFormData[index]) ? 'selected-row' : ''}`}>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Label
                                                          style={{
                                                            fontSize: 16,
                                                            fontWeight: "500",
                                                          }}
                                                        > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                        </Form.Label>
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Select
                                                          value={accessoriesFormData[index].value}
                                                          onChange={(e) => handleAccessoriesOptionChange(e, index)}


                                                        >
                                                          <option value="0">None</option>
                                                          {item.material.map((item2, index2) => (
                                                            priceGen === 'oldvalue' ? (
                                                              <option value={item2.oldvalue} key={index2}>
                                                                {item2.label}
                                                              </option>
                                                            ) : (
                                                              <option value={item2.value} key={index2}>
                                                                {item2.label}
                                                              </option>
                                                            )
                                                          ))}

                                                        </Form.Select>
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={accessoriesFormData[index].area === 0 ? '' : accessoriesFormData[index].area}
                                                          onChange={(e) => handleAccessoriesChange(e, index, "area")}
                                                          placeholder="Area"
                                                        />
                                                      </Form.Group>
                                                    </Col>

                                                    <Col sm={1}>

                                                    </Col>

                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          type="number"
                                                          value={accessoriesFormData[index].price}
                                                          // onChange={(e) => handleAccessoriesPriceChange(e, index, "price")}
                                                          placeholder="Price"
                                                          disabled={accessoriesFormData[index].value ? false : true}
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={2}>
                                                      <Form.Group>
                                                        <Form.Control
                                                          value={accessoriesFormData[index].remark}
                                                          onChange={(e) => handleAccessoriesRemarkChange(e, index, "remark")}
                                                          as="textarea" rows={1}
                                                          placeholder="Remark"
                                                        />
                                                      </Form.Group>
                                                    </Col>
                                                    <Col sm={1}>
                                                      {item.isUserAdded && (
                                                        <Button variant="danger" onClick={() => deleteUserAddedAccessories(index)}>
                                                          <i class="bi bi-x-circle-fill"></i>
                                                        </Button>
                                                      )}
                                                    </Col>
                                                  </Row>
                                                  : item.measurement == "width" ?
                                                    <Row className={`mx-1 my-3 ${isItemFilled(accessoriesFormData && accessoriesFormData[index]) ? 'selected-row' : ''}`}>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Label
                                                            style={{
                                                              fontSize: 16,
                                                              fontWeight: "500",
                                                            }}
                                                          > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                          </Form.Label>
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Select
                                                            value={accessoriesFormData[index].value}
                                                            onChange={(e) => handleAccessoriesOptionChange(e, index)}


                                                          >
                                                            <option value="0">None</option>
                                                            {item.material.map((item2, index2) => (
                                                              <option value={item2.value} key={index2}>{item2.label}</option>
                                                            ))}

                                                          </Form.Select>
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={1}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={accessoriesFormData[index].width === 0 ? '' : accessoriesFormData[index].width}
                                                            onChange={(e) => handleAccessoriesChange(e, index, "width")}
                                                            placeholder="Width"
                                                          />
                                                        </Form.Group>
                                                      </Col>

                                                      <Col sm={1}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={accessoriesFormData[index].height === 0 ? '' : accessoriesFormData[index].height}
                                                            onChange={(e) => handleAccessoriesChange(e, index, "height")}
                                                            placeholder="Height"
                                                          />
                                                        </Form.Group>
                                                      </Col>

                                                      <Col sm={1}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={accessoriesFormData[index].qnty === 0 ? '' : accessoriesFormData[index].qnty}
                                                            onChange={(e) => handleAccessoriesChange(e, index, "qnty")}
                                                            placeholder="Qty"
                                                          />
                                                        </Form.Group>
                                                      </Col>

                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            type="number"
                                                            value={accessoriesFormData[index].price}
                                                            // onChange={(e) => handleAccessoriesPriceChange(e, index, "price")}
                                                            placeholder="Price"
                                                            disabled={accessoriesFormData[index].value ? false : true}
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={2}>
                                                        <Form.Group>
                                                          <Form.Control
                                                            value={accessoriesFormData[index].remark}
                                                            onChange={(e) => handleAccessoriesRemarkChange(e, index, "remark")}
                                                            as="textarea" rows={1}
                                                            placeholder="Remark"
                                                          />
                                                        </Form.Group>
                                                      </Col>
                                                      <Col sm={1}>
                                                        {item.isUserAdded && (
                                                          <Button variant="danger" onClick={() => deleteUserAddedAccessories(index)}>
                                                            <i class="bi bi-x-circle-fill"></i>
                                                          </Button>
                                                        )}
                                                      </Col>
                                                    </Row>
                                                    : item.measurement == "qty" && item.removed !== true ?
                                                      <Row className={`mx-1 my-3 ${isItemFilled(accessoriesFormData && accessoriesFormData[index]) ? 'selected-row' : ''}`}>
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Label
                                                              style={{
                                                                fontSize: 16,
                                                                fontWeight: "500",
                                                              }}
                                                            > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                            </Form.Label>
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Select
                                                              value={accessoriesFormData[index].value}
                                                              onChange={(e) => handleAccessoriesOptionChange(e, index)}


                                                            >
                                                              <option value="0">None</option>
                                                              {item.material.map((item2, index2) => (
                                                                priceGen === 'oldvalue' ? (
                                                                  <option value={item2.oldvalue} key={index2}>
                                                                    {item2.label}
                                                                  </option>
                                                                ) : (
                                                                  <option value={item2.value} key={index2}>
                                                                    {item2.label}
                                                                  </option>
                                                                )
                                                              ))}

                                                            </Form.Select>
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={accessoriesFormData[index].qnty === 0 ? '' : accessoriesFormData[index].qnty}
                                                              onChange={(e) => handleAccessoriesChange(e, index, "qnty")}
                                                              placeholder="Qty"
                                                            />
                                                          </Form.Group>
                                                        </Col>

                                                        <Col sm={1}>

                                                        </Col>

                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              type="number"
                                                              value={accessoriesFormData[index].price}
                                                              // onChange={(e) => handleAccessoriesPriceChange(e, index, "price")}
                                                              placeholder="Price"
                                                              disabled={accessoriesFormData[index].value ? false : true}
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={2}>
                                                          <Form.Group>
                                                            <Form.Control
                                                              value={accessoriesFormData[index].remark}
                                                              onChange={(e) => handleAccessoriesRemarkChange(e, index, "remark")}
                                                              as="textarea" rows={1}
                                                              placeholder="Remark"
                                                            />
                                                          </Form.Group>
                                                        </Col>
                                                        <Col sm={1}>
                                                          {item.isUserAdded && (
                                                            <Button variant="danger" onClick={() => deleteUserAddedAccessories(index)}>
                                                              <i class="bi bi-x-circle-fill"></i>
                                                            </Button>
                                                          )}
                                                        </Col>
                                                      </Row>
                                                      : item.measurement == "length" ?
                                                        <Row className={`mx-1 my-3 ${isItemFilled(accessoriesFormData && accessoriesFormData[index]) ? 'selected-row' : ''}`}>
                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Label
                                                                style={{
                                                                  fontSize: 16,
                                                                  fontWeight: "500",
                                                                }}
                                                              > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                              </Form.Label>
                                                            </Form.Group>
                                                          </Col>
                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Select
                                                                value={accessoriesFormData[index].value}
                                                                onChange={(e) => handleAccessoriesOptionChange(e, index)}


                                                              >
                                                                <option value="0">None</option>
                                                                {item.material.map((item2, index2) => (
                                                                  priceGen === 'oldvalue' ? (
                                                                    <option value={item2.oldvalue} key={index2}>
                                                                      {item2.label}
                                                                    </option>
                                                                  ) : (
                                                                    <option value={item2.value} key={index2}>
                                                                      {item2.label}
                                                                    </option>
                                                                  )
                                                                ))}

                                                              </Form.Select>
                                                            </Form.Group>
                                                          </Col>
                                                          <Col sm={1}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                type="number"
                                                                value={accessoriesFormData[index].height === 0 ? '' : accessoriesFormData[index].height}
                                                                onChange={(e) => handleAccessoriesChange(e, index, "height")}
                                                                placeholder="Length"
                                                              />
                                                            </Form.Group>
                                                          </Col>
                                                          <Col sm={1}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                type="number"
                                                                value={accessoriesFormData[index].width === 0 ? '' : accessoriesFormData[index].width}
                                                                onChange={(e) => handleAccessoriesChange(e, index, "width")}
                                                                placeholder="Width"
                                                              />
                                                            </Form.Group>
                                                          </Col>


                                                          <Col sm={1}>

                                                          </Col>

                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                type="number"
                                                                value={accessoriesFormData[index].price}
                                                                // onChange={(e) => handleAccessoriesPriceChange(e, index, "price")}
                                                                placeholder="Price"
                                                                disabled={accessoriesFormData[index].value ? false : true}
                                                              />
                                                            </Form.Group>
                                                          </Col>
                                                          <Col sm={2}>
                                                            <Form.Group>
                                                              <Form.Control
                                                                value={accessoriesFormData[index].remark}
                                                                onChange={(e) => handleAccessoriesRemarkChange(e, index, "remark")}
                                                                as="textarea" rows={1}
                                                                placeholder="Remark"
                                                              />
                                                            </Form.Group>
                                                          </Col>
                                                          <Col sm={1}>
                                                            {item.isUserAdded && (
                                                              <Button variant="danger" onClick={() => deleteUserAddedAccessories(index)}>
                                                                <i class="bi bi-x-circle-fill"></i>
                                                              </Button>
                                                            )}
                                                          </Col>
                                                        </Row> : item.measurement == "rft" ?
                                                          <Row className={`mx-1 my-3 ${isItemFilled(accessoriesFormData && accessoriesFormData[index]) ? 'selected-row' : ''}`}>
                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Label
                                                                  style={{
                                                                    fontSize: 16,
                                                                    fontWeight: "500",
                                                                  }}
                                                                > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                </Form.Label>
                                                              </Form.Group>
                                                            </Col>
                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Select
                                                                  value={accessoriesFormData[index].value}
                                                                  onChange={(e) => handleAccessoriesOptionChange(e, index)}


                                                                >
                                                                  <option value="0">None</option>
                                                                  {item.material.map((item2, index2) => (
                                                                    priceGen === 'oldvalue' ? (
                                                                      <option value={item2.oldvalue} key={index2}>
                                                                        {item2.label}
                                                                      </option>
                                                                    ) : (
                                                                      <option value={item2.value} key={index2}>
                                                                        {item2.label}
                                                                      </option>
                                                                    )
                                                                  ))}

                                                                </Form.Select>
                                                              </Form.Group>
                                                            </Col>
                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={accessoriesFormData[index].rft === 0 ? '' : accessoriesFormData[index].rft}
                                                                  onChange={(e) => handleAccessoriesChange(e, index, "rft")}
                                                                  placeholder="RFT"
                                                                />
                                                              </Form.Group>
                                                            </Col>

                                                            <Col sm={1}>

                                                            </Col>

                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  type="number"
                                                                  value={accessoriesFormData[index].price}
                                                                  // onChange={(e) => handleAccessoriesPriceChange(e, index, "price")}
                                                                  placeholder="Price"
                                                                  disabled={accessoriesFormData[index].value ? false : true}
                                                                />
                                                              </Form.Group>
                                                            </Col>
                                                            <Col sm={2}>
                                                              <Form.Group>
                                                                <Form.Control
                                                                  value={accessoriesFormData[index].remark}
                                                                  onChange={(e) => handleAccessoriesRemarkChange(e, index, "remark")}
                                                                  as="textarea" rows={1}
                                                                  placeholder="Remark"
                                                                />
                                                              </Form.Group>
                                                            </Col>
                                                            <Col sm={1}>
                                                              {item.isUserAdded && (
                                                                <Button variant="danger" onClick={() => deleteUserAddedAccessories(index)}>
                                                                  <i class="bi bi-x-circle-fill"></i>
                                                                </Button>
                                                              )}
                                                            </Col>
                                                          </Row> : item.measurement == "depth" ?
                                                            <Row className={`mx-1 my-3 ${isItemFilled(accessoriesFormData && accessoriesFormData[index]) ? 'selected-row' : ''}`}>
                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Label
                                                                    style={{
                                                                      fontSize: 16,
                                                                      fontWeight: "500",
                                                                    }}
                                                                  > <h6 style={{ color: '#e85d13' }}>{item.name}</h6>
                                                                  </Form.Label>
                                                                </Form.Group>
                                                              </Col>
                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Select
                                                                    value={accessoriesFormData[index].value}
                                                                    onChange={(e) => handleAccessoriesOptionChange(e, index)}


                                                                  >
                                                                    <option value="0">None</option>
                                                                    {item.material.map((item2, index2) => (
                                                                      priceGen === 'oldvalue' ? (
                                                                        <option value={item2.oldvalue} key={index2}>
                                                                          {item2.label}
                                                                        </option>
                                                                      ) : (
                                                                        <option value={item2.value} key={index2}>
                                                                          {item2.label}
                                                                        </option>
                                                                      )
                                                                    ))}

                                                                  </Form.Select>
                                                                </Form.Group>
                                                              </Col>
                                                              <Col sm={1}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    type="number"
                                                                    value={accessoriesFormData[index].width === 0 ? '' : accessoriesFormData[index].width}
                                                                    onChange={(e) => handleAccessoriesChange(e, index, "width")}
                                                                    placeholder="Length"
                                                                  />
                                                                </Form.Group>
                                                              </Col>
                                                              <Col sm={1}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    type="number"
                                                                    value={accessoriesFormData[index].height === 0 ? '' : accessoriesFormData[index].height}
                                                                    onChange={(e) => handleAccessoriesChange(e, index, "height")}
                                                                    placeholder="Height"
                                                                  />
                                                                </Form.Group>
                                                              </Col>


                                                              <Col sm={1}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    type="number"
                                                                    value={accessoriesFormData[index].depth === 0 ? '' : accessoriesFormData[index].depth}
                                                                    onChange={(e) => handleAccessoriesChange(e, index, "depth")}
                                                                    placeholder="Depth"
                                                                  />
                                                                </Form.Group>
                                                              </Col>

                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    type="number"
                                                                    value={accessoriesFormData[index].price}
                                                                    // onChange={(e) => handleAccessoriesPriceChange(e, index, "price")}
                                                                    placeholder="Price"
                                                                    disabled={accessoriesFormData[index].value ? false : true}
                                                                  />
                                                                </Form.Group>
                                                              </Col>
                                                              <Col sm={2}>
                                                                <Form.Group>
                                                                  <Form.Control
                                                                    value={accessoriesFormData[index].remark}
                                                                    onChange={(e) => handleAccessoriesRemarkChange(e, index, "remark")}
                                                                    as="textarea" rows={1}
                                                                    placeholder="Remark"
                                                                  />
                                                                </Form.Group>
                                                              </Col>
                                                              <Col sm={1}>
                                                                {item.isUserAdded && (
                                                                  <Button variant="danger" onClick={() => deleteUserAddedAccessories(index)}>
                                                                    <i class="bi bi-x-circle-fill"></i>
                                                                  </Button>
                                                                )}
                                                              </Col>
                                                            </Row> : null
                                              )
                                            ))}


                                        </Col>
                                      </Row>

                                      <Row>
                                        <Col>

                                          <Row className="mx-1 my-3">
                                            <Col sm={2}>
                                              <Form.Group >
                                                <Form.Control
                                                  value={extraItemName}
                                                  onChange={(e) => setExtraItemName(e.target.value)}
                                                  type="text"
                                                  placeholder="Item Name"
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col sm={2}>
                                              <Form.Group >
                                                <Form.Control
                                                  value={extraItemMaterialName}
                                                  onChange={(e) => setExtraItemMaterialName(e.target.value)}
                                                  type="text"
                                                  placeholder="Material Name"
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col sm={2}>
                                              <Form.Group >
                                                <Form.Control
                                                  value={extraItemMaterialValue}
                                                  onChange={(e) => setExtraItemMaterialValue(e.target.value)}
                                                  type="number"
                                                  placeholder="Material Value"
                                                />
                                              </Form.Group>
                                            </Col>

                                            <Col sm={3}>
                                              <Form.Select value={extraItemMeasure} onChange={(e) => { setExtraItemMeasure(e.currentTarget.value) }} >
                                                <option>Select Measurement Type</option>
                                                <option value="area">Area</option>
                                                <option value="width">Width &  Height</option>
                                                <option value="rft">RFT</option>
                                                <option value="qty">Quantity</option>
                                                <option value="length">Width & Length</option>
                                                <option value="selection">Selection</option>
                                              </Form.Select>
                                            </Col>
                                            <Col sm={1}>
                                              <Form.Check
                                                inline
                                                label="Wood"
                                                name="Wood"
                                                type="checkbox"
                                                id="inline-checkbox-1"
                                                checked={isChecked}
                                                onChange={handleCheckboxChange}
                                              />
                                            </Col>
                                            <Col sm={2}>
                                              <Button onClick={addNewAccessoriesItem}>Add Item</Button>
                                            </Col>
                                          </Row>





                                        </Col>

                                      </Row>

                                    </Form.Group>


                                  </Form>
                                </Col>
                              </Row>
                              <Row style={{
                                // marginBottom: '50px',
                                marginLeft: '1px',
                                padding: '20px',
                                borderRadius: '15px',
                                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                                backgroundColor: '#ffffff', // Light background color


                              }} >
                                <Col style={{
                                  display: 'flex',
                                  justifyContent: 'flex-start',
                                  gap: '12px',
                                }}>
                                  <Button className="buttonDesign" style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold" }} onClick={handleCategoryGoBack} >Go Back</Button>
                                  {Boolean(restored) && (
                        <Button style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold", backgroundColor: '#fee2e2', color: '#dc2626', border: '1px solid #fca5a5' }} onClick={handleDiscardDraft} disabled={isDiscarding}>{isDiscarding ? "Discarding..." : "Discard Draft"}</Button>
                      )}
                                  <Button className="buttonDesign" style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold" }} disabled={isSaving} onClick={() => saveAccessoriesData()}  >{isSaving ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Saving...</> : "Save"}</Button>
                                </Col>
                                <Col className="col-sm-3">

                                </Col>
                                <Col className="col-sm-2"><h4>Total Price</h4></Col>
                                <Col className="col-sm-2">
                                  {/* <h4>
                        Rs:- {roomTypePrice}

                      </h4> */}
                                  <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{roomTypePrice}</h4></span>
                                </Col>
                              </Row>

                            </Row> : roomTypeModal == 'ExtraItems' ?
                              <Row className="p-2"
                                style={{
                                  marginBottom: '50px',
                                  marginLeft: '20px',
                                  padding: '20px',
                                  borderRadius: '15px',
                                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                                  backgroundColor: '#ffffff', // Light background color

                                }}>
                                {!priceGen ? (
                                  <h4>Extra items -- New Value</h4>
                                ) : (
                                  <h4>Extra items -- {priceGen === 'value' ? 'New Value' : 'Old Value'}</h4>
                                )}



                                <Row style={{
                                  marginBottom: '50px',
                                  marginLeft: '1px',
                                  padding: '20px',
                                  borderRadius: '15px',
                                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                                  backgroundColor: '#ffffff', // Light background color

                                }}>
                                  <Col style={{ minHeight: 380, maxHeight: 480 }}>

                                    {materialFields.map((field, index) => (
                                      <Row key={index} className="mx-1 my-1">
                                        <Col sm={2}> <Form.Group
                                          className="mb-3"

                                        >

                                          <Form.Label style={{
                                            fontSize: 16,
                                            fontWeight: "500",
                                          }}>Extra items</Form.Label>
                                        </Form.Group></Col>
                                        <Col sm={3}> <Form.Group
                                          className="mb-3"

                                        >

                                          <Form.Control
                                            type="text"
                                            value={field.label}
                                            onChange={(e) => handleFieldChange(e.target.value, index, 'label')}
                                            placeholder="Item Name"
                                            required={false}
                                          />
                                        </Form.Group></Col>
                                        <Col sm={3}> <Form.Group
                                          className="mb-3"

                                        >

                                          <Form.Control
                                            type="number"
                                            value={field.value}
                                            onChange={(e) => handleFieldChange(e.target.value, index, 'value')}
                                            placeholder="Item Price"
                                            required={false}
                                          />
                                        </Form.Group>
                                        </Col>
                                        <Col sm={3}> <Form.Group
                                          className="mb-3"

                                        >

                                          <Form.Control
                                            as="textarea" rows={1}
                                            value={field.remark}
                                            onChange={(e) => handleFieldChange(e.target.value, index, 'remark')}
                                            placeholder="Remark"
                                            required={false}
                                          />

                                        </Form.Group>
                                        </Col>
                                        <Col sm={1}> <Button variant="danger" onClick={() => handleRemoveField(index)} >
                                          <i class="bi bi-x-circle-fill"></i>
                                        </Button></Col>
                                        <Col>

                                        </Col>
                                      </Row>
                                    ))}
                                    <Col><Button variant="success" onClick={handleAddField} > Add options <i class="bi bi-plus-circle-fill"></i> </Button></Col>

                                  </Col>
                                </Row>


                                <Row style={{
                                  // marginBottom: '50px',
                                  marginLeft: '1px',
                                  padding: '20px',
                                  borderRadius: '15px',
                                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                                  backgroundColor: '#ffffff', // Light background color


                                }} >
                                  <Col style={{
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    gap: '12px',
                                  }}>
                                    <Button className="buttonDesign" style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold" }} onClick={handleCategoryGoBack} >Go Back</Button>
                                    {Boolean(restored) && (
                        <Button style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold", backgroundColor: '#fee2e2', color: '#dc2626', border: '1px solid #fca5a5' }} onClick={handleDiscardDraft} disabled={isDiscarding}>{isDiscarding ? "Discarding..." : "Discard Draft"}</Button>
                      )}
                                    <Button className="buttonDesign" style={{ fontSize: 13, minWidth: '9vw', fontWeight: "bold" }} disabled={isSaving} onClick={() => saveExtraItemsData()}  >{isSaving ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Saving...</> : "Save"}</Button>
                                  </Col>
                                  <Col className="col-sm-3">

                                  </Col>
                                  <Col className="col-sm-2"><h4>Total Price</h4></Col>
                                  <Col className="col-sm-2">
                                    {/* <h4>
                        Rs:- {roomTypePrice}

                      </h4> */}
                                    <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h5>Rs:-  </h5><h4 style={{ color: '#e85d13' }}>{totalValues()}</h4></span>
                                  </Col>
                                </Row>

                              </Row> : null}




            {/* Bedroom modal */}

          </Row>

        </Col>
      </Row>

    </Container>
  );
}